import * as React from 'react';
import React__default from 'react';

function _extends$3T() {
  _extends$3T = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3T.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;

  var loggedTypeFailures = {};

  var has = has$1;

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

function _extends$3S() { _extends$3S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }

var _ref$3S = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.593-9.407-20.987-21-21zm10.8 12.5a3.31 3.31 0 013.162 2.956 3.527 3.527 0 01-.647 2.62 2.968 2.968 0 01-1.968 1.177l-6.942.971v3.416L32.843 37.3A3.402 3.402 0 0129.703 42a3.402 3.402 0 01-3.154-2.096L24 33.78l-2.55 6.123A3.4 3.4 0 0118.295 42a3.404 3.404 0 01-3.143-4.693l4.442-10.667v-3.416l-6.941-.972a3.012 3.012 0 01-2.144-1.433 3.576 3.576 0 01-.473-2.358 3.315 3.315 0 013.162-2.961c.128 0 .255.01.382.026l8.09 1.133h4.657l8.093-1.133c.126-.016.254-.025.38-.026zm-21.602 2a1.338 1.338 0 00-1.182 1.236c-.055.359.015.725.199 1.037.151.265.413.447.713.498l7.805 1.093a1 1 0 01.861.99v4.485a.998.998 0 01-.077.385L17 38.072a1.402 1.402 0 00.762 1.821 1.437 1.437 0 001.84-.757l3.475-8.34a1 1 0 01.803-.609l.12-.007a1 1 0 01.922.616l3.473 8.34a1.431 1.431 0 001.842.757c.344-.14.618-.414.76-.759.143-.339.144-.721.001-1.06l-4.516-10.85a.998.998 0 01-.077-.385v-4.485a1 1 0 01.86-.99l7.805-1.092a.984.984 0 00.648-.4 1.52 1.52 0 00.264-1.135 1.31 1.31 0 00-1.31-1.227l-8.137 1.14c-.045.006-.092.01-.138.01H21.6c-.046 0-.093-.004-.139-.01l-8.141-1.14a1.15 1.15 0 00-.123-.01zM24 5a4.75 4.75 0 110 9.5A4.75 4.75 0 0124 5zm0 2a2.75 2.75 0 100 5.5A2.75 2.75 0 0024 7z"
});

function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3S);
}

function _extends$3R() { _extends$3R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }

var _ref$3R = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.16 8.36a37.623 37.623 0 01-16.518-7.075L23.999.75l-.64.535A37.623 37.623 0 016.84 8.36L6 8.496v19.735c0 6.442 11.352 17.634 17.796 18.977l.204.042.204-.042C30.648 45.865 42 34.672 42 28.23V8.496l-.84-.136zM40 28.23c0 5.422-10.37 15.609-16 16.974C18.37 43.839 8 33.652 8 28.23V10.189a39.698 39.698 0 0016-6.868 39.698 39.698 0 0016 6.868v18.042zM20.999 11.818a2.72 2.72 0 001.356 2.312l3.099 1.816-1.593 2.784-4.35-2.547-1.011 1.726 4.727 2.768v14.381h-1.32v2h4.64v-2h-1.32v-14.69l4.64-8.106L25.04 9.45a2.759 2.759 0 00-1.399-.393A2.706 2.706 0 0021 11.817zm2.679-.76a.677.677 0 01.345.115l3.122 1.818-.698 1.22-3.09-1.812a.72.72 0 01.314-1.34h.007z",
  fill: "currentColor"
});

function SvgAccidentInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3R({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3R);
}

function _extends$3Q() { _extends$3Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }

var _ref$3Q = /*#__PURE__*/React.createElement("path", {
  d: "M37 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5H13a5.006 5.006 0 01-5-5v-3H6v-2h2v-5H6v-2h2v-5H6v-2h2v-5H6v-2h2v-5H6V9h2V6a5.006 5.006 0 015-5zm0 2H13a3.003 3.003 0 00-3 3v3h2v2h-2v5h2v2h-2v5h2v2h-2v5h2v2h-2v5h2v2h-2v3a3.003 3.003 0 003 3h24a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zM25.749 22.429c3.076.034 6.088.877 8.735 2.443l.681.377-.198.752a9.22 9.22 0 01-9.218 6.928A9.218 9.218 0 0116.533 26l-.198-.752.68-.377a17.542 17.542 0 018.734-2.443zm0 2c-2.46.023-4.879.645-7.046 1.811a7.184 7.184 0 007.046 4.689 7.186 7.186 0 007.048-4.689 15.18 15.18 0 00-7.048-1.811zM25.75 10.5a4.75 4.75 0 110 9.5 4.75 4.75 0 010-9.5zm0 2a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5z"
});

function SvgAddressBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3Q);
}

function _extends$3P() { _extends$3P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }

var _ref$3P = /*#__PURE__*/React.createElement("path", {
  d: "M43.811 4.235A7.36 7.36 0 0038.51 2c-2.01 0-3.894.793-5.304 2.235l-2.04 2.088-2.036-2.084A7.37 7.37 0 0023.823 2c-2.01 0-3.894.793-5.303 2.235-1.407 1.44-2.183 3.362-2.183 5.413 0 2.05.776 3.973 2.183 5.413L31.166 28 43.81 15.065c2.919-2.986 2.919-7.844 0-10.83zM22.17 15.945h5.573l1.327-2.005 2.967 5.97 2.627-3.965h5.503l-9 9.206-8.997-9.206zm20.238-2.293l-.28.287h-8.518l-1.328 2.005-2.966-5.97-2.628 3.965h-6.48l-.283-.29a5.685 5.685 0 01-1.61-4.001c0-1.518.573-2.938 1.61-4a5.411 5.411 0 013.899-1.642 5.42 5.42 0 013.902 1.646l3.44 3.52 3.444-3.524a5.411 5.411 0 013.9-1.642 5.41 5.41 0 013.898 1.642c2.157 2.207 2.157 5.797 0 8.004zM14.123 46l-5.387-2.254 1.257-4.134a11.872 11.872 0 01-1.703-1.725l-4.17 1.031L2 33.748l3.665-2.253a12.13 12.13 0 010-2.484L2 26.758l2.116-5.17 4.164 1.027c.519-.648 1.1-1.237 1.737-1.76L9 16.642l5.11-2.142 2.562 4.26-1.69 1.039-1.681-2.795-1.978.83.926 3.835-.54.394a9.855 9.855 0 00-2.233 2.262l-.39.547-3.792-.935-.819 2.003 3.336 2.05-.105.665a10.14 10.14 0 000 3.196l.107.664-3.337 2.052.821 2.002 3.795-.939.39.545a9.914 9.914 0 002.236 2.256l.576.419-1.138 3.744 2.156.902 1.832-3.054s.194-.341.22-.38c.292.098.638.157.638.157a9.692 9.692 0 003.152.002l.656-.107 2.031 3.38 1.979-.83-.93-3.845.541-.394a9.856 9.856 0 002.232-2.256l.389-.545 3.8.937.819-2.002-2.775-1.705 1.027-1.709 4.223 2.594-2.116 5.171-4.174-1.029a11.883 11.883 0 01-1.733 1.754l1.02 4.22-5.11 2.142-2.232-3.713c-.819.086-1.638.086-2.45 0L14.124 46zm3.45-8.798c-3.816 0-6.921-3.141-6.921-7 0-3.86 3.105-7 6.921-7 3.816 0 6.921 3.14 6.921 7 0 3.859-3.105 7-6.921 7zm0-12c-2.726 0-4.944 2.243-4.944 5 0 2.756 2.218 5 4.944 5s4.944-2.243 4.944-5-2.218-5-4.944-5z"
});

function SvgAdministrationHealthcare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3P({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3P);
}

function _extends$3O() { _extends$3O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }

var _ref$3O = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 20c7.452.008 13.492 6.048 13.5 13.5C29 40.956 22.956 47 15.5 47S2 40.956 2 33.5 8.044 20 15.5 20zM40 1a3.003 3.003 0 013 3v9a2.994 2.994 0 01-2.624 2.962L46 21.586V42a3.003 3.003 0 01-3 3H27v-2h16c.552 0 1-.448 1-1V23H34V13H16c-.552 0-1 .448-1 1v4h-2v-4a3.003 3.003 0 013-3V4a3.003 3.003 0 013-3zM15.5 22C9.149 22 4 27.149 4 33.5S9.149 45 15.5 45c6.348-.007 11.493-5.152 11.5-11.5C27 27.149 21.851 22 15.5 22zM12 26v2h2.5v-2h2v2H19v-2h2v2h2v2h-2v2.5h2v2h-2V37h2v2h-2v2h-2v-2h-2.5v2h-2v-2H12v2h-2v-2H8v-2h2v-2.5H8v-2h2V30H8v-2h2v-2h2zm2.5 8.5H12V37h2.5v-2.5zm4.5 0h-2.5V37H19v-2.5zM14.5 30H12v2.5h2.5V30zm4.5 0h-2.5v2.5H19V30zm17-15.586V21h6.586L36 14.414zM40 3H19c-.552 0-1 .448-1 1v7h17.414l3 3H40c.552 0 1-.448 1-1V4c0-.552-.448-1-1-1z"
});

function SvgAllergyBedding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3O);
}

function _extends$3N() { _extends$3N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }

var _ref$3N = /*#__PURE__*/React.createElement("path", {
  d: "M23 3.5a4 4 0 014 4v3h15a4.685 4.685 0 015 5v19a4.685 4.685 0 01-5 5h-2.525a5.497 5.497 0 01-10.95 0h-9.05a5.497 5.497 0 01-10.95 0H6a4.69 4.69 0 01-5-5.011v-9.403L15.586 10.5H19v-3a4 4 0 014-4zm-9 32a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm20 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm10.226-22.225A2.706 2.706 0 0042 12.5H16.414L3 25.914v8.575A2.687 2.687 0 006 37.5h2.714a5.494 5.494 0 0110.573 0h9.427a5.494 5.494 0 0110.573 0H42a2.706 2.706 0 003-3v-19a2.706 2.706 0 00-.774-2.225zM27 17.5v5h5v2h-5v5h-2v-5h-5v-2h5v-5h2zm-4-12a2 2 0 00-2 2v3h4v-3a2 2 0 00-2-2z"
});

function SvgAmbulance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3N);
}

function _extends$3M() { _extends$3M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }

var _ref$3M = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.395.164 1.666.706 3.04 1.293l.487.208 3.774 1.614a3.6 3.6 0 012.173 3.64c3.513-1.561 9.087-4.046 9.165-4.08a3.594 3.594 0 013.03 6.517c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-1.118-.222-6.54-1.431-7.404-1.624H4.003V31.003l7.16-.013c.523-.252 1.702-.818 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.064.014 6.3 1.406 7.467 1.638 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.203 3.57 3.57 0 01-1.271-.284l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062l-3.523-1.507-.488-.209a691.49 691.49 0 00-3.275-1.393 6.04 6.04 0 00-4.624.013zM29.746 1c1.397 0 2.783.242 4.097.714l-.678 1.882a10.107 10.107 0 00-3.42-.596h-.011a10.051 10.051 0 00-9.228 6.007l6.499.006-.002 2-7.136-.007c-.268 1.32-.267 2.68.004 4l7.128.007-.002 2-6.484-.006c1.609 3.648 5.223 6 9.21 5.993h.013a10.107 10.107 0 003.367-.573l.665 1.886c-1.295.456-2.659.689-4.032.688h-.014a12.026 12.026 0 01-11.355-7.996l-4.364-.005.002-2 3.84.004a12.062 12.062 0 01-.178-2.016c.004-.665.064-1.328.178-1.984L14.009 11l.002-2 4.353.005A12.026 12.026 0 0129.734.999z"
});

function SvgAokBonusProgram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3M);
}

function _extends$3L() { _extends$3L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }

var _ref$3L = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.609c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.002l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211-5.582-.001v9.998l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052 1.042-.386 12.423-5.631 16.72-7.62a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.944-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM13.003 9.105l5.373 5.373-1.414 1.414-2.948-2.948a9.977 9.977 0 008.561 9.95 9.924 9.924 0 008.49-2.818l1.41 1.418a11.907 11.907 0 01-8.44 3.504c-.583 0-1.167-.042-1.745-.126A11.972 11.972 0 0112.016 12.92l-2.973 2.972-1.414-1.414 5.374-5.373zm2.438-4.512a11.991 11.991 0 0120.55 8.475l2.97-2.971 1.415 1.414-5.373 5.373-5.374-5.373 1.414-1.414 2.95 2.949a10.006 10.006 0 00-8.667-9.957 9.905 9.905 0 00-8.457 2.905z"
});

function SvgAokHealthAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3L);
}

function _extends$3K() { _extends$3K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }

var _ref$3K = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.29c.395.164 1.666.706 3.04 1.293l.487.208 3.774 1.614a3.6 3.6 0 012.173 3.64c3.513-1.561 9.087-4.046 9.165-4.08a3.594 3.594 0 013.03 6.518c-.638.294-15.541 7.19-16.87 7.682a9.132 9.132 0 01-3.166.515 17.351 17.351 0 01-3.366-.377c-1.118-.222-6.54-1.43-7.404-1.624H4.003V30.683l7.16-.013c.523-.252 1.702-.818 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.859c-1.169.52-2.326 1.076-2.84 1.323l-.444.211H6.003v9.997l5.45.024c.035.008 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.425 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.163 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.203 3.57 3.57 0 01-1.271-.284l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062l-3.523-1.507-.488-.208a691.48 691.48 0 00-3.275-1.394 6.04 6.04 0 00-4.624.014zm15.374-29.83l1.02 1.721-6.144 3.64h12.884v17h-28v-17h12.884l-6.144-3.64 1.02-1.72 6.24 3.697 6.24-3.698zm-7.24 7.36h-11v13h11v-13zm13 0h-11v13h11v-13z"
});

function SvgAokPremiumProgram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3K);
}

function _extends$3J() { _extends$3J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }

var _ref$3J = /*#__PURE__*/React.createElement("path", {
  d: "M40.303 7.693c8.934 8.934 8.934 23.418 0 32.352-5.848 5.845-12.092 6.962-31.288 6.962-2.162 0-4.489-.015-6.998-.037l-.982-.01-.008-.98a751.038 751.038 0 01-.03-5.632v-1.307C1.027 19.72 2.24 13.4 7.95 7.694c8.934-8.934 23.419-8.935 32.353-.001zM9.363 9.107C3.824 14.643 2.83 20.087 3.017 44.98c24.871.204 30.314-.792 35.873-6.348A20.878 20.878 0 109.363 9.107zm22.888 4.077a6.39 6.39 0 012.837 10.731L24.493 34.507 13.891 23.913a6.39 6.39 0 019.033-9.042l1.566 1.566 1.569-1.569a6.39 6.39 0 016.192-1.684zm-13.845 1.832a4.364 4.364 0 00-3.11 1.277 4.31 4.31 0 00.016 6.21l9.181 9.174 9.19-9.187a4.39 4.39 0 00-6.219-6.196l-2.974 2.973-2.972-2.97a4.37 4.37 0 00-3.112-1.281z"
});

function SvgAokRecommendation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3J);
}

function _extends$3I() { _extends$3I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }

var _ref$3I = /*#__PURE__*/React.createElement("path", {
  d: "M29.432 27.745a5.012 5.012 0 003.581 1.5 5.03 5.03 0 002.516-.672c2.221-1.283 2.423-3.352 3.645-7.914-2.955-.792-4.798-1.433-6.335-1.433-.827 0-1.566.186-2.341.633-2.09 1.207-2.904 3.604-2.307 5.724l-2.99 1.727v-7.206c2.149-.532 3.83-2.453 3.83-4.878 0-2.56-1.705-3.788-5.031-7.114-3.34 3.34-5.03 4.549-5.03 7.114a5.04 5.04 0 003.82 4.88v7.204l-2.989-1.726c.597-2.12-.216-4.517-2.306-5.724a4.482 4.482 0 00-2.341-.633c-1.538 0-3.381.641-6.336 1.433 1.222 4.562 1.424 6.63 3.646 7.914a5.024 5.024 0 002.515.671 5.014 5.014 0 003.581-1.499l4.23 2.443v3.532H12.446v2.41h23.101v-2.41H25.201v-3.532l4.231-2.444zm1.046-4.19a2.585 2.585 0 011.225-1.608c.387-.223.705-.31 1.137-.31.785 0 1.898.292 3.406.713-.753 2.914-1.036 3.624-1.922 4.135a2.62 2.62 0 01-1.31.349 2.592 2.592 0 01-2.27-1.308 2.658 2.658 0 01-.266-1.971zM17.25 25.527a2.593 2.593 0 01-2.269 1.307c-.462 0-.915-.12-1.31-.348-.886-.512-1.17-1.222-1.923-4.136 1.508-.42 2.622-.713 3.407-.713.43 0 .75.087 1.136.31a2.624 2.624 0 01.96 3.58zM24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.593-9.407-20.987-21-21zm0 8.494c.148.145.288.283.42.415l.376.377c1.473 1.492 1.825 2.06 1.825 2.94a2.623 2.623 0 01-2.62 2.62 2.623 2.623 0 01-2.621-2.62c0-1.023.473-1.624 2.62-3.732z"
});

function SvgAok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3I({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3I);
}

function _extends$3H() { _extends$3H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }

var _ref$3H = /*#__PURE__*/React.createElement("path", {
  d: "M32.344 29.585l8.709 8.708-3.819 3.819-8.712-8.705-1.417 1.417 10.129 10.122 6.652-6.653-10.125-10.125-1.417 1.417zM16.91 24.63l1.417-1.418-4.383-4.38 3.824-3.823 4.38 4.381 1.418-1.416-4.381-4.382 7.31-7.309-10.088-3.229L.75 18.712l6.656 6.657 5.122-5.12 4.382 4.38zM3.584 18.711L16.96 5.336l5.792 1.853L7.406 22.535l-3.822-3.823z"
});

var _ref2$6 = /*#__PURE__*/React.createElement("path", {
  d: "M46.644 11.27a1.518 1.518 0 00-1.85-.945c-.244.07-.465.203-.643.383l-4.26 4.26-2.292-.687-.7-2.308 4.257-4.26a1.497 1.497 0 00.407-1.389 1.52 1.52 0 00-.971-1.104 10.112 10.112 0 00-10.86 2.604 10.244 10.244 0 00-2.263 9.8L7.679 37.425l6.653 6.653L34.05 24.361a10.11 10.11 0 0012.594-13.09zm-3.765 9.199a8.114 8.114 0 01-8.722 1.803l-.611-.24-19.214 19.213-3.819-3.82 19.258-19.27-.217-.599a8.232 8.232 0 011.644-8.364 8.107 8.107 0 017.965-2.32l-4.531 4.533 1.362 4.487 4.468 1.34 4.529-4.53a8.144 8.144 0 01-2.112 7.767z"
});

function SvgApprenticeships(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3H({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3H, _ref2$6);
}

function _extends$3G() { _extends$3G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }

var _ref$3G = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 47H11a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h24a5.006 5.006 0 015 5v24h-2V6a3.003 3.003 0 00-3-3H11a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h11v2zm-9-33h20v2H13v-2zm0 7h20v2H13v-2zm20 7H13v2h20v-2zm-4.69 18.415c.378.376.889.587 1.422.585a2.002 2.002 0 001.417-.583L44.5 33.21l-1.416-1.418-13.36 13.203-5.316-5.207L23 41.214l5.31 5.201z",
  fill: "currentColor"
});

function SvgApprovalWait(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3G({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3G);
}

function _extends$3F() { _extends$3F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }

var _ref$3F = /*#__PURE__*/React.createElement("path", {
  d: "M38.94 7.645L9.647 36.941V14.353h-2v25.002a1 1 0 001 1l25-.002v-2l-22.585.001L40.353 9.06 38.94 7.645z"
});

function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3F);
}

function _extends$3E() { _extends$3E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }

var _ref$3E = /*#__PURE__*/React.createElement("path", {
  d: "M38.354 36.94L9.06 7.645 7.646 9.06 36.94 38.354l-22.585-.001v2l25 .002a1 1 0 001-1V14.353h-2V36.94z"
});

function SvgArrowDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3E);
}

function _extends$3D() { _extends$3D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }

var _ref$3D = /*#__PURE__*/React.createElement("path", {
  d: "M25.002 43.007L25 1.579h-2l.002 41.428L7.029 27.035 5.615 28.45l17.68 17.679a1 1 0 001.414 0l17.676-17.679-1.414-1.414L25 43.007z"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3D);
}

function _extends$3C() { _extends$3C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }

var _ref$3C = /*#__PURE__*/React.createElement("path", {
  d: "M20.966 7.03l-1.414-1.415-17.68 17.68a1 1 0 000 1.414l17.68 17.676 1.414-1.414L4.993 25 46.421 25v-2l-41.428.002L20.966 7.029z"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3C);
}

function _extends$3B() { _extends$3B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }

var _ref$3B = /*#__PURE__*/React.createElement("path", {
  d: "M28.45 5.615L27.034 7.03 43.007 23 1.579 23v2h41.428L27.035 40.97l1.414 1.415 17.679-17.679a1 1 0 000-1.414L28.449 5.615z"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3B);
}

function _extends$3A() { _extends$3A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }

var _ref$3A = /*#__PURE__*/React.createElement("path", {
  d: "M40.354 38.94L11.06 9.646l22.585.001v-2l-25-.001a1 1 0 00-1 1v25.002h2v-22.59L38.94 40.355l1.415-1.414z"
});

function SvgArrowUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3A);
}

function _extends$3z() { _extends$3z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }

var _ref$3z = /*#__PURE__*/React.createElement("path", {
  d: "M39.354 7.646l-25 .001v2l22.585-.001L7.646 38.94l1.415 1.414L38.354 11.06v22.587h2V8.646a1 1 0 00-1-1z"
});

function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3z);
}

function _extends$3y() { _extends$3y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }

var _ref$3y = /*#__PURE__*/React.createElement("path", {
  d: "M23.292 1.866L5.615 19.546 7.03 20.96 23 4.987 23 46.415h2V4.987L40.97 20.96l1.415-1.414-17.679-17.68a1.03 1.03 0 00-1.414 0z"
});

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3y);
}

function _extends$3x() { _extends$3x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }

var _ref$3x = /*#__PURE__*/React.createElement("path", {
  d: "M16.723 2.204a2.056 2.056 0 011.949.09c1.733 1.048 3.82 2.467 4.57 4.15a28.072 28.072 0 011.16 3.527l9.871 11.595 10.89-18.089 1.711 1.028-10.934 18.16 9.852 2.787-.544 1.916-10.719-3.032-15.141 8.097c.972 5.834 2.098 12.782 2.174 13.247l-1.97.32c-.016-.094-.778-4.802-1.595-9.755l-.18-1.09-.06-.363-.12-.724a698.48 698.48 0 00-1.357-7.983c-9.467 1.85-13.56-3.477-14.907-5.922a2.048 2.048 0 01.793-2.759l5.545-3.138 4.065-4.875 4.173-1.9-.388-3.59.015-.12a2.056 2.056 0 011.147-1.577zm17.901 29.295V36h4.5v2h-4.5v4.5h-2V38h-4.5v-2h4.5v-4.5h2zM17.578 3.994l.511 4.714-5.071 2.308L9.01 15.82 3.15 19.138c1.146 2.196 4.831 6.918 13.685 4.786l1.002-.242.21 1.009c.16.772.54 2.97.993 5.667l13.811-7.386-10.265-12.059-.058-.222a28.898 28.898 0 00-1.108-3.436c-.593-1.328-2.993-2.78-3.781-3.256l-.061-.005z"
});

function SvgAssistanceDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3x);
}

function _extends$3w() { _extends$3w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }

var _ref$3w = /*#__PURE__*/React.createElement("path", {
  d: "M24.195 17l7.967 4.608a3.503 3.503 0 01-3.527 6.053l-3.707-2.166v4.451l3.637 2.375a2.987 2.987 0 011.36 2.51V43.5a3.51 3.51 0 01-7.02 0v-6.188L20.906 36h-5.013l-1.998 1.312V43.5a3.51 3.51 0 01-7.02 0V34.83a2.986 2.986 0 011.36-2.51l3.655-2.387v-4.42L8.184 27.66a3.503 3.503 0 01-3.527-6.053L12.623 17h11.572zm-11.55 14.832l-3.311 2.163a.993.993 0 00-.454.836V43.5a1.504 1.504 0 003.009 0v-7.266l2.537-1.665-1.78-2.737zm11.522.008l-1.78 2.738 2.523 1.656V43.5a1.504 1.504 0 003.01 0V34.83a.995.995 0 00-.453-.836l-3.3-2.155zM22.922 28h-9.026v2.079l2.55 3.92h3.926l2.55-3.92v-2.08zm.733-9H13.163l-7.5 4.339a1.496 1.496 0 00-.544 2.05 1.51 1.51 0 002.057.544l6.72-3.896V26h9.026v-3.995l6.724 3.93c.719.41 1.634.167 2.054-.546a1.5 1.5 0 00-.545-2.051L23.655 19zM34.379 6a8.575 8.575 0 0110.704-4.491l-.682 1.88A6.575 6.575 0 0036.653 6h4.255v2h-5.123a6.386 6.386 0 00-.042 3h5.165v2h-4.356a6.577 6.577 0 007.823 2.787l.67 1.885A8.586 8.586 0 0134.299 13h-3.391v-2h2.804a8.121 8.121 0 01.026-3h-2.83V6zM18.408 1a7 7 0 010 14 7.008 7.008 0 01-7-7 7 7 0 017-7zm0 2a5 5 0 100 10 5 5 0 000-10z"
});

function SvgBabyBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3w);
}

function _extends$3v() { _extends$3v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }

var _ref$3v = /*#__PURE__*/React.createElement("path", {
  d: "M30.284 17l7.967 4.608a3.481 3.481 0 011.63 2.132c.24.897.11 1.853-.359 2.654a3.519 3.519 0 01-4.794 1.267l-3.712-2.169v4.559l3.623 2.357a2.973 2.973 0 011.359 2.5v8.61a3.5 3.5 0 01-7 0v-6.14L26.892 36h-4.787L20 37.378v6.14a3.5 3.5 0 01-7 0v-8.61a2.973 2.973 0 011.36-2.5l3.622-2.357v-4.54l-3.712 2.15a3.517 3.517 0 01-4.794-1.266 3.497 3.497 0 011.271-4.787L18.713 17h11.571zM18.788 31.912l-3.34 2.173a.98.98 0 00-.449.823v8.61a1.5 1.5 0 003 0v-7.222l2.555-1.671-1.766-2.713zm11.421 0l-1.766 2.713 2.555 1.671v7.221a1.5 1.5 0 003 0v-8.61a.98.98 0 00-.45-.822l-3.339-2.173zM29.016 28H19.98v2.078L22.533 34h3.931l2.552-3.922V28zm.731-9H19.25l-7.502 4.34a1.496 1.496 0 00-.545 2.047 1.512 1.512 0 002.064.544l6.714-3.89V26h9.035v-3.993l6.718 3.925c.72.413 1.639.17 2.06-.546a1.497 1.497 0 00-.545-2.048L29.747 19zM21.82 1.533A7 7 0 1124.5 15a7.008 7.008 0 01-7-7 7 7 0 014.321-6.467zM24.5 3a5 5 0 100 10 5 5 0 000-10z"
});

function SvgBaby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3v);
}

function _extends$3u() { _extends$3u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }

var _ref$3u = /*#__PURE__*/React.createElement("path", {
  d: "M38 14.947C37.97 7.236 31.711 1 24 1S10.03 7.236 10 14.947c0 6.613 4.681 16.384 11.27 18.594l-1.752 5.827H23v7.633h2v-7.633h3.482l-1.751-5.827C33.319 31.33 38 21.56 38 14.947zM25.793 37.368h-3.586l1.024-3.404a8.283 8.283 0 001.538 0l1.024 3.404zM24 32.001c-6.508 0-12-10.475-12-17.054.03-6.606 5.393-11.946 12-11.946s11.97 5.34 12 11.946c0 6.58-5.492 17.054-12 17.054z"
});

function SvgBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3u);
}

function _extends$3t() { _extends$3t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }

var _ref$3t = /*#__PURE__*/React.createElement("path", {
  fill: "#293033",
  d: "M41.661 11.98L31.373 5.341A2.989 2.989 0 0130 2.821V1h-2v1.82a4.98 4.98 0 002.289 4.202l.924.596L22.37 26H13v-8h-2v8H5v-9.61c0-1.106.604-2.118 1.625-2.67l10.979-6.698A5.028 5.028 0 0020 2.754V1h-2v1.754c0 1.039-.55 2.02-1.438 2.561L5.629 11.987A4.994 4.994 0 003 16.389V35c0 1.654 1.346 3 3 3h6v6c0 1.654 1.346 3 3 3h17.88C34.6 47 36 45.654 36 44V18h-2v26c0 .552-.502 1-1.12 1H15c-.551 0-1-.448-1-1v-6h7c.883 0 1.67-.39 2.22-1h3.246A4.54 4.54 0 0031 32.466c0-1.943-1.26-3.605-3-4.243V27.5a2.993 2.993 0 00-2.702-2.97l7.609-15.82 7.713 4.977c.898.517 1.349 1.283 1.38 2.313v31h2V15.97c-.052-1.735-.897-3.162-2.339-3.99zM5 34.764V28h3.382L5 34.764zM6.618 36l4-8h2.764l-4 8H6.618zM14 36h-2.382l4-8h2.764l-4 8H14zm8-6v5c0 .552-.449 1-1 1h-4.382l4-8H22v2zm4-2.5V30s.78-.03 1.036 0C28.18 30.132 29 31.275 29 32.466A2.537 2.537 0 0126.466 35H24v-7.5a1.001 1.001 0 012 0z"
});

function SvgBandage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3t);
}

function _extends$3s() { _extends$3s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }

var _ref$3s = /*#__PURE__*/React.createElement("path", {
  d: "M32 19.234V13c0-2.944-2.056-5-5-5h-2v2h2c1.822 0 3 1.178 3 3v32H6V13c0-1.822 1.178-3 3-3h2V8H9c-2.944 0-5 2.056-5 5v34h40V26.434l-12-7.2zM42 45H32V21.566l10 6V45zM15.5 23h-4v-4h4v4zm9 0h-4v-4h4v4zm-9 8h-4v-4h4v4zm9 0h-4v-4h4v4zm-9 8h-4v-4h4v4zm5-4h4v4h-4v-4zM16.292 9.989H14v-2h1.64a6.076 6.076 0 01-.068-.864c0-.294.028-.58.069-.864H14v-2h2.292A6.182 6.182 0 0121.744 1c.719 0 1.423.122 2.093.362l-.674 1.883a4.201 4.201 0 00-4.41 1.016h2.35v2h-3.435c-.06.28-.096.567-.096.864 0 .297.035.585.096.864h3.436v2h-2.352a4.196 4.196 0 004.393 1.023l.666 1.886a6.191 6.191 0 01-2.067.352 6.182 6.182 0 01-5.452-3.261z"
});

function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3s);
}

function _extends$3r() { _extends$3r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }

var _ref$3r = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44 18.6h-2.116V15a3.003 3.003 0 00-3-3H4a3.003 3.003 0 00-3 3v18a3.003 3.003 0 003 3h34.884a3.003 3.003 0 003-3v-3.6H44a3.003 3.003 0 003-3v-4.8a3.003 3.003 0 00-3-3zm1 7.8a1 1 0 01-1 1h-4.116V33a1 1 0 01-1 1H4a1 1 0 01-1-1V15a1 1 0 011-1h34.884a1 1 0 011 1v5.6H44a1 1 0 011 1v4.8zM22.773 16.156c.463.298.6.914.305 1.38L19.622 23H26.7l-5.4 8.537a.99.99 0 01-1.372.307 1.004 1.004 0 01-.305-1.381L23.08 25H16l5.4-8.538a.992.992 0 011.373-.306z",
  fill: "currentColor"
});

function SvgBatteryCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3r({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3r);
}

function _extends$3q() { _extends$3q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }

var _ref$3q = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5 35.003v-20H37V4.473a2.488 2.488 0 00-1.715-2.324 2.628 2.628 0 00-2.937.838l-2.252 2.816A5.017 5.017 0 0029 8.927v6.076h-1.5v20H26v11h14v-11h-1.5zM31 8.927c0-.681.232-1.342.657-1.874l2.253-2.816a.648.648 0 01.728-.195.488.488 0 01.362.481v10.48h-4V8.927zm5.5 8.076h-7v18h7v-18zm1.5 27H28v-7h10v7zm-30 2h14v-36H8v36zm2-34h10v32H10v-32z",
  fill: "currentColor"
});

function SvgBeautyLipstick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3q({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3q);
}

function _extends$3p() { _extends$3p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }

var _ref$3p = /*#__PURE__*/React.createElement("path", {
  d: "M38.53 24a8.493 8.493 0 11-1.296 16.89A22.05 22.05 0 0122.089 47c-9.717 0-18.504-6.622-20.891-15.746L1 30.502l.678-.377A42.667 42.667 0 0122.09 25c3.587.006 7.159.452 10.636 1.328A8.415 8.415 0 0138.53 24zm-16.44 3a40.85 40.85 0 00-18.75 4.499A19.73 19.73 0 0022.09 45a20.06 20.06 0 0012.916-4.78 8.349 8.349 0 01-3.681-12.164A41.833 41.833 0 0022.089 27zm18.9-.507A6.5 6.5 0 1038.53 39a6.542 6.542 0 006.477-6.5 6.5 6.5 0 00-4.018-6.007zM39.407 29v2.592H42v1.816h-2.592V36h-1.816v-2.592H35v-1.816h2.592V29h1.816zM22 1c5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.52-.006-9.994-4.48-10-10 0-5.523 4.477-10 10-10zm0 2a8.01 8.01 0 00-8 8 8 8 0 108-8z"
});

function SvgBecomeAMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3p);
}

function _extends$3o() { _extends$3o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }

var _ref$3o = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.248 21.25c-1.2 0-2.387.248-3.486.729l-6.659-12.73h-4.605v2h3.394l3.438 6.572-7.522 10.268-6.34-12.844h2.03v-2h-6.5v2h2.24l1.008 2.042-2.37 4.55a8.745 8.745 0 105.559 9.172h4.713l8.214-11.213 1.671 3.194a8.734 8.734 0 105.215-1.74zm-21.905-1.74l4.69 9.498h-2.596a8.756 8.756 0 00-3.786-6.25l1.692-3.249zm-4.947 9.498h5.02a6.745 6.745 0 00-2.7-4.456l-2.32 4.457zM9.748 36.75a6.75 6.75 0 112.197-13.126L8.938 29.4c-.178.341-.165.75.034 1.08l.377.53h7.065a6.755 6.755 0 01-6.666 5.74zm22.143-4.477a6.747 6.747 0 006.357 4.477 6.749 6.749 0 10-2.557-12.994l3.443 6.58-1.773.928-3.39-6.482a6.747 6.747 0 00-2.08 7.491z",
  fill: "currentColor"
});

function SvgBike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3o({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3o);
}

function _extends$3n() { _extends$3n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }

var _ref$3n = /*#__PURE__*/React.createElement("path", {
  d: "M9 20.334v2H3v14h34.346a2218.1 2218.1 0 003.275-2.783l.555-.473c1.574-1.342 3.099-2.65 3.543-3.053a.936.936 0 00.28-.712.91.91 0 00-.317-.688c-.467-.384-5.659-5.031-7.064-6.29H33v-2h5.382l.285.254c1.89 1.693 6.882 6.16 7.286 6.492a2.966 2.966 0 01.111 4.424c-1.034.94-7.433 6.361-7.705 6.592l-.28.237H1v-18h8zm8.832-10.668l.932 1.77c-.34.145-.582.453-.642.818a.952.952 0 00.227.765c.374.341.897.345 1.944.325.226-.005.46-.01.707-.01 5.523 0 10 4.477 10 10 0 5.429-4.327 9.848-9.72 9.996l-.28.004a10.005 10.005 0 01-5.973-18.028l1.196 1.604A8.007 8.007 0 1021 15.334c-.232 0-.454.005-.665.009A4.345 4.345 0 0117 14.497a2.913 2.913 0 01-.862-2.498 3.054 3.054 0 011.694-2.333zm6.852 15.59l1.632 1.156A6.538 6.538 0 0121 29.334a6.538 6.538 0 01-5.316-2.922l1.632-1.156A4.66 4.66 0 0021 27.334a4.66 4.66 0 003.684-2.078zm-.184-5.047a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-7-.125a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
});

function SvgBirthPreparationCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3n);
}

function _extends$3m() { _extends$3m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }

var _ref$3m = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.583 30a6.01 6.01 0 005.917 5 6 6 0 004.206-10.278.985.985 0 01-.345-.697c.013-.29.141-.563.357-.757A6 6 0 1035.583 18H12.416a6 6 0 10-10.123 5.278c.206.175.33.426.346.696-.013.29-.141.564-.357.758A6 6 0 1012.416 30h23.167zm.917-2h-25a1 1 0 00-1 1 4 4 0 11-6.81-2.847c.6-.572.942-1.362.949-2.191a2.936 2.936 0 00-.948-2.113A4 4 0 1110.5 19a1 1 0 001 1h25a1 1 0 001-1 4 4 0 116.81 2.847 3.064 3.064 0 00-.949 2.19 2.94 2.94 0 00.948 2.114A4 4 0 1137.498 29a1 1 0 00-1-1z",
  fill: "currentColor"
});

function SvgBone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3m({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3m);
}

function _extends$3l() { _extends$3l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

var _ref$3l = /*#__PURE__*/React.createElement("path", {
  d: "M6.298 14.55a3.564 3.564 0 011.587 2.34c.416 1.704 1.02 4.386 1.342 5.833a3.893 3.893 0 013.524 1.8c.657.884 1.12 1.535 1.484 2.049.438.616.726 1.023 1.035 1.382.342.261.698.504 1.067.726 1.56.998 3.918 2.507 5.193 4.592 2.445 3.994.045 12.634-.058 13l-.205.728H11.05l-.06-1.45c-.073-1.964-.137-3.66-1.366-5.406a18.355 18.355 0 00-2.204-2.383 18.192 18.192 0 01-3.979-4.924c-1.254-2.566-2.257-12.466-2.368-13.586-.12-1.22-.437-4.462 2.433-5.149a3.564 3.564 0 012.79.448zm38.196-.448c2.87.687 2.552 3.928 2.432 5.149-.055.56-.332 3.312-.753 6.246l-.104.707c-.407 2.715-.931 5.448-1.51 6.633a18.227 18.227 0 01-3.979 4.924 18.388 18.388 0 00-2.204 2.383c-1.229 1.746-1.293 3.44-1.367 5.402L36.949 47H26.732l-.205-.728c-.103-.366-2.502-9.006-.057-13 1.275-2.085 3.633-3.594 5.193-4.592.372-.224.731-.47 1.075-.735.299-.348.586-.753 1.02-1.366.366-.515.83-1.168 1.49-2.057a3.904 3.904 0 013.524-1.8 346.1 346.1 0 011.343-5.832 3.566 3.566 0 014.378-2.788zM3.972 16.048c-.41.098-1.175.28-.908 3.007.42 4.256 1.344 11.204 2.175 12.904a16.393 16.393 0 003.575 4.366 19.828 19.828 0 012.448 2.668A10.334 10.334 0 0112.972 45h6.766c.66-2.693 1.585-8.236.087-10.684-1.036-1.692-3.16-3.052-4.566-3.952a7.18 7.18 0 01-1.507-1.107c-.368-.43-.679-.866-1.147-1.528-.359-.504-.813-1.144-1.46-2.013-.868-1.169-1.761-1.17-2.306-.78a1.64 1.64 0 00-.2 2.352c1.4 2.03 3.7 5.444 3.7 5.444L10.68 33.85c-.001-.001-2.294-3.403-3.688-5.427a3.636 3.636 0 01.371-4.86 357.814 357.814 0 00-1.423-6.198 1.559 1.559 0 00-1.97-1.317zm38.769.205c-.379.253-.628.66-.681 1.112a367.969 367.969 0 00-1.424 6.197 3.636 3.636 0 01.372 4.86c-.31.45-.664.968-1.028 1.502l-.273.402-.275.403c-1.092 1.608-2.112 3.12-2.113 3.121l-1.658-1.118s1.11-1.646 2.257-3.332l.275-.405c.413-.605.819-1.2 1.168-1.707a1.64 1.64 0 00-.199-2.352c-.544-.39-1.437-.389-2.307.78a97.838 97.838 0 00-1.463 2.02c-.467.659-.776 1.093-1.143 1.52a7.18 7.18 0 01-1.507 1.108c-1.405.9-3.53 2.26-4.566 3.952-1.498 2.448-.574 7.99.086 10.684h6.767a10.334 10.334 0 011.71-6.006 19.828 19.828 0 012.448-2.67 16.419 16.419 0 003.575-4.365c.834-1.707 1.757-8.652 2.174-12.904.267-2.726-.497-2.909-.907-3.007a1.559 1.559 0 00-1.288.205zM24.006 1c.645 0 1.23.378 1.497.964l2.502 5.309 5.577.85a1.67 1.67 0 011.29 1.024l.049.139a1.722 1.722 0 01-.398 1.707l-4.073 4.155.96 5.873a1.711 1.711 0 01-.641 1.63 1.663 1.663 0 01-1.784.145L24 20.05l-4.977 2.742c-.24.137-.51.208-.786.208-.363 0-.716-.121-1.003-.343a1.681 1.681 0 01-.644-1.63l.96-5.875-4.065-4.15a1.71 1.71 0 01-.405-1.712 1.667 1.667 0 011.334-1.162l5.589-.855 2.504-5.313a1.648 1.648 0 011.5-.96zm-.002 2.473L21.358 9.09l-6.042.924 4.37 4.462-1.017 6.229L24 17.767l5.333 2.937-1.018-6.233 4.373-4.462-6.037-.92-2.646-5.616z"
});

function SvgBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3l);
}

function _extends$3k() { _extends$3k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

var _ref$3k = /*#__PURE__*/React.createElement("path", {
  d: "M35 47l-11.5-6.62L12 47V6.134A5.074 5.074 0 0117 1h13a5.074 5.074 0 015 5.134V47zm-11.5-8.938L33 43.53V6.134a3.067 3.067 0 00-3-3.122H17a3.067 3.067 0 00-3 3.122V43.53l9.5-5.468z"
});

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3k);
}

function _extends$3j() { _extends$3j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

var _ref$3j = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 25.023C1 18.561 11.103 13.5 24 13.5s23 5.061 23 11.523v4.254a5.165 5.165 0 01-5.093 5.223H6.093A5.165 5.165 0 011 29.277v-4.254zM41.907 32.5A3.163 3.163 0 0045 29.277v-4.254c0-3.056-3.386-5.824-8.5-7.58v5.668h-2v-6.279a38.056 38.056 0 00-5.5-1.035v5.814h-2v-5.997a43.848 43.848 0 00-3-.114c-1.018 0-2.015.046-3 .114v5.997h-2v-5.814a37.58 37.58 0 00-6 1.175v6.14h-2v-5.498c-4.836 1.763-8 4.452-8 7.41v4.253A3.163 3.163 0 006.093 32.5h35.814z",
  fill: "currentColor"
});

function SvgBread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3j);
}

function _extends$3i() { _extends$3i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

var _ref$3i = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 1C36.607 1.11 46.891 11.394 47 24.112a22.72 22.72 0 01-22.763 22.89h-.126l-22.99-.122-.12-22.99A22.72 22.72 0 0123.889 1zm-.011 2h-.115A20.72 20.72 0 003.001 23.88l.11 21.01 21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12zm-.88 28.495a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm.001-18.5a6 6 0 016 6 6.303 6.303 0 01-5 6.262v4.238h-2v-6.052l.94-.057A4.276 4.276 0 0027 18.995a4 4 0 10-8 0h-2a6 6 0 016-6z"
});

function SvgBubbleQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3i);
}

function _extends$3h() { _extends$3h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

var _ref$3h = /*#__PURE__*/React.createElement("path", {
  d: "M41 43.5v2H7v-2h34zm-5-24v4h2.001a3.003 3.003 0 012.999 3v5.001a3.003 3.003 0 01-2.999 2.999H36v1.023a4.982 4.982 0 01-4.977 4.977H14.978A4.982 4.982 0 0110 35.523V19.5h26zm-2 2H12v14.023a2.98 2.98 0 002.978 2.977h16.045A2.98 2.98 0 0034 35.523V21.5zm4.001 4H36v7h2.001a1 1 0 00.999-.999V26.5a1 1 0 00-.999-1zm-16.34-23a9.731 9.731 0 01-.48 7.66c-1.634 3.493-.496 5.8-.174 6.34h-2.193a9.118 9.118 0 01.554-7.187 7.422 7.422 0 00.104-6.813zm4.844 0a9.731 9.731 0 01-.481 7.66c-1.633 3.493-.495 5.8-.173 6.34h-2.194a9.118 9.118 0 01.554-7.187 7.422 7.422 0 00.104-6.813z"
});

function SvgCafeteria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3h);
}

function _extends$3g() { _extends$3g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

var _ref$3g = /*#__PURE__*/React.createElement("path", {
  d: "M19 5v2H8.444A3.448 3.448 0 005 10.444v5.779h10v2H5v23.333A3.448 3.448 0 008.444 45h31.112A3.448 3.448 0 0043 41.556V18.223H33v-2h10v-5.779A3.448 3.448 0 0039.556 7H29V5h10.556A5.45 5.45 0 0145 10.444v31.112A5.45 5.45 0 0139.556 47H8.444A5.45 5.45 0 013 41.556V10.444A5.45 5.45 0 018.444 5H19zm-2.25 29.5v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm-21-8.5v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zM25 1v17.424l3.084-2.97 1.388 1.442-4.778 4.6c-.388.372-1 .372-1.388 0l-4.778-4.6 1.388-1.442L23 18.424V1h2z"
});

function SvgCalenderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3g);
}

function _extends$3f() { _extends$3f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

var _ref$3f = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 1v4h8.5V1h7v4h4.306A5.45 5.45 0 0145 10.444v31.112A5.45 5.45 0 0139.556 47H8.444A5.45 5.45 0 013 41.556V10.444A5.45 5.45 0 018.444 5h4.306V1h7zM43 18.223H5v23.333A3.448 3.448 0 008.444 45h31.112A3.448 3.448 0 0043 41.556V18.223zm-9.414 5.068l1.41 1.418-14.022 13.94c-.808.8-2.11.8-2.918 0l-5.053-5.023 1.41-1.418 5.053 5.022 14.12-13.939zM12.75 7H8.444A3.448 3.448 0 005 10.444v5.779h38v-5.779A3.448 3.448 0 0039.556 7H35.25v4h-7V7h-8.5v4h-7V7zm20.5-4h-3v6h3V3zm-15.5 0h-3v6h3V3z"
});

function SvgCalenderCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3f);
}

function _extends$3e() { _extends$3e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

var _ref$3e = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 1v4h8.5V1h7v4h4.306A5.45 5.45 0 0145 10.444v31.112A5.45 5.45 0 0139.556 47H8.444A5.45 5.45 0 013 41.556V10.444A5.45 5.45 0 018.444 5h4.306V1h7zM43 18.223H5v23.333A3.448 3.448 0 008.444 45h31.112A3.448 3.448 0 0043 41.556V18.223zm-23.763 4.775l.237.002c2.602 0 4.733 1.519 4.733 3.807a4.12 4.12 0 01-2.983 3.83c2.31.454 3.567 1.86 3.567 3.808 0 2.765-2.423 4.555-5.317 4.555A5.802 5.802 0 0114 35.488l2.423-1.27a3.354 3.354 0 003.185 2.29c1.346 0 2.468-.726 2.468-2.063 0-1.564-1.369-2.402-3.769-2.402h-.695v-2.221c2.49 0 3.836-.816 3.836-2.38 0-1.224-.964-1.858-2.177-1.858a3.53 3.53 0 00-3.073 1.836l-1.974-1.27a5.68 5.68 0 015.25-3.15zm12.263.229v15.637h-2.736V25.81h-2.266v-2.583H31.5zM12.75 7H8.444A3.448 3.448 0 005 10.444v5.779h38v-5.779A3.448 3.448 0 0039.556 7H35.25v4h-7V7h-8.5v4h-7V7zm20.5-4h-3v6h3V3zm-15.5 0h-3v6h3V3z"
});

function SvgCalenderDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3e);
}

function _extends$3d() { _extends$3d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

var _ref$3d = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 1v4h8.5V1h7v4h4.306A5.45 5.45 0 0145 10.444v31.112A5.45 5.45 0 0139.556 47H8.444A5.45 5.45 0 013 41.556V10.444A5.45 5.45 0 018.444 5h4.306V1h7zM43 18.222H5v23.334A3.448 3.448 0 008.444 45h31.112A3.448 3.448 0 0043 41.556V18.222zM16.75 34.5v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm-21-8.5v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm10.5 0v2h-6.5v-2h6.5zm-25-19H8.444A3.448 3.448 0 005 10.444v5.778h38v-5.778A3.448 3.448 0 0039.556 7H35.25v4h-7V7h-8.5v4h-7V7zm20.5-4h-3v6h3V3zm-15.5 0h-3v6h3V3z"
});

function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3d);
}

function _extends$3c() { _extends$3c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

var _ref$3c = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 5.997v36a3.003 3.003 0 003 3h16v2H8a5.006 5.006 0 01-5-5v-36a5.006 5.006 0 015-5h24a5.006 5.006 0 015 5v16h-2v-16a3.003 3.003 0 00-3-3H8a3.003 3.003 0 00-3 3zm25 8H10v2h20v-2zm-8 7H10v2h12v-2zm-12 7h8v2h-8v-2zm13 8.006c0-6.075 4.925-11 11-11 6.072.006 10.993 4.927 11 11 0 6.075-4.925 11-11 11s-11-4.925-11-11zm2 0a9 9 0 009 9 9.01 9.01 0 009-9 9 9 0 10-18 0zm9-1.415l2.793-2.793 1.414 1.414-2.793 2.793 2.793 2.793-1.414 1.414L34 37.416l-2.793 2.793-1.414-1.414 2.793-2.793-2.793-2.793 1.414-1.414L34 34.588z",
  fill: "currentColor"
});

function SvgCancellationForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3c);
}

function _extends$3b() { _extends$3b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

var _ref$3b = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.283 13.5l-2.586-7H11.29l-2.447 7H1v5.55l5.625 1.757v16.74a3.947 3.947 0 107.894 0V34.66H33.73v2.887a3.947 3.947 0 107.895 0V20.729L47 19.049V13.5h-7.717zM6.981 18.823L3 17.58V15.5h5.143l-1.162 3.324zm31.671 20.414c.603-.35.974-.994.972-1.69V20.193L35.304 8.5H12.71L8.624 20.184v17.363a1.947 1.947 0 103.895 0V32.66H35.73v4.887a1.947 1.947 0 002.922 1.69zM45 17.579l-3.773 1.18-1.205-3.26H45v2.08zm-9.5-.08h-23v2h23v-2zm-25 8.25a3.25 3.25 0 116.5 0 3.25 3.25 0 01-6.5 0zm2 0a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM34.25 29a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5zm0-2a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM19 28.5h10v2H19v-2z",
  fill: "currentColor"
});

function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3b({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3b);
}

function _extends$3a() { _extends$3a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

var _ref$3a = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.16 8.36a37.622 37.622 0 01-16.518-7.075L23.999.75l-.64.535A37.623 37.623 0 016.84 8.36L6 8.496v19.735c0 6.442 11.352 17.634 17.796 18.977l.204.042.204-.042C30.648 45.865 42 34.672 42 28.23V8.496l-.84-.136zM40 28.23c0 5.422-10.37 15.609-16 16.974C18.37 43.839 8 33.652 8 28.23V10.189A39.698 39.698 0 0024 3.32a39.698 39.698 0 0016 6.87v18.04zM16.82 10.686a4.53 4.53 0 016.4-.021l.776.777.775-.779a4.528 4.528 0 016.4-.001 4.533 4.533 0 01.307 6.074l-.18.206-1.498-1.326.154-.173a2.53 2.53 0 00-.2-3.37 2.59 2.59 0 00-3.566 0l-2.19 2.202-2.194-2.198a2.59 2.59 0 00-3.57-.003 2.558 2.558 0 000 3.59l7.142 6.953-1.395 1.433-7.152-6.964a4.53 4.53 0 01-.009-6.4zm12.3 10.022v1.88h-1.99v-1.88h-1.88v-1.99h1.88v-1.88h1.99v1.88H31v1.99h-1.88zm-5.303 5.53c.553.243 4.136 1.851 4.136 1.851a2.53 2.53 0 011.444 1.888l3.85-1.8.003-.001.738-.345a2.375 2.375 0 011.865-.096 2.478 2.478 0 011.424 1.336 2.583 2.583 0 01-1.181 3.353c-.904.44-8.825 4.284-9.581 4.578a5.395 5.395 0 01-1.956.336 9.794 9.794 0 01-1.999-.234c-.623-.129-3.504-.847-4.14-1.007H14v-9.018h4.295a43.32 43.32 0 011.635-.817 4.79 4.79 0 013.887-.023zm11.355 3.377a.404.404 0 00-.32.018c-.016.008-6.285 2.941-6.78 3.165-.37.151-.77.207-1.167.162a2.425 2.425 0 01-.917-.21L22.3 31.09l.82-1.823 3.636 1.636c.081.024.164.042.248.055a.38.38 0 00.117-.03.5.5 0 00.272-.282.572.572 0 00-.257-.733l-.134-.06c-.653-.293-3.5-1.572-3.986-1.784a2.8 2.8 0 00-2.24.004 43.66 43.66 0 00-1.763.887l-.22.117H16v5.02l2.786.03c1.22.305 3.664.911 4.183 1.02a5.494 5.494 0 002.822-.011c.515-.2 5.92-2.806 9.427-4.51a.575.575 0 00.232-.741.491.491 0 00-.278-.27z",
  fill: "currentColor"
});

function SvgCareInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3a({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3a);
}

function _extends$39() { _extends$39 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

var _ref$39 = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 28.61c.395.164 1.666.706 3.04 1.293l.487.208 3.774 1.614a3.6 3.6 0 012.173 3.64c3.513-1.561 9.087-4.046 9.165-4.08a3.594 3.594 0 013.03 6.518c-.638.294-15.541 7.19-16.87 7.682a9.132 9.132 0 01-3.166.515 17.351 17.351 0 01-3.366-.377c-1.118-.222-6.54-1.43-7.404-1.624H4.003V30.003l7.16-.013c.523-.252 1.702-.818 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.859c-1.169.52-2.326 1.076-2.84 1.323l-.444.211H6.003V42l5.45.024c.064.014 6.3 1.406 7.467 1.638 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.163 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.203 3.57 3.57 0 01-1.271-.284l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062l-3.523-1.507-.488-.208c-1.461-.624-2.858-1.22-3.275-1.394a6.04 6.04 0 00-4.624.014zM25.762 4.005a6.875 6.875 0 0110.185 9.209l-.282.32-1.496-1.327.256-.29a4.876 4.876 0 00-7.25-6.498L24 8.602l-3.183-3.18a4.874 4.874 0 00-6.896 6.89l11.91 11.56-1.393 1.436-11.92-11.57a6.873 6.873 0 019.712-9.73l1.768 1.765zm6.253 9.005v4.682h4.682v2h-4.682v4.682h-2v-4.682h-4.682v-2h4.682V13.01h2z"
});

function SvgCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$39);
}

function _extends$38() { _extends$38 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

var _ref$38 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 27.002a1 1 0 01.967 1.256l-1.526 5.769 5.306 5.308-4.379 7.663-1.737-.992 3.622-6.337-3.679-3.681-.343.179A12.816 12.816 0 0124 37.502a12.825 12.825 0 01-6.074-1.512l-3.679 3.679 3.621 6.337-1.737.992-4.378-7.663 5.305-5.306-1.525-5.77a1 1 0 01.967-1.257h15zm-1.299 2H17.8l1.43 5.412a11.31 11.31 0 009.541.001l1.431-5.413zm2.283-9.375l.223.168 6 6-1.414 1.414-5.898-5.898a16.02 16.02 0 00-14.79 0l-5.898 5.898-1.414-1.414 6.223-6.168a18 18 0 0116.968 0zM24.001 1.002a7 7 0 017 7 7.007 7.007 0 01-7.001 7 7 7 0 010-14zM24 3.156A4.846 4.846 0 1024 12.848 4.846 4.846 0 0024 3.156z"
});

function SvgChaningRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$38({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$38);
}

function _extends$37() { _extends$37 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

var _ref$37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.862 9.73l-.005-.002.812-1.18L29.223 2.1l-.334-.137c-.055-.021-5.59-2.167-10.654.007l-.298.128-.166.277c-.502.84-.986 1.865-1.454 2.857l-.001.003-.008.015c-.415.88-.807 1.71-1.169 2.322l-.31.525.664 1.054-.02.013 4.795 7.525-4.927 7.941 4.977 3.264 3.54-5.57 3.55 5.569 4.974-3.263-4.935-7.953 4.415-6.945zm-6.823 3.065l2.6-4.191a23.38 23.38 0 012.22.551l-3.582 5.635-1.239-1.995zm.447-4.514a23.005 23.005 0 00-3.317-.111l1.693 2.728 1.624-2.617zm-7.361-2.194c.393-.834.799-1.693 1.198-2.402a13.6 13.6 0 018.49.02l1.76 3.294a26.147 26.147 0 00-6.55-.848 23.16 23.16 0 00-5.203.58l.215-.453.09-.19zm-.056 17.939l1.65 1.082 2.953-4.647-1.211-1.902-3.392 5.467zm9.936 1.083L17.639 8.839c.757-.2 1.526-.356 2.302-.466l9.714 15.653-1.65 1.083zM21.89 47.002a17.32 17.32 0 01-3.364-.377c-1.05-.208-5.88-1.284-7.192-1.576L11.121 45H4V31l7.16-.013.012-.007c.53-.255 1.7-.817 2.882-1.342a7.987 7.987 0 016.205-.031c.975.405 7.302 3.115 7.302 3.115a3.599 3.599 0 012.172 3.642c3.513-1.563 9.086-4.048 9.165-4.083a3.595 3.595 0 013.03 6.521l-.074.034c-1.296.6-15.5 7.17-16.797 7.65a9.122 9.122 0 01-3.166.515zm-15.89-4l5.45.024.205.045c1.09.243 6.214 1.385 7.262 1.593 1.79.443 3.665.425 5.447-.052 1.042-.386 12.422-5.633 16.72-7.622a1.595 1.595 0 10-1.356-2.889l-.927.413c-2.698 1.203-10.3 4.593-11.032 4.906-.548.21-1.14.281-1.722.206a3.568 3.568 0 01-1.3-.287l-6.516-2.794.788-1.838 6.47 2.775c.226.068.457.116.692.144a1.596 1.596 0 00.595-3.064l-.31-.133h-.002c-1.284-.55-6.132-2.624-6.974-2.976a6.04 6.04 0 00-4.624.014c-1.144.509-2.276 1.053-2.806 1.307l-.034.016-.444.211H6v10z",
  fill: "currentColor"
});

function SvgCharity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$37({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$37);
}

function _extends$36() { _extends$36 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

var _ref$36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5 42a3.003 3.003 0 01-3 3H9a3.003 3.003 0 01-3-3V6a3.003 3.003 0 013-3h17.5V1H9a5.006 5.006 0 00-5 5v36a5.006 5.006 0 005 5h17.5a5.006 5.006 0 005-5v-9h-2v9zM42.437 5.477a8.482 8.482 0 00-13.464 1.965.882.882 0 01-.07-.023.817.817 0 00-.074-.025 11.733 11.733 0 00-11.294 3.031c-3.293 3.298-3.625 6.776-3.519 19.065l.008.983.983.009c1.242.011 2.394.018 3.466.018 9.554 0 12.666-.562 15.605-3.504a11.665 11.665 0 003.357-7.084 79.02 79.02 0 004.183.088c.747 0 1.54-.005 2.38-.013l.983-.009.008-.982c.074-8.676-.166-11.138-2.552-13.52zm-9.774 20.105c-2.508 2.513-5.065 2.991-16.654 2.907-.075-11.55.41-14.115 2.941-16.65a9.707 9.707 0 1113.713 13.743zm4.798-7.677c1.475.084 3.306.102 5.535.09.04-7.697-.297-9.43-1.972-11.102a6.468 6.468 0 00-10.162 1.28 11.536 11.536 0 016.6 9.732zM17.75 41.5a2 2 0 100-4 2 2 0 000 4z",
  fill: "currentColor"
});

function SvgChatOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$36({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$36);
}

function _extends$35() { _extends$35 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

var _ref$35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.782 1a6.671 6.671 0 014.754 1.97 6.747 6.747 0 01-.002 9.52c-1.69 1.692-3.417 2.01-8.702 2.01-.568 0-1.177-.004-1.832-.01l-.983-.009-.008-.982c-.055-6.376.09-8.6 2.019-10.53A6.673 6.673 0 0137.78 1h.001zm-4.78 11.497c5.634.054 6.923-.225 8.117-1.42a4.746 4.746 0 000-6.694A4.683 4.683 0 0037.783 3h-.001a4.686 4.686 0 00-3.338 1.383c-1.208 1.208-1.464 2.492-1.44 8.114zM26.5 45a3.003 3.003 0 003-3v-6h2v6a5.006 5.006 0 01-5 5H9a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h17.5v2H9a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h17.5zm.5-28.5h7a2.002 2.002 0 012 2v12a2.002 2.002 0 01-2 2H18a2.002 2.002 0 01-2-2v-12a2.002 2.002 0 012-2h7v-4h2v4zm-9 2v12h16.002L34 18.5H18zm6 4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM22 26h8v2h-8v-2zm7.5-2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.75 41.5a2 2 0 100-4 2 2 0 000 4z",
  fill: "currentColor"
});

function SvgChatbot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$35({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$35);
}

function _extends$34() { _extends$34 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

var _ref$34 = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.697.014 22.986 10.303 23 23 0 12.703-10.297 23-23 23S1 36.703 1 24 11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21c11.593-.013 20.987-9.407 21-21 0-11.598-9.402-21-21-21zm11.211 12.041l1.41 1.418-16.236 16.14a2.245 2.245 0 01-3.156 0l-5.85-5.815 1.41-1.418 5.85 5.816a.24.24 0 00.336 0L35.21 15.04z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$34({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$34);
}

function _extends$33() { _extends$33 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

var _ref$33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.067 7.772h-1.392a10.996 10.996 0 00-19.35 0h-1.393a9.422 9.422 0 00-1 18.79V46h24.135V26.562a9.421 9.421 0 00-1-18.79zM13.932 44v-6h20.135v6H13.932zm20.135-19.385h1a7.422 7.422 0 100-14.844h-.553C34.837 10.817 35 11.906 35 13h-2a9 9 0 10-18 0h-2c0-1.094.163-2.183.485-3.229h-.553a7.422 7.422 0 100 14.844h1V36h20.135V24.615z"
});

function SvgChefHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$33({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$33);
}

function _extends$32() { _extends$32 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

var _ref$32 = /*#__PURE__*/React.createElement("path", {
  d: "M15.696 9.723l1.414 1.414a2.25 2.25 0 000 3.178c.69.69 1.378.717 3.676.692l.748-.005V15l.412-.03c8.835.022 15.984 7.196 15.975 16.032-.01 8.835-7.173 15.994-16.008 15.998-8.833-.01-15.99-7.168-16-16h2c.016 7.681 6.219 13.915 13.9 13.97 7.682.054 13.972-6.091 14.098-13.772.125-7.68-5.962-14.028-13.641-14.224l-.357.026-1.109.006c-2.37.024-3.796.035-5.108-1.278a4.25 4.25 0 010-6.006zm6.216 25.278a9.75 9.75 0 017.807 3.91l-1.613 1.18a7.75 7.75 0 00-12.387 0l-1.613-1.18A9.75 9.75 0 0121.912 35zm-6-9a2 2 0 110 4 2 2 0 010-4zm12 0a2 2 0 110 4 2 2 0 010-4zm-21.5-22a4.505 4.505 0 014.5 4.5v11.625a4.503 4.503 0 01-1.5 3.349V26a3 3 0 11-6 0v-2.527a4.501 4.501 0 01-1.5-3.348V8.501a4.505 4.505 0 014.5-4.5zm0 2a2.5 2.5 0 00-2.5 2.5v11.625c.003.817.404 1.58 1.074 2.048l.427.299V26a1 1 0 102 0v-3.53l.426-.297a2.504 2.504 0 001.074-2.048v-1.125h-2.5v-2h2.5v-2h-2.5v-2h2.5v-2h-2.5v-2h2.5v-.5a2.5 2.5 0 00-2.5-2.5zm28.971 0A8.575 8.575 0 0146.087 1.51l-.681 1.88a6.575 6.575 0 00-7.749 2.611h4.256v2H36.79a6.386 6.386 0 00-.043 3h5.166v2h-4.356a6.577 6.577 0 007.822 2.786l.67 1.885A8.586 8.586 0 0135.303 13h-3.39v-2h2.804a8.121 8.121 0 01.025-3h-2.83v-2z"
});

function SvgChildSicknessBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$32({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$32);
}

function _extends$31() { _extends$31 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

var _ref$31 = /*#__PURE__*/React.createElement("path", {
  d: "M16.302 1l1.414 1.415a3.01 3.01 0 00-.901 2.144 3.14 3.14 0 00.92 2.204c.945.943 1.91.978 4.835.952.443-.005.92-.009 1.44-.009 9.913.003 18.33 7.266 19.783 17.074 1.453 9.807-4.497 19.198-13.985 22.074-9.488 2.876-19.65-1.632-23.887-10.595-4.237-8.964-1.269-19.678 6.976-25.184l1.113 1.663C6.594 17.69 3.924 27.328 7.735 35.392c3.811 8.063 12.953 12.118 21.488 9.531 8.535-2.586 13.888-11.034 12.582-19.856-1.306-8.823-8.877-15.357-17.796-15.36-.512 0-.983.004-1.42.007-.364.004-.709.007-1.037.007-2.32 0-3.843-.159-5.228-1.543a5.15 5.15 0 01-1.51-3.618c0-1.338.536-2.62 1.488-3.56zm15.345 33.588l1.613 1.182a11.548 11.548 0 01-9.306 4.66 11.548 11.548 0 01-9.307-4.66l1.613-1.182a9.626 9.626 0 0015.387 0zM16.759 21.212a2 2 0 110 4 2 2 0 010-4zm14.5 0a2 2 0 110 4 2 2 0 010-4z"
});

function SvgChild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$31({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$31);
}

function _extends$30() { _extends$30 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

var _ref$30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 7.495a6.003 6.003 0 016-5.994 6.003 6.003 0 016 5.994v25.67a5.997 5.997 0 01-2.143 4.583v4.9a3.857 3.857 0 01-7.714 0v-4.9A5.996 5.996 0 0118 33.165V7.495zm7.857 29.24l.428-.298A4 4 0 0028 33.165v-2.664h-3.5v-2H28v-4.5h-3.5v-2H28v-4.25h-3.5v-2H28v-4.25h-3.5v-2H28V7.495a4 4 0 00-8 0v25.67a4 4 0 001.716 3.272l.427.298v5.913a1.857 1.857 0 003.714 0v-5.913z",
  fill: "currentColor"
});

function SvgClinicalThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$30({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$30);
}

function _extends$2$() { _extends$2$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

var _ref$2$ = /*#__PURE__*/React.createElement("path", {
  d: "M43.048 38.775H4.955a3.95 3.95 0 01-1.929-7.398l15.207-8.507.977 1.746-15.207 8.507a1.95 1.95 0 00.952 3.651h38.093a1.946 1.946 0 00.95-3.645L21.81 20.743l.952-.936c3.358-3.3 3.947-4.098 3.947-5.336a3.246 3.246 0 10-6.492 0h-2a5.246 5.246 0 1110.492 0c0 1.908-.902 3.128-3.597 5.824l19.862 11.088a3.947 3.947 0 01-1.926 7.392z"
});

function SvgCloakroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2$);
}

function _extends$2_() { _extends$2_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

var _ref$2_ = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.592-9.408-20.987-21-21zm1 6v14.426l7.004 4.085-1.008 1.728L23 24.574V9h2z"
});

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2_);
}

function _extends$2Z() { _extends$2Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

var _ref$2Z = /*#__PURE__*/React.createElement("path", {
  d: "M19 20l5.25 5.277-1.433 1.413-2.81-2.826V44.5h-2.014V23.864l-2.81 2.826-1.433-1.413L19 20zm11.007 0v20.636l2.81-2.826 1.433 1.413L29 44.5l-5.25-5.277 1.433-1.413 2.81 2.826V20h2.014zM19.23 3.403a11.627 11.627 0 0111.476 3.232 7.83 7.83 0 012.832-.532 8.045 8.045 0 018.063 8.009l-.002.141A9.302 9.302 0 0137.619 32h-3.297v-2h3.297a7.303 7.303 0 002.882-14.046l-1.028-.431.11-1.108c.01-.097.017-.199.017-.303a6.043 6.043 0 00-6.064-6.01 5.897 5.897 0 00-2.358.5l-1.008.438-.727-.823a9.624 9.624 0 00-16.62 4.53l-.24 1.257-1.511-.031a8.064 8.064 0 00-5.685 2.354A7.906 7.906 0 003 21.986a8.509 8.509 0 002.452 6.065 6.452 6.452 0 004.66 1.897h3.567v2h-3.57a8.394 8.394 0 01-6.059-2.47A10.524 10.524 0 011 21.987a9.897 9.897 0 012.98-7.082 10.069 10.069 0 016.96-2.93 11.627 11.627 0 018.289-8.571z"
});

function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2Z);
}

function _extends$2Y() { _extends$2Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

var _ref$2Y = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.5 45a3.003 3.003 0 003-3v-6.5h2V42a5.006 5.006 0 01-5 5H9a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h5v2H9a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h17.5zM25.347 3.059a6.39 6.39 0 015.49 5.5l-1.366-1.36-1.42 1.414 3.85 3.836 3.849-3.836-1.42-1.415-1.462 1.458A8.407 8.407 0 0018.503 3.51l1.434 1.401a6.354 6.354 0 015.41-1.852zM41 9h-4v2h4a1 1 0 011 1v12a1 1 0 01-1 1H20a1 1 0 01-1-1v-6h-2v6a3.003 3.003 0 003 3h9.5v3h-5v2h12v-2h-5v-3H41a3.003 3.003 0 003-3V12a3.003 3.003 0 00-3-3zm-24.866 1.091l-1.465 1.46-1.419-1.415L17.1 6.3l3.848 3.836-1.42 1.414-1.366-1.361a6.398 6.398 0 0010.856 3.7l1.415 1.419a8.48 8.48 0 01-5.948 2.442 8.394 8.394 0 01-8.35-7.659zM19.75 39.5a2 2 0 11-4 0 2 2 0 014 0z",
  fill: "currentColor"
});

function SvgCoBrowsing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2Y);
}

function _extends$2X() { _extends$2X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

var _ref$2X = /*#__PURE__*/React.createElement("path", {
  d: "M45 1v23H33.982v10.981a8.394 8.394 0 01-.413 2.42 5.62 5.62 0 01-.44 1.042l-.43.802c-.204.358-.43.703-.675 1.034a4.295 4.295 0 00-1.042 2.221V47h-15v-4.5a4.363 4.363 0 00-1.077-2.253 10.928 10.928 0 01-.682-1.026l-.388-.695a5.522 5.522 0 01-.52-1.231 8.86 8.86 0 01-.333-2.314V24H3V1h42zM16.67 17.998c-.924 0-1.676.744-1.688 1.668v15.315c.009.605.097 1.206.262 1.788.08.273.194.536.337.783l.388.694c.171.288.359.566.56.834a5.965 5.965 0 011.453 3.42V45h11v-2.5a5.915 5.915 0 011.41-3.377c.197-.265.379-.54.545-.825l.431-.802c.118-.214.214-.44.286-.673a6.487 6.487 0 00.328-1.842V24H20.36v2.33c0 .482.62.903 1.63 1.552 1.685 1.083 3.993 2.565 3.993 6.118v1h-2v-1c0-2.46-1.494-3.42-3.075-4.436-1.253-.804-2.548-1.635-2.548-3.234v-6.664a1.689 1.689 0 00-1.688-1.668zM43 3H5v19h7.982v-2.334a3.689 3.689 0 017.377 0V22H43V3zM21.24 9A7.076 7.076 0 0130 5.415l-.685 1.88A5.032 5.032 0 0023.599 9h2.46v2h-3.392a4.96 4.96 0 000 2h3.392v2H23.6a5.037 5.037 0 005.694 1.713l.677 1.883c-.76.269-1.56.406-2.366.404a7.062 7.062 0 01-6.364-4H18.5v-2h2.13a6.235 6.235 0 010-2H18.5V9z"
});

function SvgCoPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2X);
}

function _extends$2W() { _extends$2W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

var _ref$2W = /*#__PURE__*/React.createElement("path", {
  d: "M24 1a23 23 0 1023 23A23.026 23.026 0 0024 1zm0 44a21 21 0 1121-21 21.025 21.025 0 01-21 21z"
});

var _ref2$5 = /*#__PURE__*/React.createElement("path", {
  d: "M25 6h-2v4h2V6zM25 38h-2v4h2v-4zM10 23H6v2h4v-2zM42 23h-4v2h4v-2zM24 26a2 2 0 100-4 2 2 0 000 4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.565 11.089L19.656 19.22a1 1 0 00-.435.435l-8.132 15.91a1.001 1.001 0 001.346 1.345l15.909-8.132a1 1 0 00.435-.435l8.132-15.91a1.001 1.001 0 00-1.346-1.345zm-8.42 16.056l-12.869 6.579 6.579-12.87 12.869-6.578-6.578 12.87z"
});

function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2W({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2W, _ref2$5, _ref3);
}

function _extends$2V() { _extends$2V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

var _ref$2V = /*#__PURE__*/React.createElement("path", {
  d: "M42 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5H6a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5zM23 25H3v17a3.003 3.003 0 003 3h17V25zm22 0H25v20h17a3.003 3.003 0 003-3V25zm-28.457 5.043l1.414 1.414L14.414 35l3.543 3.543-1.414 1.414L13 36.414l-3.543 3.543-1.414-1.414L11.586 35l-3.543-3.543 1.414-1.414L13 33.586l3.543-3.543zM41 36v2H29v-2h12zm0-4v2H29v-2h12zm1-29H25v20h20V6a3.003 3.003 0 00-3-3zM23 3H6a3.003 3.003 0 00-3 3v17h20V3zm-9 4v5h5v2h-5v5h-2v-5H7v-2h5V7h2zm27.001 5v2H29v-2h12.001z"
});

function SvgContributions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2V);
}

function _extends$2U() { _extends$2U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

var _ref$2U = /*#__PURE__*/React.createElement("path", {
  d: "M29.387 1.64l1.453.344-.87 1.212a4.472 4.472 0 001.888 6.745l1.038.442-.563.977a4.425 4.425 0 00-.618 2.229 4.498 4.498 0 004.493 4.493 4.414 4.414 0 002.227-.618l.979-.565.441 1.04a4.42 4.42 0 005.698 2.44l1.188-.443.153 1.26A22.88 22.88 0 0124.082 47a23.001 23.001 0 115.305-45.36zm-5.305 1.361c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21c0-.446-.019-.914-.057-1.413a6.444 6.444 0 01-6.525-2.94 6.252 6.252 0 01-2.292.434 6.5 6.5 0 01-6.493-6.493c0-.784.147-1.561.434-2.291a6.484 6.484 0 01-3.03-5.493c0-.855.17-1.7.503-2.488a20.52 20.52 0 00-3.54-.316zm-7 26a4 4 0 110 8 4 4 0 010-8zm15-4a5 5 0 110 10 5 5 0 010-10zm-15 6a2 2 0 100 4 2 2 0 000-4zm15-4a3 3 0 100 6 3 3 0 000-6zm-17-16a6 6 0 016 6 6.007 6.007 0 01-6 6 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z"
});

function SvgCookies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2U);
}

function _extends$2T() { _extends$2T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

var _ref$2T = /*#__PURE__*/React.createElement("path", {
  d: "M6.298 14.55a3.564 3.564 0 011.587 2.34c.416 1.704 1.02 4.386 1.342 5.833a3.893 3.893 0 013.524 1.8c.657.884 1.12 1.535 1.484 2.049.438.616.726 1.023 1.035 1.382.342.261.698.504 1.067.726 1.56.998 3.918 2.507 5.193 4.592 2.445 3.994.045 12.634-.058 13l-.205.728H11.05l-.06-1.45c-.073-1.964-.137-3.66-1.366-5.406a18.355 18.355 0 00-2.204-2.383 18.192 18.192 0 01-3.979-4.924c-1.254-2.566-2.257-12.466-2.368-13.586-.12-1.22-.437-4.462 2.433-5.149a3.564 3.564 0 012.79.448zm38.196-.448c2.87.687 2.552 3.928 2.432 5.149-.055.56-.332 3.312-.753 6.246l-.104.707c-.407 2.715-.931 5.448-1.51 6.633a18.227 18.227 0 01-3.979 4.924 18.388 18.388 0 00-2.204 2.383c-1.229 1.746-1.293 3.44-1.367 5.402L36.949 47H26.732l-.205-.728c-.103-.366-2.502-9.006-.057-13 1.275-2.085 3.633-3.594 5.193-4.592.372-.224.731-.47 1.075-.735.299-.348.586-.753 1.02-1.366.366-.515.83-1.168 1.49-2.057a3.904 3.904 0 013.524-1.8 346.1 346.1 0 011.343-5.832 3.566 3.566 0 014.378-2.788zM3.972 16.048c-.41.098-1.175.28-.908 3.007.42 4.256 1.344 11.204 2.175 12.904a16.393 16.393 0 003.575 4.366 19.828 19.828 0 012.448 2.668A10.334 10.334 0 0112.972 45h6.766c.66-2.693 1.585-8.236.087-10.684-1.036-1.692-3.16-3.052-4.566-3.952a7.18 7.18 0 01-1.507-1.107c-.368-.43-.679-.866-1.147-1.528-.359-.504-.813-1.144-1.46-2.013-.868-1.169-1.761-1.17-2.306-.78a1.64 1.64 0 00-.2 2.352c1.4 2.03 3.7 5.444 3.7 5.444L10.68 33.85c-.001-.001-2.294-3.403-3.688-5.427a3.636 3.636 0 01.371-4.86 357.814 357.814 0 00-1.423-6.198 1.559 1.559 0 00-1.97-1.317zm38.769.205c-.379.253-.628.66-.681 1.112a367.969 367.969 0 00-1.424 6.197 3.636 3.636 0 01.372 4.86c-.31.45-.664.968-1.028 1.502l-.273.402-.275.403c-1.092 1.608-2.112 3.12-2.113 3.121l-1.658-1.118s1.11-1.646 2.257-3.332l.275-.405c.413-.605.819-1.2 1.168-1.707a1.64 1.64 0 00-.199-2.352c-.544-.39-1.437-.389-2.307.78a97.838 97.838 0 00-1.463 2.02c-.467.659-.776 1.093-1.143 1.52a7.18 7.18 0 01-1.507 1.108c-1.405.9-3.53 2.26-4.566 3.952-1.498 2.448-.574 7.99.086 10.684h6.767a10.334 10.334 0 011.71-6.006 19.828 19.828 0 012.448-2.67 16.419 16.419 0 003.575-4.365c.834-1.707 1.757-8.652 2.174-12.904.267-2.726-.497-2.909-.907-3.007a1.559 1.559 0 00-1.288.205zM27 1a2.002 2.002 0 012 2v3h4a2.002 2.002 0 012 2v11a2.002 2.002 0 01-2 2H15a2.002 2.002 0 01-2-2V8a2.002 2.002 0 012-2h4V3a2.002 2.002 0 012-2zm6 12H15v6h18.001v-6zm0-5H15v3h18V8zm-6-5h-6v3h6V3z"
});

function SvgCorporateClients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2T);
}

function _extends$2S() { _extends$2S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

var _ref$2S = /*#__PURE__*/React.createElement("path", {
  d: "M19.76 29.61c.974.406 7.3 3.115 7.3 3.115a3.6 3.6 0 012.174 3.64c3.293-1.464 8.398-3.739 9.087-4.046l.066-.03.012-.005a3.594 3.594 0 013.03 6.518c-.639.295-15.542 7.191-16.871 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.365-.376c-.672-.133-2.892-.622-4.747-1.033l-.602-.134c-.973-.215-1.767-.393-2.055-.457H3.5V31.003l7.16-.013c.524-.252 1.703-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.17.52-2.326 1.077-2.84 1.324l-.444.211H5.5V43l5.45.024c.036.007 1.937.432 3.836.851l.517.114c1.369.302 2.647.58 3.114.673 1.791.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318a3038.9 3038.9 0 006.472-2.985 1.595 1.595 0 00-1.355-2.888c-.467.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.27-.283l-6.516-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.623.013zM21.5 1a3.975 3.975 0 013.762 3.597c.447 2.735.767 5.802 1.076 8.768.158 1.512.315 3.018.487 4.471a5.414 5.414 0 01-1.24 4.404 5.306 5.306 0 01-3.084 1.669l-.001 3.091h-2l.001-3.09a5.175 5.175 0 01-4.082-3.41H14.5V27h-2v-6.5h-2.08a4.916 4.916 0 01-1.977-9.418 5.159 5.159 0 018.745-2.518c.161-1.347.34-2.69.548-3.966A3.974 3.974 0 0121.5 1zm0 2c-1.02 0-1.634.965-1.79 1.92-.33 2.02-.587 4.221-.816 6.341a4.897 4.897 0 01-.468 8.873 3.262 3.262 0 003.073 1.866 3.437 3.437 0 002.59-1.088 3.52 3.52 0 00.75-2.84 326.83 326.83 0 01-.49-4.5c-.307-2.938-.623-5.975-1.06-8.652C23.132 3.964 22.519 3 21.5 3zm-8 6a3.176 3.176 0 00-3.165 2.91l-.063.68-.656.189a2.917 2.917 0 00.804 5.721h6.16a2.917 2.917 0 00.804-5.721l-.655-.19-.064-.678A3.176 3.176 0 0013.5 9zm24-7v3.149a4.95 4.95 0 011.737.701l2.213-2.213 1.414 1.414-2.215 2.215c.347.527.59 1.116.714 1.734H44.5v2h-3.11a4.968 4.968 0 01-.735 1.742l2.209 2.209-1.414 1.414-2.212-2.212a5.002 5.002 0 01-1.738.741V18h-2v-3.106a5.004 5.004 0 01-1.738-.741l-2.212 2.212-1.414-1.414 2.209-2.21A4.968 4.968 0 0131.61 11H28.5V9h3.136a4.967 4.967 0 01.715-1.735L30.136 5.05l1.414-1.414 2.213 2.213a4.954 4.954 0 011.737-.701V1.999h2zm-1 5a3.003 3.003 0 00-2.978 2.819c-.003.06-.01.12-.019.18 0 .75.284 1.472.795 2.021a3.03 3.03 0 004.404 0c.51-.55.795-1.27.798-2.02a1.383 1.383 0 01-.023-.177A3.005 3.005 0 0036.5 6.999z"
});

function SvgCure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2S);
}

function _extends$2R() { _extends$2R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

var _ref$2R = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 29a34.864 34.864 0 0116.566 4.125l.684.377-.198.752A17.686 17.686 0 0118.25 47 17.686 17.686 0 011.198 34.254L1 33.502l.684-.377A34.864 34.864 0 0118.25 29zm0 2A33.03 33.03 0 003.364 34.5a15.802 15.802 0 0029.772 0A33.03 33.03 0 0018.25 31zm0-21a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 110-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6zM39.285 1.026a2.517 2.517 0 012.192 2.431v3.508l.771-.003h.838c.42.001.83.004 1.177.009a2.668 2.668 0 012.258 1.039c.446.65.588 1.46.391 2.223l-.161.536c-.354 1.18-1.184 3.946-1.68 5.513a3.039 3.039 0 01-3.06 2.218H33V7h2.259c.331-1.052.952-3.06 1.264-4.106a2.473 2.473 0 012.761-1.868zM31 7v11.5h-2V7h2zm7.44-3.536c-.141.477-.347 1.147-.561 1.836l-.129.414c-.408 1.308-.804 2.559-.804 2.559l-.22.698H35v7.53h7.01a1.069 1.069 0 001.154-.824c.494-1.557 1.319-4.308 1.671-5.483l.167-.555a.762.762 0 00-.112-.47.949.949 0 00-.657-.198c-.528-.008-1.204-.01-1.836-.009h-.372l-1.449.008-.09.001-1.009.009V3.457c0-.263-.28-.422-.48-.451-.175-.028-.42-.006-.556.458z"
});

function SvgCustomerSatisfaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2R);
}

function _extends$2Q() { _extends$2Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

var _ref$2Q = /*#__PURE__*/React.createElement("path", {
  d: "M17.831 1a2.89 2.89 0 012.853 2.92V47h-7V26.588L9 23.986l6.056-20.733A2.848 2.848 0 0117.83 1zM27.5 1v13a2.995 2.995 0 002.653 2.98l.887.102V45h3V17.09l.866-.117A3.007 3.007 0 0037.5 14V1h2v13a5.021 5.021 0 01-3.46 4.758V47h-7V18.784A4.997 4.997 0 0125.5 14V1h2zm-9.669 2a.874.874 0 00-.834.728l-5.63 19.286 4.317 2.398V45h3V3.92A.89.89 0 0017.83 3zM31.5 1v8h-2V1h2zm4 0v8h-2V1h2z"
});

function SvgCutlery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2Q);
}

function _extends$2P() { _extends$2P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

var _ref$2P = /*#__PURE__*/React.createElement("path", {
  d: "M47 30.75v14H31v-14h16zm-34-4v11c0 .729.271 1 1 1h9.836l-2.293-2.293 1.414-1.414 4.707 4.707-4.707 4.707-1.414-1.414 2.293-2.293H14a2.811 2.811 0 01-3-3v-11h2zm32 14H33v2h12v-2zm0-4H33v2h12v-2zm0-4H33v2h12v-2zM30.293 5.043l1.414 1.414-2.293 2.293H37a3.003 3.003 0 013 3v15h-2v-15a1 1 0 00-1-1h-7.586l2.293 2.293-1.414 1.414-4.707-4.707 4.707-4.707zM21 4a2.003 2.003 0 012 2v10.728a2.003 2.003 0 01-2 2h-8v2.522h3.59v2H7.5v-2H11v-2.522H3a2.003 2.003 0 01-2-2V6a2.003 2.003 0 012-2zm0 2H3v10.728h18.001L21 6z"
});

function SvgDataExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2P);
}

function _extends$2O() { _extends$2O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

var _ref$2O = /*#__PURE__*/React.createElement("path", {
  d: "M30.433 1a7.07 7.07 0 016.99 5.634 6.976 6.976 0 015.855 6.365h-2.022a5.008 5.008 0 00-4.783-4.464l-.884-.052-.056-.883a5.135 5.135 0 00-10.237.29v32.22a5.142 5.142 0 0010.273-.003.955.955 0 00-.014-.112 3.595 3.595 0 01-.028-.241l-.076-1.015 1.016-.058a4.999 4.999 0 004.81-4.679h2.01a6.957 6.957 0 01-5.733 6.555A7.046 7.046 0 0130.433 47a7.185 7.185 0 01-6.135-3.389A7.153 7.153 0 0118.185 47a7.03 7.03 0 01-7.096-6.443A6.945 6.945 0 015.37 33.82c0-.949.203-1.887.596-2.752a8.297 8.297 0 010-14.924 6.665 6.665 0 01-.596-2.752 6.952 6.952 0 015.85-6.759A7.05 7.05 0 0118.184 1a7.155 7.155 0 016.113 3.388A7.186 7.186 0 0130.433 1zM18.402 3h-.217a5.015 5.015 0 00-5.076 4.599l-.055.883-.884.052a4.985 4.985 0 00-4.8 4.859 4.72 4.72 0 00.834 2.667l.731 1.072-1.223.434a6.34 6.34 0 000 12.082l1.223.434-.731 1.072a4.718 4.718 0 00-.834 2.667 4.985 4.985 0 004.806 4.86l1.016.058-.076 1.015c-.006.08-.017.159-.028.238a.817.817 0 00-.014.115A5.01 5.01 0 0018.184 45h.218a5.011 5.011 0 004.894-4.89V7.892A5.011 5.011 0 0018.185 3zm23.912 25.502a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm2.197-12.92a4.39 4.39 0 012.192 3.808 4.595 4.595 0 01-3.39 4.5v3.104h-2v-4.89l.94-.057a2.585 2.585 0 002.45-2.657 2.39 2.39 0 10-4.779 0h-2a4.39 4.39 0 016.587-3.807z"
});

function SvgDementia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2O);
}

function _extends$2N() { _extends$2N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

var _ref$2N = /*#__PURE__*/React.createElement("path", {
  d: "M33.312 47a4.86 4.86 0 01-4.622-3.82c-.365-1.19-1.471-4.536-4.673-13.705l-.446 1.271c-1.16 3.31-3.576 10.199-4.26 12.435-.944 3.083-3.309 3.97-5.045 3.798a4.275 4.275 0 01-3.841-3.995c-.196-2.036-2.373-17.95-3.035-22.779a12.227 12.227 0 00-1.308-3.043C5.106 15.297 4 13.182 4 11.302a10.42 10.42 0 0115.741-8.84c.399.2.787.42 1.162.661A5.142 5.142 0 0024 4.146a5.146 5.146 0 003.099-1.023c.399-.255.81-.49 1.234-.702A10.214 10.214 0 0133.543 1C39.273.965 43.95 5.573 44 11.303c0 1.88-1.106 3.994-2.082 5.86-.56.93-.995 1.93-1.297 2.972l-.088.639c-2.28 16.652-2.866 21.268-2.957 22.21A4.274 4.274 0 0133.312 47zM14.458 3A8.391 8.391 0 006 11.303c0 1.389.985 3.271 1.854 4.933a12.764 12.764 0 011.508 3.632c.672 4.904 2.853 20.851 3.053 22.924a2.289 2.289 0 002.05 2.196c1.027.104 2.344-.47 2.933-2.393.696-2.274 3.12-9.188 4.287-12.51.324-.927.542-1.548.58-1.664a1.807 1.807 0 011.736-1.192 1.834 1.834 0 011.76 1.177v.001l.142.405c2.544 7.284 4.17 12.05 4.7 13.783.587 1.922 1.894 2.501 2.931 2.394a2.289 2.289 0 002.052-2.197c.132-1.376 1.157-9.083 2.966-22.29l.087-.638c.312-1.28.82-2.505 1.507-3.63.869-1.66 1.854-3.541 1.854-4.931A8.42 8.42 0 0029.282 4.18a12.77 12.77 0 00-1.133.645A7.116 7.116 0 0124 6.145a7.107 7.107 0 01-4.147-1.32c-.343-.22-.697-.421-1.061-.605A8.45 8.45 0 0014.458 3z"
});

function SvgDentistry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2N);
}

function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var _ref$2M = /*#__PURE__*/React.createElement("path", {
  d: "M44.999 15.5a2.003 2.003 0 012 2v19a2.003 2.003 0 01-2 2h-10a2.003 2.003 0 01-2-2v-19a2.003 2.003 0 012-2h10zM30.998 36.51v1.98H1v-1.98h29.998zM44.999 17.5h-10v19h10.002l-.002-19zm-5 15.25a1 1 0 110 2 1 1 0 010-2zm-1-23.75a2.003 2.003 0 012 2v2.5h-2V11h-34v21.5h26v2h-26a2.003 2.003 0 01-2-2V11a2.003 2.003 0 012-2h34z"
});

function SvgDevices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2M);
}

function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var _ref$2L = /*#__PURE__*/React.createElement("path", {
  d: "M23 5l.001 20H43v1c-.013 11.593-9.407 20.987-21 21-11.598 0-21-9.402-21-21S10.402 5 22 5h1zm-1.999 2.026C10.781 7.564 2.823 16.1 3.002 26.332c.18 10.233 8.431 18.485 18.664 18.665 10.232.18 18.769-7.777 19.308-17.997H21V7.026zM26.5 1c11.316.013 20.487 9.184 20.5 20.5v1H25.5V1h1zm1 2.027V20.5h17.474C44.45 11.075 36.925 3.55 27.5 3.027z"
});

function SvgDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2L);
}

function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var _ref$2K = /*#__PURE__*/React.createElement("path", {
  d: "M46.5 18.063L39.444 7.331A2.926 2.926 0 0037 6H10.897A2.92 2.92 0 008.44 7.345l-6.95 10.707a3.036 3.036 0 00.424 3.827L21.42 40.816a3.365 3.365 0 002.264 1.155c.084.018.17.027.257.029h.002c.089-.001.176-.01.262-.029a3.283 3.283 0 002.203-1.09l19.67-18.969a3.034 3.034 0 00.421-3.849zM44.756 19H33.453l4.836-9.842L44.757 19zM23.945 39.083L17.423 21h13.04l-6.518 18.083zm.052-29.407L30.044 19H17.858l6.14-9.324zm-7.846 8.332L11.336 8h11.406l-6.59 10.008zM25.26 8h11.409L31.75 18.01 25.26 8zM9.67 9.07L14.446 19H3.224l6.445-9.93zM3.85 21h11.487l6.194 17.17L3.85 21zM26.35 38.19L32.55 21h11.622L26.35 38.19z"
});

function SvgDiamont(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2K);
}

function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var _ref$2J = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5 32.461v2H24a5.314 5.314 0 00-5.308 5.308V46h-2v-6.231a7.287 7.287 0 012.3-5.308h-7.184a7.301 7.301 0 01-3.673-13.615A7.301 7.301 0 0111.808 7.23h10.615A.577.577 0 0023 6.654V2h2v4.654a2.58 2.58 0 01-2.577 2.576H11.808a5.308 5.308 0 100 10.616H34.5v2H11.808a5.308 5.308 0 100 10.615H34.5zm8.748-13.523a7.301 7.301 0 01-3.383 8.216 7.301 7.301 0 01-3.673 13.615H25.577a.578.578 0 00-.577.577V46h-2v-4.654a2.58 2.58 0 012.577-2.577h10.615a5.307 5.307 0 100-10.615H13v-2h23.192a5.308 5.308 0 000-10.615H13v-2h11a5.314 5.314 0 005.308-5.309V2h2v6.23a7.282 7.282 0 01-2.3 5.309h7.184a7.301 7.301 0 017.056 5.4z",
  fill: "currentColor"
});

function SvgDigestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2J);
}

function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var _ref$2I = /*#__PURE__*/React.createElement("path", {
  d: "M12 4v2.003H9a3.005 3.005 0 00-3 3.003v32.988a3.005 3.005 0 003 3.003h16a3.005 3.005 0 003-3.003v-11.96h2v11.96A5.01 5.01 0 0125 47H9a5.01 5.01 0 01-5-5.006V9.006A5.01 5.01 0 019 4h3zm5 34a2 2 0 110 4 2 2 0 010-4zM36.424 1c2.017 0 3.95.81 5.365 2.248a7.782 7.782 0 010 10.866L28.997 27.118 16.205 14.11a7.79 7.79 0 010-10.862 7.528 7.528 0 0110.736.004l2.056 2.092 2.061-2.096A7.527 7.527 0 0136.424 1zm-9.547 11.988L25.537 15h-5.652l9.112 9.267L38.113 15h-5.576l-2.66 3.988-3-6zM36.424 3c-1.482 0-2.901.595-3.94 1.65l-3.487 3.545-3.482-3.54a5.528 5.528 0 00-7.884-.005 5.791 5.791 0 000 8.058l.287.292h6.548l2.66-3.988 3 6L31.465 13h8.614l.283-.288a5.773 5.773 0 000-8.062A5.528 5.528 0 0036.423 3z"
});

function SvgDigitalHealthApplications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2I);
}

function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var _ref$2H = /*#__PURE__*/React.createElement("path", {
  d: "M42 9.5a5.006 5.006 0 015 5v19a5.006 5.006 0 01-5 5H6a5.006 5.006 0 01-5-5v-19a5.006 5.006 0 015-5h36zm0 2H6a3.003 3.003 0 00-3 3v19a3.003 3.003 0 003 3h36a3.003 3.003 0 003-3v-19a3.003 3.003 0 00-3-3zm-1.455 14.891l.705.377-.209.769A8.26 8.26 0 0133 33.5a8.26 8.26 0 01-8.041-5.963l-.209-.769.705-.377a15.996 15.996 0 0115.09 0zm-13.37 1.388a6.425 6.425 0 0011.65 0 13.84 13.84 0 00-11.65 0zM19 27.5v2H7v-2h12zm0-6v2H7v-2h12zm14-7a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
});

function SvgDigitalHealthCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2H);
}

function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var _ref$2G = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 5v2h-5a3.003 3.003 0 00-3 3v32a3.003 3.003 0 003 3h15a3.003 3.003 0 003-3V30h2v12a5.006 5.006 0 01-5 5h-15a5.006 5.006 0 01-5-5V10a5.006 5.006 0 015-5h5zM19 38a2 2 0 110 4 2 2 0 010-4zM39.5 1a2.002 2.002 0 012 2v25.223l-4.393-2.51-3.06 2.55-3.547-2.534-3.547 2.534-3.06-2.55-4.393 2.51V3a2.002 2.002 0 012-2h18zm0 1.999L21.5 3v21.777l2.607-1.49 2.94 2.45 3.453-2.466 3.453 2.466 2.94-2.45 2.607 1.49V2.999zM35.5 17v2h-10v-2h10zm0-5v2h-10v-2h10zm0-5v2h-10V7h10z"
});

function SvgDigitalPatientReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2G);
}

function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var _ref$2F = /*#__PURE__*/React.createElement("path", {
  d: "M30 5.503a4.784 4.784 0 015 5v2h7a5.006 5.006 0 015 5v20a5.006 5.006 0 01-5 5H6a5.006 5.006 0 01-5-5v-20a5.006 5.006 0 015-5h7v-2a4.784 4.784 0 015-5zm12 9H6a3.003 3.003 0 00-3 3v20a3.003 3.003 0 003 3h36a3.003 3.003 0 003-3v-20a3.003 3.003 0 00-3-3zm-17 5v7h7v2h-7v7h-2v-7h-7v-2h7v-7h2zm5.202-12.007L30 7.503H18a2.811 2.811 0 00-3 3v2h18v-2a2.811 2.811 0 00-3-3z"
});

function SvgDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2F);
}

function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var _ref$2E = /*#__PURE__*/React.createElement("path", {
  d: "M36 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5H12a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5zm0 2H12a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h24a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zm-2 27v2H14v-2h20zm0-7v2H14v-2h20zm0-7v2H14v-2h20z"
});

function SvgDokument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2E);
}

function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var _ref$2D = /*#__PURE__*/React.createElement("path", {
  d: "M14.66 6c.184 0 .365.051.522.147l8.493 5.196H41.81A5.195 5.195 0 0147 16.53v19.783a5.195 5.195 0 01-5.19 5.187H6.19A5.195 5.195 0 011 36.313V11.188A5.195 5.195 0 016.19 6h8.47zm-.282 2H6.19A3.192 3.192 0 003 11.188v25.125A3.192 3.192 0 006.19 39.5h35.62A3.192 3.192 0 0045 36.313V16.53a3.192 3.192 0 00-3.19-3.187H23.393a.996.996 0 01-.522-.148L14.378 8zM25 18.005v13.648l5.806-5.592 1.388 1.442-7.5 7.222a1 1 0 01-1.388 0l-7.5-7.222 1.388-1.442L23 31.653V18.005h2z"
});

function SvgDownloadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2D);
}

function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var _ref$2C = /*#__PURE__*/React.createElement("path", {
  d: "M4 31v10a3.003 3.003 0 003 3h34a3.003 3.003 0 003-3V31h2v10a5.006 5.006 0 01-5 5H7a5.006 5.006 0 01-5-5V31h2zM25 2v30.648L36.806 21.28l1.388 1.442-13.5 13a.997.997 0 01-1.388 0l-13.5-13 1.388-1.442L23 32.65V2h2z"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2C);
}

function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var _ref$2B = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.215 35.356A19.262 19.262 0 0024 47.25a19.183 19.183 0 0013.612-5.632c7.518-7.526 7.518-19.72 0-27.247L24 .75 10.388 14.371a19.262 19.262 0 00-4.173 20.985zm5.587-19.566L24 3.582 36.198 15.79a17.25 17.25 0 11-24.396 0z",
  fill: "currentColor"
});

function SvgDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2B);
}

function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var _ref$2A = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.813 24.823a8.366 8.366 0 011.212 7.946c3.522 3.597 5.994 6.115 7.414 7.555l.661.671-5.516 6.146-.743-.74-.32-.32-.94-.937-.656-.658-.728-.728-.524-.526c-1.26-1.263-2.776-2.785-4.547-4.566-2.608 1.114-6.338.401-8.882-1.79-2.793-2.407-3.493-5.915-1.92-9.626a1.228 1.228 0 011.61-.649l.19.08.216.2 3.791 3.882 2.418-.72.69-2.285-3.83-3.893a1.21 1.21 0 01.58-2.022c4.11-.964 7.687.125 9.824 2.98zm-7.92-1.28l3.598 3.656-1.344 4.456-4.6 1.368-3.782-3.87a5.726 5.726 0 001.78 6.206c2.093 1.805 5.414 2.37 7.25 1.235l.672-.416.559.561c1.944 1.955 3.596 3.614 4.957 4.978l.528.53 1.399 1.4.594.594 2.855-3.18c-1.554-1.58-3.97-4.044-7.248-7.393l-.524-.536.366-.654a6.23 6.23 0 00-.735-6.454 6.58 6.58 0 00-6.324-2.48zM10 30l-.001-.001-3.494-.007a13.58 13.58 0 01.747 4.508 13.515 13.515 0 01-.747 4.5h15.524v2H3.386l.718-1.444A11.263 11.263 0 005.252 34.5a11.326 11.326 0 00-1.149-5.067l-.715-1.448 6.024.014c.645-1.41.955-2.95.906-4.499a10.04 10.04 0 00-.907-4.5l-3.593-.017C3.62 18.578 1 17.124 1 12.5s2.62-6.078 4.818-6.483L6 6h33.584l-.681 1.43A11.693 11.693 0 0037.8 12.5a11.84 11.84 0 00.851 4.5l3.473.008C44.348 17.285 47 18.638 47 23.5s-2.652 6.215-4.876 6.492l-.248-1.984C43.216 27.84 45 27.19 45 23.5c0-3.637-1.731-4.32-3.065-4.5h-4.567l-.001-.001H11.588c.51 1.445.757 2.97.73 4.501a12.852 12.852 0 01-.73 4.5H19v2h-9zM36.517 8H6.094C4.74 8.268 3 9.052 3 12.5s1.74 4.232 3.094 4.5h3.905v-.001h26.518A14.018 14.018 0 0135.8 12.5c-.008-1.529.234-3.05.717-4.5z"
});

function SvgDualStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2A);
}

function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var _ref$2z = /*#__PURE__*/React.createElement("path", {
  d: "M13.904 7.144a15.065 15.065 0 0122.206 19.5l9.57 9.615a4.516 4.516 0 01-6.372 6.4l-9.83-9.876a14.825 14.825 0 01-12.62.099 6 6 0 01-.976 2.21l1.48 1.485 1.06-1.066 1.414 1.42-3.535 3.551-1.414-1.42 1.06-1.065-1.478-1.485a5.946 5.946 0 01-2.471 1.028v2.1h1.5v2.009h-5v-2.01h1.5V37.54a5.946 5.946 0 01-2.47-1.028l-1.479 1.485 1.06 1.065-1.413 1.42-3.535-3.55 1.413-1.42 1.061 1.065 1.479-1.486a6.007 6.007 0 01-1.025-2.482H3v1.507H1v-5.023h2V30.6H5.09a6.012 6.012 0 011.032-2.474l-1.487-1.493-1.06 1.065-1.414-1.42 3.535-3.55 1.413 1.42-1.06 1.065 1.483 1.49a5.966 5.966 0 012.026-.942 15.065 15.065 0 014.346-18.617zm21.069 21.199a15.191 15.191 0 01-3.677 3.426l9.426 9.47a2.502 2.502 0 003.544 0 2.525 2.525 0 000-3.56zm-24.35-.72a4.008 4.008 0 00.375 8 4 4 0 003.975-3.771 15.198 15.198 0 01-4.35-4.228zM23.107 6.112c-7.205-.022-13.068 5.796-13.101 13.002-.008 7.226 5.834 13.096 13.061 13.121 7.206 0 13.05-5.835 13.062-13.041.01-7.206-5.816-13.06-13.022-13.082zm-.04 1.768c6.187.021 11.19 5.047 11.183 11.234A11.233 11.233 0 1123.066 7.879zM13.888 19.03l-.004.083a9.214 9.214 0 009.182 9.224c.072 0 .14-.01.212-.01a9.65 9.65 0 00-9.39-9.297zm9.858-9.045a9.183 9.183 0 00-9.616 7.042 11.532 11.532 0 017.01 2.746l2.91-2.923-2.765-2.777 1.414-1.42 6.943 6.974-1.414 1.42-2.765-2.777-2.912 2.926a11.66 11.66 0 012.722 6.86 9.183 9.183 0 00-1.527-18.071z"
});

function SvgEarlyDetection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2z);
}

function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var _ref$2y = /*#__PURE__*/React.createElement("path", {
  d: "M24 14.75a6 6 0 10-6-6 6.007 6.007 0 006 6zm0-10a4 4 0 110 8 4 4 0 010-8zm-6.747 12A9.816 9.816 0 0124 19.415a9.816 9.816 0 016.747-2.665H42v25.197H30.747c-1.969 0-4.657.875-5.907 2.797a1.049 1.049 0 01-.838.506 1.248 1.248 0 01-.839-.506c-1.253-1.922-3.941-2.797-5.91-2.797H6V16.75zm0 1.996H8v21.205h9.253c2.056.016 4.059.653 5.747 1.826V21.34a7.474 7.474 0 00-5.747-2.594zm22.747 0h-9.253A7.474 7.474 0 0025 21.34v20.437a10.205 10.205 0 015.747-1.826H40V18.746zM36.5 33.25v2h-8v-2h8zm0-5v2h-8v-2h8zm0-5v2h-8v-2h8z"
});

function SvgEasyLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2y);
}

function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var _ref$2x = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 24C1 11.297 11.297 1 24 1c12.697.014 22.986 10.303 23 23 0 12.703-10.297 23-23 23S1 36.703 1 24zm11.913 4.592A12 12 0 0024 36c6.624-.007 11.993-5.376 12-12a12 12 0 10-23.087 4.592zm23.628-10.777l5.125-5.126a20.85 20.85 0 010 22.622l-5.126-5.125a13.836 13.836 0 000-12.371zm-1.045-1.784l4.993-4.993a21.153 21.153 0 00-3.526-3.527l-4.993 4.994a14.11 14.11 0 013.526 3.526zm-.185-9.696l-5.125 5.125a13.837 13.837 0 00-12.372 0l-5.125-5.125a20.85 20.85 0 0122.622 0zm-19.28 6.17L11.037 7.51a21.154 21.154 0 00-3.527 3.527l4.993 4.993a14.104 14.104 0 013.527-3.526zm-9.697.184l5.126 5.125a13.837 13.837 0 000 12.372l-5.126 5.125a20.85 20.85 0 010-22.622zm6.17 19.28l-4.993 4.993a21.154 21.154 0 003.527 3.527l4.993-4.993a14.106 14.106 0 01-3.526-3.527zm.186 9.697l5.124-5.125a13.837 13.837 0 0012.372 0l5.124 5.125a20.85 20.85 0 01-22.62 0zm19.279-6.17l4.993 4.993a21.157 21.157 0 003.527-3.527l-4.993-4.993a14.106 14.106 0 01-3.527 3.527z",
  fill: "currentColor"
});

function SvgEmergencyRescueRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2x);
}

function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var _ref$2w = /*#__PURE__*/React.createElement("path", {
  d: "M42 12.503h-7v-2a4.784 4.784 0 00-5-5H18a4.784 4.784 0 00-5 5v2H6a5.006 5.006 0 00-5 5v20a5.006 5.006 0 005 5h36a5.006 5.006 0 005-5v-20a5.006 5.006 0 00-5-5zm-27-2a2.811 2.811 0 013-3h12a2.811 2.811 0 013 3v2H15v-2zm-9 4h36a3.003 3.003 0 013 3v6H3v-6a3.003 3.003 0 013-3zm36 26H6a3.003 3.003 0 01-3-3v-12h42v12a3.003 3.003 0 01-3 3z"
});

function SvgEmployed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2w);
}

function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var _ref$2v = /*#__PURE__*/React.createElement("path", {
  d: "M42 10H6a5.006 5.006 0 00-5 5v18a5.006 5.006 0 005 5h36a5.006 5.006 0 005-5V15a5.006 5.006 0 00-5-5zm0 2c.477.003.947.122 1.368.346L24 23.35 4.632 12.346c.421-.224.89-.343 1.368-.346h36zm3 21a3.003 3.003 0 01-3 3H6a3.003 3.003 0 01-3-3V15c0-.395.079-.786.231-1.15L24 25.65l20.769-11.8c.152.364.231.755.231 1.15v18z"
});

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2v);
}

function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var _ref$2u = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 29.999a21.276 21.276 0 0110.84 3.128l.66.377-.19.745a11.363 11.363 0 01-11.31 8.75 11.363 11.363 0 01-11.31-8.75l-.19-.745.662-.377A21.277 21.277 0 0135.5 29.999zm-17.94-5c4.288.04 8.522.96 12.44 2.701l-.784 1.835a29.398 29.398 0 00-11.655-2.54A30.48 30.48 0 003.34 30.76a15.054 15.054 0 0020.858 8.72l.87 1.795A16.97 16.97 0 0117.56 43 16.87 16.87 0 011.2 30.519L1 29.766l.681-.375a32.78 32.78 0 0115.88-4.391zm17.94 7a18.965 18.965 0 00-9.184 2.49A9.29 9.29 0 0035.5 41a9.29 9.29 0 009.185-6.51A18.964 18.964 0 0035.5 32zm0-17a6 6 0 016 6 6.007 6.007 0 01-6 6 6 6 0 110-12zm0 2a4 4 0 100 8 4 4 0 000-8zm-18-12a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 110-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6z"
});

function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2u);
}

function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var _ref$2t = /*#__PURE__*/React.createElement("path", {
  d: "M36 1H20.42L7 14.42V42a5.006 5.006 0 005 5h24a5.006 5.006 0 005-5V6a5.006 5.006 0 00-5-5zM19.835 4.414v9.421h-9.42l9.42-9.42zM39 42a3.003 3.003 0 01-3 3H12a3.003 3.003 0 01-3-3V15.835h12.835V3H36a3.003 3.003 0 013 3v36z"
});

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2t);
}

function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var _ref$2s = /*#__PURE__*/React.createElement("path", {
  d: "M36 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5v-2a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zm6 0a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5v-2a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zM30 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5H6a5.006 5.006 0 01-5-5V14.42L14.42 1zm0 2H15.835v12.835H3V42a3.003 3.003 0 003 3h24a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zM13.835 4.414l-9.42 9.421h9.42v-9.42z"
});

function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2s);
}

function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var _ref$2r = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.003 36.703c-.23 0-.46-.013-.69-.036-6.63-.395-11.807-5.884-11.813-12.526-.003-4.959 2.388-7.857 11.814-17.15l.702-.694.702.694c9.394 9.275 11.779 12.174 11.782 17.17.014 6.909-5.573 12.523-12.482 12.542h-.015zm0-2h.007a4.697 4.697 0 003.34-1.388 4.746 4.746 0 001.4-3.382c-.001-1.728-.731-2.828-4.743-6.823-4.026 4.005-4.758 5.101-4.757 6.81a4.78 4.78 0 004.752 4.782zm.012-25.594C32.907 17.924 34.498 20.26 34.5 24.163a10.486 10.486 0 01-3.092 7.471 10.62 10.62 0 01-1.243 1.05 6.753 6.753 0 00.585-2.753c-.002-2.749-1.477-4.435-6.04-8.94l-.702-.693-.702.693c-4.832 4.763-6.058 6.263-6.056 8.931 0 .944.2 1.877.584 2.74a10.571 10.571 0 01-4.334-8.523c-.002-3.864 1.593-6.197 10.515-15.03zM36.5 39.703h-25v2h25v-2z",
  fill: "currentColor"
});

function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2r);
}

function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var _ref$2q = /*#__PURE__*/React.createElement("path", {
  d: "M40.484 4.684c-.082.048-8.255 4.865-15.424.027a21.079 21.079 0 00-17.37-3L7 1.934v45.064h2V20.567A19.563 19.563 0 0123.94 23.5c8.217 5.544 17.198.256 17.576.028l.484-.291V3.77l-1.516.913zM40 22.076c-1.864.946-8.774 3.929-14.94-.233a21.341 21.341 0 00-12.048-3.713A20.613 20.613 0 009 18.515V3.435A19.568 19.568 0 0123.94 6.37c6.325 4.267 13.101 2.117 16.06.796v14.91z"
});

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2q);
}

function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var _ref$2p = /*#__PURE__*/React.createElement("path", {
  d: "M41.81 41.5H6.19A5.195 5.195 0 011 36.313V11.188A5.195 5.195 0 016.19 6h8.47c.184 0 .365.051.522.147l8.493 5.196H41.81A5.195 5.195 0 0147 16.53v19.783a5.195 5.195 0 01-5.19 5.187zM6.19 8A3.192 3.192 0 003 11.188v25.125A3.192 3.192 0 006.19 39.5h35.62A3.192 3.192 0 0045 36.313V16.53a3.192 3.192 0 00-3.19-3.187H23.393a.996.996 0 01-.522-.148L14.378 8H6.19z"
});

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2p);
}

function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var _ref$2o = /*#__PURE__*/React.createElement("path", {
  d: "M40.314 25.5l5.436 5.436L29.686 47H24.25v-5.436L40.314 25.5zM31.25 1a5.006 5.006 0 015 5v21h-2V6a3.003 3.003 0 00-3-3h-24a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h15v2h-15a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h24zm9.064 27.34L26.258 42.395v2.596h2.596l14.057-14.056-2.597-2.597zM29.25 22v2h-20v-2h20zm0-9v2h-20v-2h20z"
});

function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2o);
}

function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var _ref$2n = /*#__PURE__*/React.createElement("path", {
  d: "M26.512 12.046a4.107 4.107 0 014.105.007l16.537 9.596-1.003 1.733L42 20.974v17.518a5.01 5.01 0 01-5 5.008H19.847a4.855 4.855 0 01-4.846-4.853v-3.111h2v3.11a2.851 2.851 0 002.846 2.85h17.154a3.006 3.006 0 003-3.004V19.814l-10.387-6.028a2.112 2.112 0 00-2.105-.004l-5.142 2.954-.995-1.737zm-25.01 9.838a26.66 26.66 0 0125.998 0l.656.377-.185.734A14.063 14.063 0 0114.5 33.5a14.063 14.063 0 01-13.47-10.505l-.185-.734zM25.82 23.24a24.745 24.745 0 00-22.637 0A12.05 12.05 0 0014.5 31.5a12.05 12.05 0 0011.319-8.26zM19 22.5v2h2v2h-2v2h-2v-2h-2v-2h2v-2h2zm-4.5-18a6 6 0 110 12 6.007 6.007 0 01-6-6 6 6 0 016-6zm0 2a4 4 0 100 8 4 4 0 000-8z"
});

function SvgGeneralPractitioner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2n);
}

function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var _ref$2m = /*#__PURE__*/React.createElement("path", {
  d: "M45 11.5H33.79a6.216 6.216 0 00-.114-8.681 6.248 6.248 0 00-8.815 0c-.33.324-.619.686-.861 1.08a5.677 5.677 0 00-.861-1.08 6.247 6.247 0 00-8.814 0 6.215 6.215 0 00-.115 8.68H3a2.003 2.003 0 00-2 2V21a2.003 2.003 0 002 2h1v19.898A3.11 3.11 0 007.111 46H40.89A3.11 3.11 0 0044 42.897V23h1a2.003 2.003 0 002-2v-7.5a2.003 2.003 0 00-2-2zM26.275 4.236a4.24 4.24 0 015.988-.001 4.224 4.224 0 010 5.974c-1.077 1.075-2.219 1.313-7.261 1.289-.023-5.043.208-6.199 1.273-7.262zm-10.537-.001a4.24 4.24 0 015.987 0c1.065 1.064 1.296 2.22 1.273 7.263-5.008.02-6.186-.214-7.26-1.29a4.223 4.223 0 010-5.973zM3 13.5h20V21H3v-7.5zm3 29.397V23h17v21H7.111A1.108 1.108 0 016 42.897zm36 0A1.108 1.108 0 0140.889 44H25V23h17v19.897zM25 21v-7.5h20l.002 7.5H25z"
});

function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2m);
}

function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var _ref$2l = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 21v-3H27v3.345a5.29 5.29 0 00-6 0V18H5v3H2v2h3v3a4.004 4.004 0 004 4h8a4.004 4.004 0 004-4v-1.751a3.368 3.368 0 016 0V26a4.004 4.004 0 004 4h8a4.004 4.004 0 004-4v-3h3v-2h-3zm-24 5a2.002 2.002 0 01-2 2H9a2.002 2.002 0 01-2-2v-6h12v6zm20 2a2.002 2.002 0 002-2v-6H29v6a2.002 2.002 0 002 2h8z",
  fill: "currentColor"
});

function SvgGlasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2l);
}

function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var _ref$2k = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M46.059 7.5v-2h-4.5V1h-2v5.086l-1.846 1.846C28.912-.102 15.306.363 7.074 8.979c-8.232 8.615-8.077 22.228.348 30.655 8.426 8.426 22.039 8.582 30.655.35 8.617-8.23 9.083-21.836 1.05-30.638L40.973 7.5h5.086zm-3.2 16.6a19.978 19.978 0 11-6.576-14.738l-3.776 3.776c-5.935-5.172-14.9-4.711-20.273 1.043-5.372 5.753-5.218 14.73.348 20.296 5.566 5.566 14.542 5.72 20.296.347 5.754-5.372 6.215-14.338 1.043-20.272l3.776-3.776a19.8 19.8 0 015.162 13.325zm-14.687 0a5.218 5.218 0 11-2.304-4.324l-3.616 3.617a1 1 0 101.414 1.414l3.616-3.616c.581.858.891 1.872.89 2.909zm-.877-5.75a7.24 7.24 0 101.414 1.413l3.798-3.797c4.385 5.143 3.926 12.83-1.04 17.416-4.965 4.585-12.665 4.432-17.444-.347s-4.932-12.479-.346-17.444c4.585-4.965 12.273-5.424 17.416-1.04l-3.798 3.798z"
});

function SvgGoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2k);
}

function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var _ref$2j = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 15.038V8.975a11.491 11.491 0 01-8.318-4.861l1.636-1.152A9.328 9.328 0 0024 7.038a9.328 9.328 0 007.682-4.076l1.636 1.152A11.491 11.491 0 0125 8.975v6.063h-2zm-10 2a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm-2.5 4.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm13.5 4.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-2a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm11-7a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-16.5 2.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm-2.5 4.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm13.5-4.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-10 7a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm2 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
  fill: "currentColor"
});

function SvgGrapes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2j);
}

function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var _ref$2i = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.63 18.827a3.924 3.924 0 013.111 3.902l.005 8.798a15.482 15.482 0 01-26.37 10.999L6.301 32.459a2.986 2.986 0 01-.966-2.961 3.546 3.546 0 012.661-2.345 5.806 5.806 0 015.614 1.67l4.197 4.18.009-28.127a3.871 3.871 0 014.62-3.804 3.925 3.925 0 013.111 3.904v10.95a3.888 3.888 0 012.62-.41 3.832 3.832 0 012.788 2.297c.86-.59 1.92-.81 2.944-.61a3.83 3.83 0 012.766 2.248 3.87 3.87 0 012.965-.624zm-21.843 22.28a13.395 13.395 0 009.475 3.894c7.439-.012 13.468-6.036 13.484-13.475l-.005-8.796a1.949 1.949 0 00-1.488-1.939 1.859 1.859 0 00-1.56.39 1.875 1.875 0 00-.682 1.45V25h-2v-3.894a1.95 1.95 0 00-1.489-1.94 1.875 1.875 0 00-2.243 1.84h-.005V25h-2v-4.107h.005V19.42a1.95 1.95 0 00-1.488-1.94 1.872 1.872 0 00-2.244 1.84h-.003V25h-2v-6.015h.003V4.975a1.95 1.95 0 00-1.488-1.939 1.875 1.875 0 00-2.243 1.84l-.01 30.295a1.1 1.1 0 01-1.876.779l-5.734-5.712a3.943 3.943 0 00-2.837-1.257 3.35 3.35 0 00-.849.105 1.667 1.667 0 00-1.243.933 1.18 1.18 0 00.45 1.027l10.07 10.061z",
  fill: "currentColor"
});

function SvgHandShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2i);
}

function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var _ref$2h = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.701 9.205a3.903 3.903 0 015.8 3.402v18.908a15.5 15.5 0 11-30.999.001V19.732a3.243 3.243 0 01.83-2.334c1.156-1.207 3.416-1.015 4.97.343V9.71a3.9 3.9 0 015.8-3.402V4.882a3.9 3.9 0 017.566-1.33 3.899 3.899 0 016.033 3.26v2.393zM24.002 44.98c7.443 0 13.481-6.024 13.499-13.467l.001-18.907a1.9 1.9 0 00-3.8-.013h.002V23.23h-2V12.607h-.003V6.813a1.9 1.9 0 00-3.8 0v16.416h-2V4.882a1.9 1.9 0 10-3.8 0v4.754h.003v13.593h-2V9.71h-.002a1.9 1.9 0 00-3.8 0v12.654h-.025v4.92a9.298 9.298 0 018.288 9.226h-2a7.293 7.293 0 00-7.288-7.28h-1V22.1a3.51 3.51 0 00-2.89-3.534.813.813 0 00-.612.217c-.205.272-.303.61-.273.95v11.783c.018 7.443 6.057 13.467 13.5 13.466z",
  fill: "currentColor"
});

function SvgHandStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2h);
}

function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var _ref$2g = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.998 25.827a3.91 3.91 0 010 6.163 3.867 3.867 0 01-2.478 6.599 3.915 3.915 0 01-3.374 5.912H23.572l-6.531-.17c-6.936-.013-12.55-5.643-12.543-12.578.007-6.936 5.633-12.555 12.568-12.553l2.236-.041 5.266-13.292a2.873 2.873 0 013.616-2.258c2.293.618 4.143 3.516 3.268 6.86l-1.345 8.68 1.29-.003 7.818.008a3.914 3.914 0 012.783 6.673zm-2.784-.835a1.924 1.924 0 001.922-1.921 1.923 1.923 0 00-1.922-1.92l-4.734-.005v.011l-4.217-.009a1.928 1.928 0 00-.514 3.789l.208.057h9.257v-.002zM17.068 42.334a10.569 10.569 0 11.018-21.137l3.585-.067 5.776-14.578.036-.107c.216-.8.591-.956.877-.956.103.002.204.018.302.047a3.588 3.588 0 011.844 4.467l-1.539 9.901a3.903 3.903 0 00-.322 6.1 3.913 3.913 0 00-.02 5.837 3.914 3.914 0 00.277 6.047 3.92 3.92 0 00-1.069 2.686c.004.679.187 1.344.529 1.93h-3.763l-6.53-.17zm13.696.17h5.382a1.92 1.92 0 00.024-3.838h-2.704c-.186.01-.383.015-.599.02l-.162.004h-.01c-.925.02-2.157.047-2.545.057a1.928 1.928 0 00.614 3.757zm8.42-5.9l-3.058.063v.002H33.78c-.628 0-3.514-.06-4.13-.09a1.926 1.926 0 01-.021-3.648l.304-.106h9.28v.001c1.061 0 1.921.86 1.923 1.92a1.881 1.881 0 01-1.952 1.858zm-9.33-5.776h9.736a1.919 1.919 0 00.014-3.837h-9.567l-.298.083a1.926 1.926 0 00-.11 3.676l.224.078z",
  fill: "currentColor"
});

function SvgHandThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2g);
}

function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var _ref$2f = /*#__PURE__*/React.createElement("path", {
  d: "M38.48 31.995a3.973 3.973 0 003.097-1.146 4 4 0 000-5.657c5.077-5.076 5.077-13.308 0-18.384-5.077-5.077-13.308-5.077-18.385 0-5.076-5.077-13.308-5.077-18.384 0-5.077 5.076-5.077 13.308 0 18.384a4 4 0 000 5.657c.85.85 1.985 1.22 3.096 1.146a3.973 3.973 0 001.146 3.097c.85.85 1.985 1.22 3.097 1.146a3.973 3.973 0 001.146 3.097 3.97 3.97 0 003.097 1.145 3.973 3.973 0 001.146 3.097 4 4 0 005.656 0l2.829-2.828a3.959 3.959 0 001.022-1.807l.392.393a4 4 0 005.657 0 3.973 3.973 0 001.146-3.097 3.973 3.973 0 003.097-1.146 3.973 3.973 0 001.145-3.097zM24.607 8.222c4.289-4.29 11.267-4.29 15.556 0 4.289 4.289 4.289 11.267 0 15.556L27.435 11.05l-7.723 7.723c-.78.78-2.049.78-2.828 0a2.002 2.002 0 010-2.828l7.723-7.723zM9.05 29.435c-.78.78-2.048.78-2.828 0a2.002 2.002 0 010-2.828l2.828-2.829c.78-.78 2.049-.78 2.829 0 .78.78.78 2.049 0 2.829L9.05 29.435zm4.243 4.243c-.78.78-2.049.78-2.829 0a2.002 2.002 0 010-2.829l2.829-2.828c.78-.78 2.049-.78 2.828 0 .78.78.78 2.048 0 2.828l-2.828 2.829zm4.243 4.242c-.78.78-2.05.78-2.829 0a2.002 2.002 0 010-2.828l2.829-2.829c.78-.78 2.048-.78 2.828 0 .78.78.78 2.05 0 2.829l-2.828 2.828zm4.242 4.243c-.78.78-2.048.78-2.828 0a2.002 2.002 0 010-2.828l2.828-2.829c.78-.78 2.049-.78 2.829 0 .78.78.78 2.049 0 2.829l-2.829 2.828zm7.778-17.678l6.364 6.364c.78.78.78 2.049 0 2.829-.78.78-2.048.78-2.828 0l-6.364-6.364a1 1 0 10-1.414 1.414l6.364 6.364c.78.78.78 2.049 0 2.828-.78.78-2.049.78-2.829 0l-2.828-2.828a3.973 3.973 0 00-3.097-1.146 3.973 3.973 0 00-1.146-3.097 3.973 3.973 0 00-3.097-1.146 3.973 3.973 0 00-1.145-3.096 3.973 3.973 0 00-3.097-1.146 3.973 3.973 0 00-1.146-3.097 4 4 0 00-5.657 0l-1.414 1.414c-4.29-4.289-4.29-11.267 0-15.556 4.289-4.29 11.267-4.29 15.556 0L15.47 14.53a4 4 0 005.657 5.657l6.309-6.31 12.728 12.729c.78.78.78 2.048 0 2.828-.78.78-2.049.78-2.828 0l-6.364-6.364a1 1 0 10-1.415 1.414z"
});

function SvgHandshakeCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2f);
}

function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var _ref$2e = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.593-9.407-20.987-21-21zm11.094 25.577l1.812.846A14.23 14.23 0 0124 37.5a14.23 14.23 0 01-12.906-8.077l1.812-.846a12.35 12.35 0 0022.188 0zM15.5 16.25a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm17 0a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z"
});

function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2e);
}

function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var _ref$2d = /*#__PURE__*/React.createElement("path", {
  d: "M24 2C11.103 2 1 10.411 1 21.15V41a5.006 5.006 0 005 5h3a5.006 5.006 0 005-5v-7a5.006 5.006 0 00-5-5H3v-7.85C3 11.532 12.225 4 24 4s21 7.533 21 17.15V29h-6a5.006 5.006 0 00-5 5v7a5.006 5.006 0 005 5h3a5.006 5.006 0 005-5V21.15C47 10.41 36.897 2 24 2zM3 41V31h4v13H6a3.003 3.003 0 01-3-3zm9-7v7a3.003 3.003 0 01-3 3V31a3.003 3.003 0 013 3zm24 7v-7a3.003 3.003 0 013-3v13a3.003 3.003 0 01-3-3zm9 0a3.003 3.003 0 01-3 3h-1V31h4v10z"
});

function SvgHeadphones1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2d);
}

function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var _ref$2c = /*#__PURE__*/React.createElement("path", {
  d: "M39 9.257v-1.39a3.024 3.024 0 00-1.633-2.672 28.746 28.746 0 00-13.365-3.194 28.772 28.772 0 00-13.37 3.195A3.025 3.025 0 009 7.87v1.386c-5.093 3.629-8 8.896-8 14.58V41a5.006 5.006 0 005 5h3a5.006 5.006 0 005-5v-7a5.006 5.006 0 00-5-5H3v-5.165a15.834 15.834 0 016.695-12.61 2.894 2.894 0 002.3 1.109 3.01 3.01 0 001.447-.375 21.997 21.997 0 0110.56-2.604c3.681-.03 7.31.865 10.556 2.603a2.924 2.924 0 003.746-.732A15.832 15.832 0 0145 23.836V29h-6a5.006 5.006 0 00-5 5v7a5.006 5.006 0 005 5h3a5.006 5.006 0 005-5V23.836c0-5.685-2.908-10.95-8-14.58zM9 31a3.003 3.003 0 013 3v7a3.003 3.003 0 01-3 3H6a3.003 3.003 0 01-3-3V31h6zM37 9.336a.976.976 0 01-.485.855.987.987 0 01-.996.014 23.986 23.986 0 00-11.517-2.849c-4.018-.03-7.98.95-11.52 2.85A.996.996 0 0111 9.336V7.87c.006-.383.223-.731.564-.905a26.768 26.768 0 0112.438-2.964 26.733 26.733 0 0112.433 2.964c.341.172.56.52.565.903v1.468zM45 41a3.003 3.003 0 01-3 3h-3a3.003 3.003 0 01-3-3v-7a3.003 3.003 0 013-3h6v10z"
});

function SvgHeadphones2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2c);
}

function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var _ref$2b = /*#__PURE__*/React.createElement("path", {
  d: "M46.064 32.051l-4.509-4.52a7.488 7.488 0 00-2.906-8.788l.126.019a9.477 9.477 0 00-2.59-8.03 9.166 9.166 0 00-13.054-.002l-2.756 2.798-2.75-2.792a9.166 9.166 0 00-13.06-.005A9.49 9.49 0 003.4 22.495H1V24.5h4.112L20.375 40l9.202-9.342a7.414 7.414 0 007.448 1.414l4.508 4.52a3.203 3.203 0 004.53 0 3.22 3.22 0 00.001-4.54zm-38.142-7.55h4.8l1.32-3.971 3.914 10.79 2.722-6.82h4.323v-2.005h-5.678L18.045 25.7 13.96 14.437l-2.68 8.058H5.953a7.46 7.46 0 01.036-10.356 7.172 7.172 0 0110.214.005l4.173 4.236 4.179-4.241a7.172 7.172 0 0110.208 0 7.447 7.447 0 012.09 5.728 7.442 7.442 0 00-2.35-.383 7.515 7.515 0 00-6.25 11.666l-7.877 7.996L7.922 24.5zm21.079.5a5.5 5.5 0 115.5 5.514 5.513 5.513 0 01-5.5-5.514zm15.648 10.173c-.47.47-1.23.47-1.701.001l-4.07-4.08a7.561 7.561 0 001.702-1.707l4.069 4.08a1.21 1.21 0 010 1.706z"
});

function SvgHealthCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2b);
}

function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var _ref$2a = /*#__PURE__*/React.createElement("path", {
  d: "M45 18h-3v-2a1.934 1.934 0 00-2-2h-3a1.934 1.934 0 00-2 2v4H13v-4a1.934 1.934 0 00-2-2H8a1.934 1.934 0 00-2 2v2H3a1.934 1.934 0 00-2 2v8a1.934 1.934 0 002 2h3v2a1.934 1.934 0 002 2h3a1.934 1.934 0 002-2v-4h22v4a1.934 1.934 0 002 2h3a1.934 1.934 0 002-2v-2h3a1.934 1.934 0 002-2v-8a1.934 1.934 0 00-2-2zM3 28v-8h3v8H3zm8 4H8V16l2.993-.063c.006.02.008.042.007.063v16zm2-6v-4h22v4H13zm27 6h-3V16h3v16zm5-4h-3v-8h3v8z"
});

function SvgHealthCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2a);
}

function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var _ref$29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.16 8.36a37.624 37.624 0 01-16.518-7.075L23.999.75l-.64.535A37.623 37.623 0 016.84 8.36L6 8.496v19.735c0 6.442 11.352 17.634 17.796 18.977l.204.042.204-.042C30.648 45.865 42 34.672 42 28.23V8.496l-.84-.136zM40 28.23c0 5.422-10.37 15.609-16 16.974C18.37 43.839 8 33.652 8 28.23V10.189a39.698 39.698 0 0016-6.868 39.698 39.698 0 0016 6.868v18.042zm-17-5.058v-7h2v7h7v2h-7v7h-2v-7h-7v-2h7z",
  fill: "currentColor"
});

function SvgHealthInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$29);
}

function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var _ref$28 = /*#__PURE__*/React.createElement("path", {
  d: "M6.298 13.554a3.564 3.564 0 011.587 2.34c.416 1.704 1.02 4.386 1.342 5.833a3.893 3.893 0 013.524 1.799c.657.884 1.12 1.536 1.484 2.05.438.616.726 1.022 1.035 1.382.342.261.698.503 1.067.726 1.56.998 3.918 2.507 5.193 4.592 2.445 3.994.045 12.634-.058 13l-.205.728H11.05l-.06-1.451c-.073-1.963-.137-3.658-1.366-5.405a18.355 18.355 0 00-2.204-2.383 18.192 18.192 0 01-3.979-4.924c-1.254-2.567-2.257-12.466-2.368-13.586-.12-1.22-.437-4.462 2.433-5.149a3.564 3.564 0 012.79.448zm38.196-.448c2.87.687 2.552 3.928 2.432 5.149-.11 1.119-1.109 11.009-2.367 13.586a18.227 18.227 0 01-3.979 4.923 18.388 18.388 0 00-2.204 2.384c-1.229 1.746-1.293 3.44-1.367 5.402l-.06 1.454H26.732l-.205-.728c-.103-.367-2.502-9.006-.057-13 1.275-2.085 3.633-3.594 5.193-4.592.372-.224.731-.47 1.075-.735.299-.349.586-.753 1.02-1.366.366-.515.83-1.168 1.49-2.057a3.904 3.904 0 013.524-1.8 346.1 346.1 0 011.343-5.832 3.566 3.566 0 014.378-2.788zM3.972 15.052c-.41.098-1.175.28-.908 3.007.42 4.255 1.344 11.204 2.175 12.904a16.393 16.393 0 003.575 4.366 19.828 19.828 0 012.448 2.668 10.334 10.334 0 011.71 6.007h6.766c.66-2.693 1.585-8.236.087-10.684-1.036-1.692-3.16-3.052-4.566-3.952a7.18 7.18 0 01-1.507-1.107c-.368-.43-.679-.867-1.147-1.528-.359-.505-.813-1.144-1.46-2.014-.868-1.168-1.761-1.169-2.306-.779a1.64 1.64 0 00-.2 2.352c1.4 2.03 3.7 5.444 3.7 5.444l-1.658 1.118c-.001 0-1.197-1.776-2.387-3.524l-.274-.402c-.363-.534-.717-1.052-1.027-1.501a3.636 3.636 0 01.371-4.861 357.814 357.814 0 00-1.423-6.197 1.559 1.559 0 00-1.97-1.317zm38.769.205c-.379.253-.628.66-.681 1.112a367.969 367.969 0 00-1.424 6.196 3.636 3.636 0 01.372 4.861c-.31.45-.664.968-1.028 1.502l-.273.402c-1.19 1.748-2.387 3.523-2.388 3.524l-1.658-1.118s2.302-3.414 3.7-5.444a1.64 1.64 0 00-.199-2.352c-.544-.39-1.437-.39-2.307.78a97.838 97.838 0 00-1.463 2.02c-.467.658-.776 1.093-1.143 1.52a7.18 7.18 0 01-1.507 1.108c-1.405.9-3.53 2.26-4.566 3.952-1.498 2.448-.574 7.99.086 10.684h6.767a10.334 10.334 0 011.71-6.007 19.828 19.828 0 012.448-2.668 16.419 16.419 0 003.575-4.366c.496-1.017 1.024-3.888 1.458-6.943l.102-.736.099-.738c.208-1.597.385-3.17.515-4.487.267-2.727-.497-2.91-.907-3.007a1.559 1.559 0 00-1.288.205zM32.96 3.588a6.169 6.169 0 01.643 8.476l-.251.285-1.496-1.326.225-.255a4.17 4.17 0 00-6.205-5.552l-2.885 2.886-2.881-2.883a4.168 4.168 0 00-5.898 5.891L24.69 21.278l-1.392 1.435-10.49-10.178a6.167 6.167 0 018.715-8.73l1.468 1.469 1.471-1.472a6.169 6.169 0 018.498-.214zM30 12.004v4h4v2h-4v4h-2v-4h-4v-2h4v-4h2z"
});

function SvgHealthPartner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$28);
}

function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var _ref$27 = /*#__PURE__*/React.createElement("path", {
  d: "M17 16.5v2c-7.18 0-13 5.82-13 13s5.82 13 13 13c7.176-.008 12.992-5.824 13-13h2c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15zm4-15v15h12.75a2.973 2.973 0 012.908 3.72 2.947 2.947 0 01-1.362 1.841c-.462.278-.989.43-1.528.439H21v5h15v12h5c3.271 0 5 1.729 5 5v1H34v-16H19v-26h-6v-2h8zm20 40h-5v2h7.919c-.26-1.407-1.16-2-2.919-2zm-7.238-23H21v2h12.75c.186-.013.368-.068.53-.162a.958.958 0 00.437-.604.973.973 0 00-.955-1.234z"
});

function SvgHealthResources(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$27);
}

function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var _ref$26 = /*#__PURE__*/React.createElement("path", {
  d: "M39.332 4.374L40.75 5.79l-4.764 4.757a12.37 12.37 0 012.551 7.518 12.504 12.504 0 01-3.967 9.112l-4.865 4.843v6.032a5.564 5.564 0 01-5.674 5.572 5.67 5.67 0 01-5.673-5.651h2.005a3.664 3.664 0 003.668 3.65 3.581 3.581 0 003.668-3.571l.001-6.863 5.477-5.453a10.373 10.373 0 003.355-7.67c-.026-5.796-4.732-10.48-10.527-10.48-5.795 0-10.5 4.684-10.527 10.48h-2.005A12.526 12.526 0 0134.65 9.05l4.682-4.676zM19.281 24.396l1.418 1.416L8.668 37.825 7.25 36.41l12.031-12.013zm6.724-13.057a6.768 6.768 0 016.768 6.712 6.63 6.63 0 01-2.039 4.8l-5.174 5.125-1.412-1.421 5.183-5.134a4.651 4.651 0 001.436-3.37 4.763 4.763 0 00-9.524 0h-2.005a6.768 6.768 0 016.767-6.712z"
});

function SvgHearingImpairment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$26);
}

function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var _ref$25 = /*#__PURE__*/React.createElement("path", {
  d: "M43.687 8.347a11.287 11.287 0 00-16.045 0l-3.647 3.692-3.641-3.686a11.288 11.288 0 00-16.052-.006 11.6 11.6 0 000 16.212l1.464 1.483H2v2.004h5.745L23.995 44.5l19.692-19.935a11.58 11.58 0 000-16.218zm-1.422 14.809l-18.27 18.495-13.437-13.605h7.164l2.364-7.108 6 15.03 2.636-7.922h4.28v-2.004H27.28l-1.364 4.101-6-15.03-3.637 10.929h-7.7L5.723 23.15a9.594 9.594 0 010-13.394 9.291 9.291 0 0113.208.006l5.063 5.127 5.07-5.133a9.29 9.29 0 0113.2 0 9.568 9.568 0 010 13.4z"
});

function SvgHeartBeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$25);
}

function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var _ref$24 = /*#__PURE__*/React.createElement("path", {
  d: "M23.995 43.75L4.302 23.81c-4.403-4.508-4.403-11.706 0-16.213a11.289 11.289 0 0116.051.006l3.642 3.687 3.647-3.693a11.289 11.289 0 0116.045 0c4.417 4.504 4.417 11.715 0 16.219L23.995 43.75zM12.325 6.254a9.21 9.21 0 00-6.601 2.753 9.593 9.593 0 000 13.393l18.27 18.5 18.271-18.494a9.567 9.567 0 000-13.399 9.29 9.29 0 00-13.201 0l-5.07 5.131-5.063-5.125a9.22 9.22 0 00-6.606-2.76z"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$24);
}

function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var _ref$23 = /*#__PURE__*/React.createElement("path", {
  d: "M26.464 12.553a4.09 4.09 0 014.096-.007L47 22.134l-1.008 1.729-3.995-2.33V39a5.131 5.131 0 01-5 5H20A5.131 5.131 0 0115 39v-4h2v4a3.118 3.118 0 003 3h16.997a3.118 3.118 0 003-3V20.366l-10.441-6.09a2.083 2.083 0 00-2.086.005l-2.932 1.707-1.006-1.73zM13.076 19.96c.7.29 5.25 2.24 5.25 2.24.7.294 1.252.857 1.534 1.562.113.28.182.576.203.877l1.793-.798.463-.206 3.931-1.751a2.866 2.866 0 013.793 1.388 2.867 2.867 0 01-1.382 3.808c-.527.244-2.939 1.36-5.482 2.528l-.665.305-.664.305c-2.536 1.161-4.9 2.232-5.336 2.393a6.83 6.83 0 01-2.371.388 12.763 12.763 0 01-2.475-.276c-.8-.16-4.562-1.054-5.285-1.226H1V21.001h5.263a59.74 59.74 0 012.13-1.016 6.034 6.034 0 014.683-.024zm-3.87 1.852c-.15.066-.306.137-.462.21l-.312.146c-.773.365-1.475.721-1.48.723l-.213.109H3v6.498l3.732.027c.044.011 4.497 1.071 5.326 1.237a7.653 7.653 0 003.762-.025c.115-.042.416-.172.858-.368l.315-.14c1.564-.7 4.4-1.999 7.161-3.27l.59-.272c1.078-.497 2.13-.983 3.073-1.42a.865.865 0 00-.736-1.565c-.34.153-7.977 3.556-8.605 3.826-.436.17-.906.227-1.37.169a2.848 2.848 0 01-1.023-.226l-4.685-2.009.79-1.837 4.634 1.987c.136.04.275.07.416.087a.865.865 0 00.304-1.66c-.002-.001-1.205-.517-2.467-1.056l-.446-.19a419.816 419.816 0 00-2.321-.987 4.04 4.04 0 00-3.102.006zM18.471 4a4.534 4.534 0 013.506 7.401l-.179.203-1.499-1.322.153-.174a2.53 2.53 0 00-.197-3.37 2.587 2.587 0 00-3.568 0l-2.19 2.201-2.193-2.2a2.589 2.589 0 00-3.569-.003 2.559 2.559 0 000 3.591l7.141 6.956-1.394 1.434L7.33 11.75a4.53 4.53 0 016.39-6.423l.776.778.775-.779c.848-.849 2-1.326 3.2-1.326zm1.024 7.5v2h1.999v2h-1.999v2h-2v-2h-1.999v-2h1.999v-2h2z"
});

function SvgHomeNursing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$23);
}

function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var _ref$22 = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM18.003 6v2h-2v17h11.004V8h-2.004V6h2.125a1.818 1.818 0 011.879 1.88v3.587l5.996 3.997V27h-21V7.88A1.818 1.818 0 0115.882 6h2.12zm11.004 7.872v11.128h3.996v-8.464l-3.996-2.664zm-8.504 6.128v2h-2v-2h2zm3.985 0v2h-2v-2h2zm-3.985-4.5v2h-2v-2h2zm3.985 0v2h-2v-2h2zM20.503 11v2h-2v-2h2zm4 0v2h-2v-2h2zm-2-10v2h2v2h-2v2h-2V5h-2V3h2V1h2z"
});

function SvgHospitalTreatment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$22);
}

function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var _ref$21 = /*#__PURE__*/React.createElement("path", {
  d: "M18.003 1c4.03 0 7.43 3 7.93 7h1.07a4.784 4.784 0 015 5v6.234l12 7.2V47h-40V13a4.784 4.784 0 015-5h1.07c.5-4 3.9-7 7.93-7zm9.202 8.993l-.202.007h-1.07a7.992 7.992 0 01-15.86 0h-1.07a2.811 2.811 0 00-3 3v32h24V13a2.811 2.811 0 00-3-3zm4.798 11.573V45h10V27.566l-10-6zM15.503 36.5v4h-4v-4h4zm9 0v4h-4v-4h4zm-9-8v4h-4v-4h4zm9 0v4h-4v-4h4zm-9-8v4h-4v-4h4zm9 0v4h-4v-4h4zM18.003 3a6.007 6.007 0 00-6 6 6 6 0 106-6zm1 2v3h3v2h-3v3h-2v-3h-3V8h3V5h2z"
});

function SvgHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$21);
}

function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var _ref$20 = /*#__PURE__*/React.createElement("path", {
  d: "M17.377 8.548a4.093 4.093 0 014.099.005l16.465 9.581-1.005 1.729-3.997-2.326V22h-2v-5.625L20.47 10.28a2.085 2.085 0 00-2.089-.003L7.944 16.366V35a3.118 3.118 0 003 3h7.998v2h-7.999a5.13 5.13 0 01-4.999-5V17.532l-3.995 2.33-1.008-1.728zM35.94 24L34.81 40H21.07l-1.13-16h16zm7-14.048V29h2.895l1.223 11H36.824l1.222-11h2.895V9.952h2zM22.192 27.744L22.916 38h10.048l.723-10.22A8.814 8.814 0 0128.07 30h-.086a8.867 8.867 0 01-5.792-2.256zM44.046 31h-4.21l-.777 7h5.765l-.778-7zm-11.328-5h-9.505a7.04 7.04 0 004.772 2h.065a6.88 6.88 0 004.668-2z"
});

function SvgHousekeeping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$20);
}

function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var _ref$1$ = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.494 12.124A18.084 18.084 0 0146.73 28.998l.019 16.983-1.995.002-.018-16.944A16.073 16.073 0 0031.182 14.1c-.181-.029-.364-.05-.547-.071l-.105-.012a5.279 5.279 0 01-1.007 4.01l-.085.101-8.65 8.94-1.433-1.394 8.601-8.887a3.388 3.388 0 00.643-1.978 3.43 3.43 0 00-3.42-3.429c-.98.001-1.913.43-2.552 1.173l-.087.087L4.91 28.264a4.48 4.48 0 00-1.665 2.953c0 1.89 1.53 3.424 3.42 3.428.268-.01 6.19-.402 10.098-.662l1.064-.07V45.98h-1.995v-9.932c-4.317.287-9.007.596-9.167.596a5.428 5.428 0 01-5.415-5.428 6.332 6.332 0 012.347-4.458l2.68-2.376A12.97 12.97 0 1127.072 9.73a5.44 5.44 0 012.698 2.215c.577.035 1.154.09 1.724.18zm-12.182-.822l1.935-.194a5.413 5.413 0 013.434-1.7 10.981 10.981 0 10-16.9 13.643l10.92-9.678-1.495.15a1 1 0 01-.889-1.607l2.922-3.79 1.58 1.222-1.507 1.954zm16.485 18.68h1.995V45.98h-1.995v-16zM7.294 12.493l4.812 1.29a1 1 0 01.297 1.797L8.25 18.365l-1.11-1.662 2.323-1.557-2.685-.72.515-1.932z",
  fill: "currentColor"
});

function SvgHygieneArmBend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1$);
}

function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var _ref$1_ = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.501 2.37l-1.895-.62-1.08 3.33 1.894.62 1.081-3.33zm4 .38h-2v3.5h2v-3.5zm-2 6.5h2v3.5h-2v-3.5zm0 13h2v3.5h-2v-3.5zm0-6.5h2v3.5h-2v-3.5zm-7.91-1.633l1.894.62-1.08 3.33-1.896-.622 1.081-3.329zm2.007-6.185l1.895.621-1.08 3.33-1.896-.62 1.081-3.33zm-2.12 12.988l-1.896-.62-1.08 3.33 1.894.62 1.081-3.33zM36.5 23.63l-1.895.62-1.08-3.33 1.894-.62 1.081 3.33zm-3.903-5.563l1.895-.622-1.08-3.329-1.896.62 1.081 3.33zM29.396 1.748l1.081 3.33-1.895.62-1.08-3.33 1.894-.62zm1.194 10.133l1.895-.62-1.08-3.33-1.896.621 1.081 3.33zM21.892 46.25a17.377 17.377 0 01-3.365-.376c-1.12-.223-6.54-1.431-7.404-1.624H4V30.253l7.16-.013.02-.01c.534-.256 1.698-.815 2.874-1.338a7.993 7.993 0 016.204-.032c.976.407 7.302 3.115 7.302 3.115a3.6 3.6 0 012.17 3.64 9709.39 9709.39 0 008.031-3.575l.009-.003 1.127-.503a3.594 3.594 0 013.03 6.518l-.088.04c-1.382.64-15.49 7.165-16.782 7.642a9.134 9.134 0 01-3.166.515zm-15.891-4l5.45.024.009.002c.284.064 6.31 1.409 7.458 1.636a10.91 10.91 0 005.447-.052c1.04-.385 12.421-5.63 16.719-7.62a1.594 1.594 0 10-1.355-2.887c-.467.21-11.088 4.944-11.96 5.318a3.564 3.564 0 01-1.75.203 3.575 3.575 0 01-1.272-.284l-6.516-2.793.79-1.837 6.467 2.773c.225.068.456.116.69.145a1.595 1.595 0 00.598-3.063c-.002-.001-6.313-2.703-7.285-3.108a6.04 6.04 0 00-4.624.013c-1.141.508-2.27 1.05-2.802 1.305l-.038.018-.443.211H6v9.996z",
  fill: "currentColor"
});

function SvgHygieneDisinfection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1_);
}

function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var _ref$1Z = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 24C1 11.297 11.297 1 24 1c12.697.014 22.986 10.303 23 23 0 12.703-10.297 23-23 23S1 36.703 1 24zm2 0a20.96 20.96 0 008.5 16.835V27.879l-8.428-5.3-.017.245C3.027 23.214 3 23.604 3 24zm21 21a20.84 20.84 0 01-10.76-3h21.52A20.84 20.84 0 0124 45zM13.5 27.848V40h21V27.848C33.005 27.093 28.457 25 24 25s-9.005 2.093-10.5 2.848zM24 23c-5.072 0-10.029 2.35-11.53 3.126l-9.136-5.745C5.082 10.334 13.802 3 24 3s18.918 7.334 20.666 17.381l-9.137 5.745C34.03 25.35 29.072 23 24 23zm12.5 4.879v12.956A20.96 20.96 0 0045 24c0-.397-.028-.787-.055-1.176a65.282 65.282 0 01-.017-.245l-8.428 5.3zM18 29.5h12v2H18v-2zm12 5H18v2h12v-2zm-12.5-16a2 2 0 11-4 0 2 2 0 014 0zm15 2a2 2 0 100-4 2 2 0 000 4z",
  fill: "currentColor"
});

function SvgHygieneMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1Z);
}

function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var _ref$1Y = /*#__PURE__*/React.createElement("path", {
  d: "M23.999.838l.643.535A37.61 37.61 0 0041.159 8.45l.841.135V28.14c0 6.443-11.353 17.637-17.796 18.979l-.204.043-.204-.043C17.353 45.777 6 34.583 6 28.14V8.585l.84-.135a37.607 37.607 0 0016.518-7.076L24 .838zM24 3.408a39.7 39.7 0 01-16 6.87V28.14c0 5.422 10.37 15.61 16 16.975 5.63-1.365 16-11.553 16-16.975V10.28a39.7 39.7 0 01-16-6.87zm0 27.148l.698 1.427 1.562.229-1.13 1.11.267 1.569L24 34.15l-1.397.74.267-1.568-1.13-1.111 1.562-.23.698-1.426zm5.238-1.428l.698 1.427 1.562.229-1.13 1.11.267 1.569-1.397-.74-1.397.74.267-1.568-1.13-1.111 1.562-.23.698-1.426zm-10.443 0l.699 1.427 1.561.229-1.13 1.11.267 1.569-1.397-.74-1.396.74.266-1.568-1.13-1.111 1.562-.23.698-1.426zm14.374-3.868l.699 1.427 1.561.229-1.13 1.11.267 1.569-1.397-.741-1.396.74.266-1.568-1.13-1.11 1.562-.23.698-1.426zm-18.254 0l.699 1.427 1.561.229-1.13 1.11.267 1.569-1.397-.741-1.396.74.266-1.568-1.13-1.11 1.562-.23.698-1.426zm19.575-5.29l.698 1.428 1.562.229-1.13 1.11.267 1.569-1.397-.741-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.426zm-20.98 0l.698 1.428 1.562.229-1.13 1.11.267 1.569-1.397-.741-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.426zm19.575-5.286l.698 1.427 1.562.228-1.13 1.11.266 1.569-1.396-.74-1.397.74.267-1.568-1.13-1.111 1.561-.228.699-1.427zm-18.17 0l.699 1.427 1.561.228-1.13 1.11.267 1.569-1.397-.74-1.396.74.266-1.568-1.13-1.111 1.562-.228.698-1.427zm3.847-3.865l.699 1.427 1.561.229-1.13 1.11.267 1.569-1.397-.741-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.426zm10.476 0l.698 1.427 1.562.229-1.13 1.11.267 1.569-1.397-.741-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.426zM24 9.39l.698 1.427 1.562.229-1.13 1.11.267 1.569L24 12.985l-1.397.74.267-1.568-1.13-1.11 1.562-.23L24 9.392z"
});

function SvgInsuranceEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1Y);
}

function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var _ref$1X = /*#__PURE__*/React.createElement("path", {
  d: "M24 47.163l-.204-.043C17.353 45.778 6 34.584 6 28.14V8.586l.84-.135a37.468 37.468 0 0016.518-7.076l.641-.538.643.537A37.61 37.61 0 0041.159 8.45l.841.135v19.555c0 6.443-11.353 17.637-17.796 18.979l-.204.043zM8 10.28V28.14c0 5.422 10.37 15.609 16 16.975 5.63-1.365 16-11.553 16-16.975V10.28a39.707 39.707 0 01-16-6.87 39.707 39.707 0 01-16 6.87z"
});

function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1X);
}

function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var _ref$1W = /*#__PURE__*/React.createElement("path", {
  d: "M39 28a3.003 3.003 0 013 3v1h2a3.003 3.003 0 013 3v8a3.003 3.003 0 01-3 3H30a3.003 3.003 0 01-3-3v-8a3.003 3.003 0 013-3h2v-1a3.003 3.003 0 013-3zm5 6H30a1 1 0 00-1 1v8a1 1 0 001 1h14a1 1 0 001-1v-8a1 1 0 00-1-1zm-33.004-4v6.956c0 .726.323 1.049 1.048 1.049h9.136l-2.286-2.29 1.41-1.414 4.697 4.704-4.697 4.705-1.41-1.414 2.286-2.291h-9.136A2.884 2.884 0 019 36.956V30h1.995zM38 35.5V38h2.5v2H38v2.5h-2V40h-2.5v-2H36v-2.5h2zm1-5.5h-4a1 1 0 00-1 1v1h6v-1a1 1 0 00-1-1zM5 7v2H3v17h11.004V9.001L12.001 9V7h2.125a1.819 1.819 0 011.88 1.88v3.548L22 15.926V28H1V8.88A1.819 1.819 0 012.88 7H5zm11.004 7.744V26h3.996v-8.926l-3.996-2.33zm7.687-10.449L25.1 5.71 22.818 8H34.96A2.882 2.882 0 0138 11.05V26h-1.993V11.05c0-.726-.323-1.05-1.047-1.05H22.818l2.283 2.29-1.41 1.415L19.002 9l4.69-4.705zM7.5 21v2h-2v-2h2zm3.955 0v2h-2v-2h2zm-3.955-4.5v2h-2v-2h2zm3.955 0v2h-2v-2h2zM7.501 12v2h-2v-2h2zm4 0v2h-2v-2h2zm-2-10v2h2v2h-2v2h-2V6h-2V4h2V2h2z"
});

function SvgIntegratedCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1W);
}

function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var _ref$1V = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM27.967 1c1.12.016 2.022.92 2.036 2.04v3.96h5.5a2.002 2.002 0 012 2v14a2.002 2.002 0 01-2 2h-23a2.002 2.002 0 01-2-2V9a2.002 2.002 0 012-2h5.5V3.015A1.983 1.983 0 0119.947 1zm7.536 14h-23v8h23.001v-8zm0-6h-23v4h23V9zM19.947 3l.042 4h8.014V3.04l-8.056-.04z"
});

function SvgJobOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1V);
}

function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var _ref$1U = /*#__PURE__*/React.createElement("path", {
  d: "M14 24a2 2 0 012 2h2a4 4 0 00-8 0h2a2 2 0 012-2zM28 22a4 4 0 00-4 4h2a2 2 0 014 0h2a4 4 0 00-4-4zM30.545 31.356c-6.284 3.211-12.535 3.21-19.107 0a1 1 0 00-1.407 1.148 11.328 11.328 0 0021.938-.011 1 1 0 00-1.424-1.139zM21 39a9.321 9.321 0 01-8.193-4.864 21.865 21.865 0 0016.369.033A9.323 9.323 0 0121 39z"
});

var _ref2$4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.492 21.653l-6.923-2.04 3.86-5.836a2.639 2.639 0 00-2.6-4.065l-9.342 1.441.488-6.885a3.035 3.035 0 00-4.988-2.532l-9.145 7.737a18.991 18.991 0 1015.989 33.368l5.971 1.6a1.862 1.862 0 00.47.062 1.784 1.784 0 001.592-2.57l-2.4-4.9L43.808 37a2.075 2.075 0 001.417-3.582l-4.8-4.549 5.5-2.891a2.345 2.345 0 00-.43-4.325zm-5.361-9.965a.639.639 0 01.63.986l-3.582 5.415a19.1 19.1 0 00-4.73-5.216zM27.276 3.263a1.035 1.035 0 011.7.863l-.456 6.433A18.888 18.888 0 0021 9c-.18 0-.355.022-.534.027zM4 28a17 17 0 1117 17A17.019 17.019 0 014 28zm30.6 13.243a19.087 19.087 0 002.3-2.866l1.963 4.006zM43.8 35l-5.161.027a18.825 18.825 0 001.106-4.048l4.107 3.89zm1.19-10.792l-5.048 2.654a18.85 18.85 0 00-1-5.054l5.984 1.763a.345.345 0 01.063.637z"
});

function SvgJolinchen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1U, _ref2$4);
}

function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var _ref$1T = /*#__PURE__*/React.createElement("path", {
  d: "M41 1v46H12a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h29zm-2 37.955H12a3.003 3.003 0 00-3 3V42a3.003 3.003 0 003 3h27v-6.045zM39 3H12a3.003 3.003 0 00-3 3v31.983a4.95 4.95 0 013-1.028h27V3zm-15.591 8.155a7.072 7.072 0 015.282 1.963l-1.578 1.228a5.294 5.294 0 00-3.575-1.195 2.404 2.404 0 00-2.066 1.208c-.13.331-.135.698-.012 1.032.46.791 1.752 1.064 3.119 1.352 1.89.4 4.245.897 4.577 3.312l.01.137a3.588 3.588 0 01-1.316 2.737 3.127 3.127 0 011.022 3.381c-.755 2.627-3.771 2.782-4.763 2.832l-.06.003-.06-.004c-2.483-.172-3.654-.897-5.495-2.566l1.344-1.482c1.507 1.366 2.27 1.904 4.229 2.048 2.238-.125 2.712-.787 2.874-1.352.164-.649.192-1.25-1.19-1.74-.279-.05-1.325-.223-2.232-.374l-.377-.062-1.074-.178a3.567 3.567 0 01-2.96-2.828 3.365 3.365 0 011.557-3.17 3.424 3.424 0 01-1.002-1.163l-.047-.102a3.386 3.386 0 01.126-2.816 4.39 4.39 0 013.667-2.2zm-.531 7.251c-1.208.611-1.872 1.32-1.788 1.925a1.59 1.59 0 001.299 1.131c1.698.28 2.643.436 3.178.526.97-.386 1.56-1.025 1.597-1.728-.163-.868-1.098-1.159-2.999-1.56a27.443 27.443 0 01-1.287-.294z"
});

function SvgLaw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1T);
}

function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var _ref$1S = /*#__PURE__*/React.createElement("path", {
  d: "M30 0c8.015 0 15.546 3.12 21.215 8.788C56.883 14.457 60 21.988 60 30.003s-3.12 15.546-8.785 21.212C45.549 56.88 38.015 60 30 60s-15.546-3.12-21.215-8.785C3.117 45.549 0 38.015 0 30.003c0-8.015 3.12-15.546 8.785-21.215C14.451 3.12 21.985 0 30 0zm0 3.158C15.199 3.158 3.158 15.198 3.158 30c0 14.801 12.04 26.842 26.842 26.842 14.801 0 26.842-12.04 26.842-26.842 0-14.801-12.04-26.842-26.842-26.842zm-.07 3.94c2.168 2.292 4.275 4.523 6.322 6.997 1.385 2.11 1.626 5.487.361 7.719-1.204 2.11-3.461 3.754-5.87 3.995v10.909l5.75-3.445a30.433 30.433 0 01-.421-1.93c-.362-2.835.602-5.428 2.89-7.177 1.927-1.508 4.576-1.99 7.045-1.267l7.165 1.568-2.83 9.047c-1.265 2.352-3.492 3.98-6.142 4.161-2.589.181-4.997-.844-6.623-2.895-2.348 1.146-4.576 2.594-6.864 3.981v1.532l.001.234v1.318l.001.285.001 2.056v3.235l-.001.125v.188l-.002.11 17.68.008c-.023-.007-1.634 1.93-1.634 1.93H13.214l-1.633-1.93 17.333-.007-.007-9.069c.045-.015-6.692-3.973-6.744-4.056-1.987 2.292-4.757 3.438-7.767 2.714-2.289-.482-4.637-2.533-5.42-4.825l-2.468-8.142c2.95-.723 6.082-1.387 9.152-1.99 2.71-.12 5.239 1.086 6.804 3.378 1.385 1.99 1.626 5.005.662 7.237l5.78 3.618c.01.201.015-.46.017-1.543l.001-.455v-.753l.001-.268V26.384c0-.398.002-.635.004-.642-2.709-.362-5.502-2.42-6.224-5.134-.722-2.473-.301-5.307 1.385-7.177zm15.716 17.61c-2.048-.542-4.215-.3-5.781 1.086-1.806 1.448-2.348 3.8-1.806 5.971.421 1.689 1.866 3.196 3.492 3.74 1.626.602 3.673.421 5.058-.544 3.13-2.05 2.95-6.03 4.154-9.106zM21.32 27.665c-.963-2.11-3.07-3.498-5.419-3.317-1.006.155-1.98.354-2.943.565l-1.922.426c-.641.14-1.285.276-1.94.396l-.24.18.482 1.63c.227.618.42 1.287.616 1.966l.133.454.136.454c.694 2.268 1.628 4.455 4.233 5.086 2.228.663 4.576 0 6.081-1.749 1.385-1.628 1.746-4.1.783-6.091zm8.61-17.791c-.454.618-.992 1.195-1.554 1.756l-.378.373c-2.027 1.978-4.191 3.85-3.788 6.857.12 2.17 1.867 4.221 3.854 4.825 2.227.723 4.636.06 6.202-1.69 1.143-1.386 1.685-3.376 1.143-5.186-.963-2.713-3.672-4.764-5.479-6.935z"
});

function SvgLebensbaum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), _ref$1S);
}

function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var _ref$1R = /*#__PURE__*/React.createElement("path", {
  d: "M15.085 8c.184 0 .365.05.522.147l8.096 4.957H41a5.006 5.006 0 015 5V35a5.006 5.006 0 01-5 5H7a5.006 5.006 0 01-5-5V13a5.006 5.006 0 015-5h8.085zm-.282 2H7a3.003 3.003 0 00-3 3v22a3.003 3.003 0 003 3h34a3.003 3.003 0 003-3V18.104a3.003 3.003 0 00-3-3H23.42a.997.997 0 01-.522-.148L14.803 10zm8.783 7.51a6.897 6.897 0 015.197 1.964l-1.553 1.228a5.159 5.159 0 00-3.517-1.195 2.36 2.36 0 00-2.033 1.208 1.474 1.474 0 00-.012 1.031c.453.791 1.724 1.064 3.069 1.352 1.86.4 4.176.897 4.503 3.312l.01.137a3.61 3.61 0 01-1.295 2.737 3.16 3.16 0 011.006 3.381c-.743 2.627-3.71 2.782-4.687 2.832l-.058.003-.059-.004c-2.444-.172-3.596-.897-5.407-2.566l1.322-1.482c1.483 1.366 2.234 1.904 4.161 2.048 2.202-.125 2.668-.787 2.828-1.352.161-.649.189-1.25-1.171-1.74-.216-.039-.897-.154-1.612-.275l-.39-.066-1.622-.273a3.536 3.536 0 01-2.91-2.828 3.387 3.387 0 011.53-3.17 3.408 3.408 0 01-.986-1.163l-.046-.102a3.435 3.435 0 01.124-2.815 4.31 4.31 0 013.608-2.201zm-.523 7.251c-1.188.611-1.841 1.32-1.759 1.925a1.572 1.572 0 001.278 1.131l2.08.35.324.054.723.122a2.176 2.176 0 001.571-1.728c-.16-.868-1.08-1.159-2.95-1.56a26.608 26.608 0 01-1.267-.294z"
});

function SvgLegalDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1R);
}

function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var _ref$1Q = /*#__PURE__*/React.createElement("path", {
  d: "M37.998 1a5.006 5.006 0 015 5v5h-2V6a3.003 3.003 0 00-3-3h-31a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h31a3.003 3.003 0 003-3v-5h2v5a5.006 5.006 0 01-5 5h-31a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h31zm-10 16a9.12 9.12 0 014.474 1.129l.386.225.09.439c2.03 10.01 3.23 16.01 3.23 16.01l.24 1.197h-4.92v4h-2v-6h4.48c-.436-2.17-1.448-7.203-2.896-14.346a7.844 7.844 0 00-6.17 0A7899.338 7899.338 0 0022.02 34h4.479v6h-2v-4h-4.919l.24-1.196s1.199-6.001 3.226-16.01l.089-.439.386-.226A8.993 8.993 0 0127.998 17zm-10.016 1.333l.516.286V29.98h-2.5V40h-2V27.977h2.5v-8.153a9.933 9.933 0 00-8 0v8.153h2.5V40h-2V29.98h-2.5V18.618l.516-.285a11.951 11.951 0 0110.968 0zM44.586 27l1.416 1.412-4.005 4.017-3.999-4.018 1.418-1.41 2.583 2.594L44.586 27zm-2.583-11.429l3.999 4.018-1.418 1.41-2.583-2.594L39.414 21l-1.416-1.412 4.005-4.017zM12.498 7a4 4 0 110 8 4 4 0 010-8zm15.5 0a4 4 0 110 8 4 4 0 010-8zm-15.5 2a2 2 0 100 4 2 2 0 000-4zm15.5 0a2 2 0 100 4 2 2 0 000-4z"
});

function SvgLift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1Q);
}

function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var _ref$1P = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.735 29.593C13.058 25.569 10 20.973 10 15.347 10.054 7.662 16.315 1.47 24 1.5c7.685-.031 13.947 6.162 14 13.847 0 5.294-2.83 9.662-5.3 13.477-.556.858-1.094 1.688-1.577 2.494-.077.127-.483 3.037-1.217 8.73a3.002 3.002 0 01-1.475 2.215A9.89 9.89 0 0128 42.5c-.295 2.19-1.742 4-4 4-2.264 0-3.712-1.8-4-4a9.865 9.865 0 01-.423-.239 3 3 0 01-1.449-2.19c-.75-5.703-1.161-8.609-1.233-8.717-.37-.575-.76-1.162-1.16-1.76v-.001zM24 3.5c-6.54 0-11.875 5.234-12 11.772 0 4.75 2.69 8.827 5.311 12.798.316.478.63.954.939 1.43.525-.007 1.442-.007 2.75 0l-.835-10.847A2 2 0 0122.16 16.5h3.68a2 2 0 011.994 2.153L27 29.5c1.267-.007 2.167-.007 2.7 0 .465-.762.955-1.523 1.447-2.29C33.545 23.481 36 19.66 36 15.271 35.875 8.734 30.54 3.5 24 3.5zm-1.796 15h3.608L25 29.5h-2l-.796-11zM28.5 35.503l.596-3.983H18.904l.596 3.983h9zm-8.382 4.15l-.332-2.153h8.497l-.349 2.16a1 1 0 01-.987.84h-5.84a1 1 0 01-.989-.847zm5.883 2.847h-3.999A1.955 1.955 0 0024 44.497a1.957 1.957 0 002.001-1.997z",
  fill: "currentColor"
});

function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1P);
}

function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var _ref$1O = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.352 16.5h6.718l-2.974-15H4.444l-2.796 15h6.704v28h-3v2h8v-2h-3v-28zm-4.246-13h6.347l2.181 11H4.055l2.05-11zm34.246 21h6v18h-5.5v4h-2v-4h-16.5v4h-2v-4h-4.5v-18h6v-3a5.006 5.006 0 015-5h8.5a5.006 5.006 0 015 5v3zm-13.5-6a3.003 3.003 0 00-3 3v11h14.5v-11a3.003 3.003 0 00-3-3h-8.5zm17.5 22h-26.5v-14h4v8h18.5v-8h4v14z",
  fill: "currentColor"
});

function SvgLivingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1O);
}

function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var _ref$1N = /*#__PURE__*/React.createElement("path", {
  d: "M23.99 1C34.533 1.079 43.03 9.664 43 20.207c.005 7.589-3.703 12.095-18.321 26.594l-.703.699-.704-.7c-.437-.433-.865-.858-1.282-1.275l-.823-.822C8.343 31.872 5.005 27.443 5 20.173A19.119 19.119 0 0110.617 6.56 18.756 18.756 0 0123.97 1h.019zm-.002 2.004h-.017a16.769 16.769 0 00-11.94 4.973A17.128 17.128 0 007 20.172c.004 6.148 2.364 9.851 15.302 22.834l.822.824.85.848C38.294 30.442 40.953 26.628 41 20.398v-.19c.03-9.44-7.573-17.129-17.012-17.204zM24 12a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 110-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6z"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1N);
}

function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var _ref$1M = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.766 10.86a1.416 1.416 0 00-.588-.11 3.604 3.604 0 00-3.677 3.234v7.648a3.798 3.798 0 01-3.502-3.775V4.249h-2v13.608a3.798 3.798 0 01-3.5 3.775v-7.579l-.003-.07a3.604 3.604 0 00-3.676-3.234 1.418 1.418 0 00-.588.11C9.948 11.408.499 20.41.502 40.517a3.508 3.508 0 003.584 3.233c.394 0 .84 0 11.176-6.008a8.531 8.531 0 004.237-7.35v-6.744a5.803 5.803 0 004.5-2.537 5.803 5.803 0 004.5 2.537v6.743a8.53 8.53 0 004.236 7.35c10.337 6.01 10.783 6.01 11.177 6.01a3.52 3.52 0 003.587-3.303c0-20.038-9.45-29.04-14.733-29.587zM17.499 30.39a6.527 6.527 0 01-3.241 5.622c-8.033 4.67-9.874 5.566-10.293 5.733a1.485 1.485 0 01-1.466-1.298c0-18.795 8.672-27.38 13.095-27.61l.373-.02.06-.057c.743.04 1.357.597 1.472 1.333V30.39zm16.241 5.622c8.033 4.67 9.874 5.566 10.293 5.733a1.495 1.495 0 001.468-1.368c-.002-18.725-8.674-27.31-13.098-27.54l-.372-.02-.058-.055a1.578 1.578 0 00-1.474 1.331V30.39a6.527 6.527 0 003.241 5.622z",
  fill: "currentColor"
});

function SvgLungsBreathSystem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1M);
}

function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var _ref$1L = /*#__PURE__*/React.createElement("path", {
  d: "M15.269 5A12.339 12.339 0 0124 8.551a12.339 12.339 0 018.731-3.55H47v32.01H32.731c-2.626 0-6.215 1.162-7.894 3.716L24 42l-.836-1.272c-1.68-2.555-5.27-3.718-7.896-3.718H1V5zm0 1.995H3v28.02h12.269c2.794.01 5.51.933 7.731 2.628V10.507c-1.735-2.403-5.181-3.512-7.731-3.512zm29.731 0H32.731c-2.55 0-5.996 1.109-7.731 3.512v27.136a12.814 12.814 0 017.731-2.628H45V6.995zM42 27.5v2H28.5v-2H42zm0-4.5v2H28.5v-2H42zm-22.5-9v10H6V14h13.5zm-2 2H8v6h9.5v-6zM42 18.5v2H28.5v-2H42zM34.5 14v2h-6v-2h6z"
});

function SvgMagazin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1L);
}

function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var _ref$1K = /*#__PURE__*/React.createElement("path", {
  d: "M44.032 4.957h-1.978v-.99A2.971 2.971 0 0039.086 1h-3.957a2.971 2.971 0 00-2.968 2.968v.989h-1.978a2.971 2.971 0 00-2.968 2.968v7.914a2.971 2.971 0 002.968 2.967h13.85A2.971 2.971 0 0047 15.84V7.925a2.971 2.971 0 00-2.968-2.968zm-9.892-.99a.99.99 0 01.989-.989h3.957a.99.99 0 01.99.99v.989H34.14v-.99zm-3.957 2.968h13.85a.99.99 0 01.989.99v1.484H29.194V7.925a.99.99 0 01.989-.99zm13.85 9.893h-13.85a.99.99 0 01-.99-.99v-4.45h15.829v4.45a.99.99 0 01-.99.99zM17.98 26.226c-4.364 0-7.914-3.55-7.914-7.914s3.55-7.914 7.914-7.914 7.914 3.55 7.914 7.914c0 4.363-3.55 7.914-7.914 7.914zm0-13.85a5.942 5.942 0 00-5.936 5.936 5.942 5.942 0 005.936 5.935 5.942 5.942 0 005.936-5.935 5.942 5.942 0 00-5.936-5.936zm0 34.624c-7.807 0-14.866-5.303-16.785-12.609L1 33.647l.673-.373c4.753-2.631 10.544-4.08 16.307-4.08 5.763 0 11.554 1.449 16.307 4.08l.673.373-.195.744C32.846 41.697 25.787 47 17.98 47zM3.327 34.633c1.963 6.064 8 10.389 14.653 10.389 6.654 0 12.69-4.325 14.653-10.389-4.33-2.236-9.5-3.461-14.653-3.461-5.154 0-10.324 1.225-14.653 3.461z"
});

function SvgManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1K);
}

function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var _ref$1J = /*#__PURE__*/React.createElement("path", {
  d: "M45.036 5.683a1.977 1.977 0 00-1.96-.063L31 11.917 18.388 5.34a3 3 0 00-2.775 0L3.075 11.878A1.997 1.997 0 002 13.652v26.454a2 2 0 002.924 1.774L17 35.583l12.612 6.577a3 3 0 002.775 0l12.538-6.538A1.997 1.997 0 0046 33.848V7.394a1.985 1.985 0 00-.964-1.711zM4 40.106V13.652l12-6.257v26.453L4 40.106zm14-6.258V7.394l12 6.258v26.454l-12-6.258zm26 0l-12 6.257V13.652l12-6.258v26.454z"
});

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1J);
}

function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var _ref$1I = /*#__PURE__*/React.createElement("path", {
  d: "M34.533 25.536a5.25 5.25 0 113.712 8.96 5.293 5.293 0 01-.786-.075 6.059 6.059 0 01-1.57 5.777l-5.024 5.024a6.053 6.053 0 01-7.514.843 18.467 18.467 0 01-5.856.936c-7.837 0-14.104-4.583-15.967-11.675l-.198-.752.68-.377a30.817 30.817 0 0125.273-2.576l.015-.015a6.05 6.05 0 015.776-1.571 5.234 5.234 0 011.46-4.499zm-8.844 7.68a28.694 28.694 0 00-22.007 2.352C5.54 41.325 10.878 45 17.495 45a16.675 16.675 0 004.17-.525 6.07 6.07 0 01.61-7.845zm-3.13 7.065a4.065 4.065 0 001.13 3.527 4.082 4.082 0 005.762 0l1.294-1.293zm6.54-7.576a4.012 4.012 0 00-.387.316l-5.024 5.024c-.112.122-.217.25-.314.385l7.87 2.148zm6.128 1.346a4.065 4.065 0 00-4.278-2.16l2.232 8.187 1.294-1.294a4.065 4.065 0 00.752-4.733zm5.317-7.1a3.249 3.249 0 100 4.597 3.257 3.257 0 000-4.597zM17.569 6c7.183 0 13.02 5.795 13.074 12.978-.005 1.822-.3 3.63-.874 5.36l-.242.65h-5.448a8.542 8.542 0 01-13.02 0H5.613l-.242-.65a17.181 17.181 0 01-.874-5.36c.053-7.183 5.89-12.977 13.073-12.977zm2.931 9.58a25.666 25.666 0 01-8.71 2.621c.223 1.164.624 3.115 1.147 5.581l.08.381a6.55 6.55 0 009.053.045l.193-.55c.264-.75 1.065-3.058 1.526-4.688a13.407 13.407 0 01-3.289-3.39zM17.622 8C11.52 7.967 6.543 12.878 6.496 18.979c.01 1.355.191 2.703.54 4.012h3.689c-.446-2.124-1.003-4.826-1.105-5.578l-.149-1.095 1.106-.038a23.619 23.619 0 009.75-2.874l.856-.502.51.853c.017.03 1.733 2.878 3.695 3.832l.725.352-.19.782c-.28 1.153-.872 2.966-1.314 4.268h3.494c.348-1.31.53-2.657.54-4.012C28.624 12.907 23.693 7.995 17.622 8zm18.344-2A8.575 8.575 0 0146.67 1.51l-.682 1.88A6.576 6.576 0 0038.24 6h4.255v2h-5.123a6.394 6.394 0 00-.042 3h5.165v2H38.14a6.578 6.578 0 007.823 2.787l.67 1.884a8.586 8.586 0 01-10.746-4.67h-3.39v-2h2.803a8.13 8.13 0 01.025-3h-2.829V6z"
});

function SvgMaternityBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1I);
}

function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var _ref$1H = /*#__PURE__*/React.createElement("path", {
  d: "M31 42.5v2H6v-2h25zm14-18a2.003 2.003 0 011.994 1.85l.006.15v16a2.003 2.003 0 01-1.85 1.994L45 44.5h-9a2.003 2.003 0 01-1.994-1.85L34 42.5v-16a2.003 2.003 0 011.85-1.994L36 24.5h9zm0 2h-9v16h9.002L45 26.5zm-4.5 11a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-30.357-34A8.183 8.183 0 0115.5 5.492a8.185 8.185 0 015.031-1.986l.327-.006H30v13h9.5a2.003 2.003 0 011.994 1.85l.006.15v3h-2v-3H30v4.98h-9.142a5.686 5.686 0 00-4.525 2.075.953.953 0 01-1.664 0 5.347 5.347 0 00-3.4-1.97L11 23.55V37.5h20v2H11a2.003 2.003 0 01-1.994-1.85L9 37.5V23.48H1V3.5h9.143zM28 5.5h-7.142a5.84 5.84 0 00-4.167 1.671l-.191.197v15.355a8.538 8.538 0 014.004-1.232l.354-.01H28V5.5zm-17.857 0H3v15.98h7.143c1.42.013 2.811.38 4.05 1.065l.307.178V7.368A5.839 5.839 0 0010.143 5.5z"
});

function SvgMedialOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1H);
}

function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var _ref$1G = /*#__PURE__*/React.createElement("path", {
  d: "M42.06 25.263l1.624-1.608c4.422-4.45 4.422-11.634 0-16.084-4.433-4.42-11.606-4.42-16.04 0l-3.649 3.66-3.645-3.654A11.325 11.325 0 001 15.61a11.295 11.295 0 003.3 8.033l19.715 20.113 5-5.322a1.923 1.923 0 001.986 1.846h4a1.936 1.936 0 002-2.003V33.27h5a1.936 1.936 0 002.001-2.003V27.26a1.93 1.93 0 00-1.942-1.998zM23.987 40.87L5.721 22.233a9.353 9.353 0 1113.214-13.24l5.06 5.073 5.065-5.08a9.359 9.359 0 0113.208 0 9.4 9.4 0 01-.002 13.256l-3.019 3.016h-2.245V20.25a1.936 1.936 0 00-2-2.003h-4a1.936 1.936 0 00-2 2.003v5.008h-5A1.936 1.936 0 0022 27.26v4.006a1.936 1.936 0 002 2.003h5v2.263l-5.014 5.337zm18.015-9.603h-7v7.01h-4v-7.01h-7V27.26h7v-7.01h4v7.01h7v4.006z"
});

function SvgMedicineCare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1G);
}

function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var _ref$1F = /*#__PURE__*/React.createElement("path", {
  d: "M36 27.04h-8.97l9.012-8.997c3.898-3.905 3.893-10.231-.012-14.13C32.125.015 25.799.02 21.9 3.925L4.93 20.867A9.984 9.984 0 003.104 32.48 9.964 9.964 0 0012 47.007h24a9.983 9.983 0 100-19.966zM23.314 5.338a7.993 7.993 0 0111.314 11.294l-7.779 7.766-11.313-11.295 7.778-7.765zM6.344 22.279l7.778-7.765 11.313 11.294-7.778 7.765A7.993 7.993 0 016.344 22.28zM4 37.024a7.997 7.997 0 01.441-2.578c.158.182.315.366.488.54 3.911 3.891 10.232 3.891 14.142 0L23 31.062V45.01H12a8.002 8.002 0 01-8-7.986zm32 7.986H25V29.066l.03-.029H36a7.987 7.987 0 110 15.973z"
});

function SvgMedicines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1F);
}

function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var _ref$1E = /*#__PURE__*/React.createElement("path", {
  d: "M34.517 24.25a10.881 10.881 0 019.967 0l.516.285V32h2v2H31v3h-2v-9.89a12.148 12.148 0 00-10 0V37h-2v-3H1v-2h2v-7.465l.517-.285a10.881 10.881 0 019.967 0l.516.285V32h3v-6.09l.516-.285a13.75 13.75 0 0112.968 0l.516.285V32h3v-7.465zM12 25.741a8.859 8.859 0 00-7 0V32h7zm31 0a8.859 8.859 0 00-7 0V32h7zM24 11a5.5 5.5 0 010 11 5.507 5.507 0 01-5.5-5.5A5.5 5.5 0 0124 11zM8.5 13a4 4 0 110 8 4 4 0 010-8zm31 0a4 4 0 110 8 4 4 0 010-8zM24 13a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8.5 15a2 2 0 100 4 2 2 0 000-4zm31 0a2 2 0 100 4 2 2 0 000-4z"
});

function SvgMeetingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1E);
}

function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var _ref$1D = /*#__PURE__*/React.createElement("path", {
  d: "M34.068 6v26.223l-20.043-3.185v10.478a3.507 3.507 0 01-7.014 0V28.07H4.004A2 2 0 012 26.079V12.144a2 2 0 012.004-1.99h3.93L34.068 6zM9.015 28.242v11.274a1.503 1.503 0 003.006 0V28.72l-3.006-.477zM32.063 8.335L9.015 11.997v14.229l23.048 3.662V8.335zm5.418 14.844L46.5 27.16l-.814 1.82-9.019-3.982.814-1.819zM7.011 12.144H4.004V26.08h3.007V12.144zm39.082 5.972v1.991h-9.02v-1.99h9.02zm-.407-8.872l.814 1.819-9.019 3.982-.814-1.82 9.019-3.981z"
});

function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1D);
}

function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var _ref$1C = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.804 10.186C16.042 9.527 8.284 15.812 7.11 24.52c-.092.69-.142 1.386-.148 2.082l-2-.02c.007-.778.063-1.556.166-2.328 1.318-9.76 10.014-16.8 19.835-16.06l-3.993-3.89 1.395-1.431 6.339 6.174-6.175 6.34-1.433-1.397 3.707-3.804zM8.569 33.563C12.291 41.53 21.592 45.2 29.752 41.92a17 17 0 001.885-.894l.968 1.75c-.681.377-1.386.71-2.109 1-9.146 3.691-19.58-.428-23.739-9.372l-1.423 5.387L3.4 39.28l2.26-8.556 8.557 2.26-.511 1.934-5.137-1.356zm35.496 2.081l-5.367 1.492c5.604-8.11 3.892-19.185-3.9-25.222a18.889 18.889 0 00-1.928-1.315l-1.022 1.719c.598.356 1.174.748 1.724 1.176 6.952 5.387 8.481 15.268 3.482 22.505l-1.422-5.12-1.927.535 2.369 8.527 8.526-2.37-.535-1.927zM23.56 18.342l.699.686c5.018 4.916 6.29 6.466 6.293 9.237a6.985 6.985 0 01-6.99 6.977h-.012a7.01 7.01 0 01-6.998-6.987c-.002-2.753 1.275-4.302 6.308-9.228l.7-.685zM21.523 31.22a2.03 2.03 0 001.622 1.98c.053.005.105.013.157.02.084.011.167.023.254.023a2.02 2.02 0 002.023-2.015c0-.656-.256-1.124-2.024-2.896-1.817 1.815-2.032 2.24-2.032 2.888zm6.054-.028c-.013-1.6-.829-2.538-3.321-4.98l-.7-.686-.7.684c-2.498 2.445-3.317 3.384-3.33 4.972a4.934 4.934 0 01-.974-2.928c-.002-1.785.768-2.926 5.007-7.109 4.223 4.174 4.991 5.318 4.992 7.123a4.904 4.904 0 01-.974 2.924z",
  fill: "currentColor"
});

function SvgMetabolism(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1C);
}

function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var _ref$1B = /*#__PURE__*/React.createElement("path", {
  d: "M13 17v6.466c0 6.352 5.149 11.5 11.5 11.5S36 29.818 36 23.466V17h2v6.466c-.005 7.068-5.453 12.94-12.5 13.473v6.562h8.314V45.5H15.186v-1.999H23.5v-6.562c-7.047-.534-12.495-6.405-12.5-13.473V17h2zM24.5 2a8.5 8.5 0 018.5 8.5v13a8.51 8.51 0 01-8.5 8.5 8.51 8.51 0 01-8.5-8.5v-13A8.5 8.5 0 0124.5 2zm0 2a6.5 6.5 0 00-6.5 6.5v13a6.5 6.5 0 0013 0v-13A6.5 6.5 0 0024.5 4z"
});

function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1B);
}

function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var _ref$1A = /*#__PURE__*/React.createElement("path", {
  d: "M36.679 25.335a4.655 4.655 0 015.437 1.056 4.768 4.768 0 010 6.719 4.71 4.71 0 01-3.348 1.389c-.151 0-.3-.029-.45-.043a6.011 6.011 0 01-1.523 5.817l-4.95 4.968a5.918 5.918 0 01-6.74 1.191 17.97 17.97 0 01-4.494.57c-7.68 0-14.075-4.72-15.913-11.747l-.198-.752.678-.377a31.937 31.937 0 0115.433-4.125c2.837.01 5.66.415 8.385 1.204a5.955 5.955 0 015.084-.98 4.655 4.655 0 012.599-4.89zM20.61 32a29.812 29.812 0 00-13.766 3.497c1.853 5.717 7.286 9.505 13.766 9.505a16.287 16.287 0 002.41-.184 6.021 6.021 0 01.343-8.089l3.903-3.916a28.338 28.338 0 00-6.656-.813zm3.052 8.362a4.015 4.015 0 001.11 3.463 3.999 3.999 0 005.662 0l1.261-1.265zm6.426-7.485a3.98 3.98 0 00-.365.3l-4.95 4.966a3.967 3.967 0 00-.299.368l7.72 2.112zm6.044 1.327a4.005 4.005 0 00-4.199-2.142l2.191 8.06 1.26-1.264a4.005 4.005 0 00.748-4.654zm4.574-6.4a2.749 2.749 0 100 3.89 2.737 2.737 0 000-3.89zM20.5 1.004c2.092-.065 4.165.409 6.02 1.376l.164.1.114.151.018.025.035.047c.227.327.162.622-1 4.708A12.919 12.919 0 0133.5 19.178a16.85 16.85 0 01-.945 5.542l-.252.625h-5.82a8.06 8.06 0 01-11.963 0H8.7l-.254-.625a16.823 16.823 0 01-.946-5.542 12.913 12.913 0 017.64-11.734 339.03 339.03 0 01-1.107-3.955l-.196-.74.664-.382A12.45 12.45 0 0120.5 1.003zm2.912 14.804a25.514 25.514 0 01-8.65 2.603 362.48 362.48 0 001.124 5.47 6.078 6.078 0 009.274-.052c.231-.656 1.048-3.002 1.515-4.655a13.358 13.358 0 01-3.263-3.366zm-2.86-7.54C14.49 8.235 9.546 13.116 9.5 19.177a16.1 16.1 0 00.583 4.168h3.646c-.372-1.765-1.026-4.917-1.136-5.724l-.15-1.096 1.107-.038a23.45 23.45 0 009.688-2.856l.857-.503.51.854c.016.028 1.72 2.86 3.67 3.808l.724.352-.19.783c-.295 1.216-.926 3.135-1.365 4.42h3.474c.375-1.358.57-2.759.582-4.167-.017-6.034-4.915-10.915-10.948-10.911zm.39-5.264H20.5a11.66 11.66 0 00-4.318.763c.249.901.6 2.141.842 2.993a13.121 13.121 0 013.528-.492c1.153.003 2.3.161 3.411.47l.85-2.984a11.484 11.484 0 00-4.313-.75z"
});

function SvgMidwife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1A);
}

function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var _ref$1z = /*#__PURE__*/React.createElement("path", {
  d: "M29.798 28.006a3.349 3.349 0 01-2.94-1.742l-.66-1.208a7.047 7.047 0 00-3.857-3.271l-2.403-.84a6.238 6.238 0 01-2.71-9.707 10.596 10.596 0 018.363-3.7 10.898 10.898 0 0110.872 10.806 11.27 11.27 0 01-4.667 9.002h-.002a3.346 3.346 0 01-1.996.66zM25.59 9.537a8.633 8.633 0 00-6.822 2.978 4.238 4.238 0 001.83 6.542l2.402.84a9.037 9.037 0 014.951 4.2l.66 1.207a1.35 1.35 0 001.99.436 9.26 9.26 0 003.86-7.384 8.893 8.893 0 00-8.871-8.819zm10.476 22.145a16.909 16.909 0 00.801-25.872A16.909 16.909 0 008.782 16.54a17.327 17.327 0 00-.005 3.683 550.72 550.72 0 01-2.974 5.565 2.504 2.504 0 00.776 3.25L8.682 30.5v2.406c0 6.382 4.49 8.647 8.335 8.647h3.515V46.5h2v-6.947h-5.515c-1.487 0-6.335-.48-6.335-6.647v-3.452L7.72 27.396a.505.505 0 01-.16-.656 537.979 537.979 0 003.131-5.861l.146-.279-.04-.311a15.286 15.286 0 01-.028-3.536 14.911 14.911 0 1123.7 13.633l-.403.3V46.5h2V31.682z",
  fill: "currentColor"
});

function SvgMind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1z);
}

function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1y = /*#__PURE__*/React.createElement("path", {
  d: "M44 6H4a3.003 3.003 0 00-3 3v24a3.003 3.003 0 003 3h19v4h-9v2h20v-2h-9v-4h19a3.003 3.003 0 003-3V9a3.003 3.003 0 00-3-3zm1 27c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V9c0-.552.448-1 1-1h40c.552 0 1 .448 1 1v24z"
});

function SvgMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1y);
}

function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1x = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.75 24c0 12.679 10.26 22.967 22.939 23a22.745 22.745 0 008.953-1.82 1 1 0 000-1.84 21.033 21.033 0 010-38.68 1 1 0 000-1.84A22.745 22.745 0 0030.689 1c-12.679.033-22.94 10.321-22.94 23zm3.827-8.694a21 21 0 0125.118-11.43 23.04 23.04 0 000 40.248 21 21 0 01-25.118-28.818z",
  fill: "currentColor"
});

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1x);
}

function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1w = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.84 18.194a3.937 3.937 0 014.491 1.582c.593.88.809 1.961.6 3.002a3.997 3.997 0 01-4.703 3.144 3.96 3.96 0 01-.63-.192l-6.362 9.011a6.001 6.001 0 01-5.397 10.142 6 6 0 01-4.717-7.053c.009-.043.02-.085.031-.127l.023-.086-17.004-7.194a3.998 3.998 0 11-3.146-6.42L8.06 12.472A3.99 3.99 0 1113.867 8h15.23a5.994 5.994 0 119.858 5.507l2.884 4.687zm-2.757 3.027c.15-.75.514-1.44 1.048-1.988l-2.877-4.674a5.96 5.96 0 01-2.037.43l-.984 7.383 4.813-.76c.006-.13.018-.261.037-.391zM35.007 5a4 4 0 110 8 4 4 0 010-8zm-2.835 17.698l1.062-7.966A6.014 6.014 0 0129.098 10H13.867a3.972 3.972 0 01-.822 1.595l8.902 12.717 10.225-1.614zm-1.375 10.31a5.98 5.98 0 00-2.357.579l-5.216-7.452 8.672-1.37-1.099 8.244zM8.333 25.776c.132.2.245.413.34.633l11.076-1.749-8.342-11.918a3.97 3.97 0 01-1.398.26l-.019-.003-3.033 11.526a3.97 3.97 0 011.376 1.251zM8.046 8.611a2 2 0 111.573 2.35 2.002 2.002 0 01-1.573-2.35zM4.62 29.96a2 2 0 10.78-3.923 2 2 0 00-.78 3.922zm21.334 5.814L8.951 28.58a2.72 2.72 0 00.014-.13l.005-.065 12.055-1.904 5.772 8.246c-.32.316-.602.667-.844 1.047zm4.536 7.188a4 4 0 101.036-7.929 4 4 0 00-1.036 7.929zm2.288-9.668l1.18-8.855 5.386-.85c.16.355.37.686.625.98l-6.378 9.036a5.97 5.97 0 00-.813-.311zm9.84-9.334a2 2 0 10.78-3.923 2 2 0 00-.78 3.923z",
  fill: "currentColor"
});

function SvgNetworkConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1w);
}

function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1v = /*#__PURE__*/React.createElement("path", {
  d: "M38 .994v17h4a4.685 4.685 0 015 5v19a4.685 4.685 0 01-5 5H6a4.685 4.685 0 01-5-5v-19a4.685 4.685 0 015-5h4v-17h28zM3.113 22.052a4.111 4.111 0 00-.113.942v19a2.706 2.706 0 003 3h36a2.706 2.706 0 003-3v-19a4.11 4.11 0 00-.113-.942L24 34.15zM36 2.994H12V24.89l12 6.95 12-6.95V2.994zm6 17h-4v3.736l5.74-3.324a3.428 3.428 0 00-1.74-.412zm-32 0H6a3.428 3.428 0 00-1.74.412L10 23.73v-3.736zm21-2v2H17v-2h14zm0-7v2H17v-2h14z"
});

function SvgNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1v);
}

function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1u = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.048 39.454V3H44v36.454A5.542 5.542 0 0138.476 45H9.524A5.541 5.541 0 014 39.454V8.546h2v30.908a3.524 3.524 0 107.048 0zM38.476 43A3.54 3.54 0 0042 39.454V5H15.048v34.454A5.532 5.532 0 0113.766 43h24.71zM30 8.5h8v2h-8v-2zm0 4.5h8v2h-8v-2zm8 4.5h-8v2h8v-2zM18.5 25H38v2H18.5v-2zm8-16.5h-8v11h8v-11zm-2 9h-4v-7h4v7zm-6 13.5H38v2H18.5v-2zM38 37H18.5v2H38v-2zM10.524 8.546h-2v30.908h2V8.546z",
  fill: "currentColor"
});

function SvgNewspaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1u);
}

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1t = /*#__PURE__*/React.createElement("path", {
  d: "M28.811 27.04c0 2.441-2.161 4.021-4.741 4.021a5.176 5.176 0 01-4.881-3.1l2.16-1.12a2.988 2.988 0 002.84 2.02c1.201 0 2.201-.64 2.201-1.82 0-1.38-1.22-2.121-3.36-2.121h-.62v-1.96c2.22 0 3.42-.72 3.42-2.1 0-1.08-.86-1.641-1.94-1.641a3.152 3.152 0 00-2.741 1.62l-1.76-1.12a5.072 5.072 0 014.68-2.78c2.321 0 4.222 1.34 4.222 3.36a3.643 3.643 0 01-2.66 3.38c2.059.401 3.18 1.641 3.18 3.362z"
});

var _ref2$3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 46a22 22 0 1122-22 22.025 22.025 0 01-22 22zm0-42a20 20 0 1020 20A20.022 20.022 0 0024 4z"
});

function SvgNumber3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1t, _ref2$3);
}

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1s = /*#__PURE__*/React.createElement("path", {
  fill: "#293033",
  d: "M12.344 25.343h5.811a8.035 8.035 0 0011.942 0h5.81l.253-.625c.648-1.607.944-4 .944-5.543 0-5.236-3.143-9.745-7.638-11.769 1.244-4.377 1.229-4.403.946-4.778l-.114-.152-.163-.1c-1.411-.861-3.657-1.376-6.01-1.376-2.305 0-4.488.497-5.989 1.364l-.662.382.195.74c.215.812.78 2.813 1.104 3.955-4.491 2.04-7.626 6.526-7.626 11.734 0 1.544.296 3.936.944 5.543l.253.625zm7.174-1.465c-.282-1.331-.827-3.932-1.122-5.47 3.816-.37 7.14-1.846 8.637-2.604.645.92 1.827 2.42 3.257 3.366-.466 1.654-1.281 4-1.512 4.656A6.056 6.056 0 0124.125 26a6.053 6.053 0 01-4.607-2.122zm.294-20.114C20.975 3.279 22.525 3 24.125 3c1.856 0 3.34.348 4.307.751-.234.82-.598 2.102-.85 2.982a12.878 12.878 0 00-3.405-.47c-1.222 0-2.4.18-3.523.493-.242-.851-.592-2.091-.842-2.992zm4.365 4.5c6.028 0 10.931 4.894 10.931 10.91 0 1.192-.198 2.89-.581 4.169h-3.47c.437-1.285 1.069-3.204 1.363-4.42l.19-.783-.724-.353c-1.945-.947-3.647-3.78-3.664-3.808l-.508-.853-.855.502c-.045.027-4.616 2.683-9.673 2.856l-1.103.037.149 1.096c.109.808.763 3.96 1.134 5.726h-3.642c-.383-1.28-.581-2.977-.581-4.168 0-6.017 4.95-10.911 11.034-10.911zM39.57 33.875C35.069 31.376 29.584 30 24.125 30c-5.458 0-10.944 1.376-15.446 3.875L8 34.252l.198.752C10.018 41.955 16.717 47 24.125 47c7.408 0 14.107-5.045 15.927-11.996l.198-.752-.679-.377zM24.125 45c-6.245 0-11.912-4.057-13.776-9.751C14.423 33.149 19.28 32 24.125 32c4.844 0 9.703 1.15 13.776 3.249C36.037 40.943 30.371 45 24.125 45zm.998-11v3h2.992v2h-2.992v3h-1.996v-3h-2.992v-2h2.992v-3h1.996z"
});

function SvgNurse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1s);
}

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1r = /*#__PURE__*/React.createElement("path", {
  d: "M41.025 19.237a10.05 10.05 0 00-6.051-5.026c-2.963-.83-7.533 1.026-9.908 2.156v-2.603c.044-2.062-.987-3.999-2.723-5.112a5.143 5.143 0 00-1.46-6.78C19.182.664 17.527.828 12.846 1.653l-.97.172.155.97c.745 4.671 1.129 6.283 2.835 7.494a5.19 5.19 0 006.152-.11 4.039 4.039 0 012.04 3.585v2.614c-2.402-1.127-7.06-2.998-10.033-2.167a10.048 10.048 0 00-6.05 5.026c-2.2 3.947-2.587 9.47-1.036 14.771 1.84 6.295 4.981 10.65 8.843 12.262a9.37 9.37 0 003.644.73 12.65 12.65 0 005.636-1.467c3.328 1.66 6.425 1.912 9.215.748 3.816-1.594 6.936-5.953 8.784-12.273 1.55-5.301 1.164-10.824-1.036-14.771zM16.031 8.66c-.916-.65-1.242-1.488-1.86-5.206 3.73-.634 4.635-.6 5.547.047a3.17 3.17 0 11-3.687 5.159zm24.103 24.788c-1.676 5.73-4.387 9.632-7.633 10.988-2.334.976-5.016.67-7.963-.91l-.476-.255-.475.255c-2.961 1.585-5.662 1.888-8.03.9-3.291-1.375-6.023-5.274-7.691-10.978-1.404-4.8-1.081-9.75.863-13.241a8.093 8.093 0 014.84-4.07 4.253 4.253 0 011.138-.138c2.854 0 7.233 1.992 8.879 2.877l.481.258.479-.262c1.85-1.012 7.23-3.48 9.885-2.736a8.092 8.092 0 014.839 4.072c1.945 3.49 2.268 8.44.864 13.24z"
});

function SvgNutrition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1r);
}

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1q = /*#__PURE__*/React.createElement("path", {
  d: "M17 5v2H9a3.003 3.003 0 00-3 3v32a3.003 3.003 0 003 3h15a3.003 3.003 0 003-3V27h2v15a5.006 5.006 0 01-5 5H9a5.006 5.006 0 01-5-5V10a5.006 5.006 0 015-5h8zm-.5 33a2 2 0 110 4 2 2 0 010-4zM34 1a2.002 2.002 0 012 2v2.86l8 4.559V24H20V3a2.002 2.002 0 012-2h12zm2 7.162V22h6V11.581l-6-3.42zM34 3H22v19h12V3zm-7 12.5V18h-2.5v-2.5H27zm4.5 0V18H29v-2.5h2.5zm-4.5-5V13h-2.5v-2.5H27zm4.5 0V13H29v-2.5h2.5zm-4.5-5V8h-2.5V5.5H27zm4.5 0V8H29V5.5h2.5z"
});

function SvgOfficeOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1q);
}

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1p = /*#__PURE__*/React.createElement("path", {
  d: "M27 1a5.006 5.006 0 015 5v5.415l12 7.011V47H4V6a5.006 5.006 0 015-5h18zm5 12.731V45h10V19.574L32 13.73zM27 3H9a3.003 3.003 0 00-3 3v39h24V6a3.003 3.003 0 00-3-3zM15.5 30v4h-4v-4h4zm9 0v4h-4v-4h4zm-9-9v4h-4v-4h4zm9 0v4h-4v-4h4zm-9-9v4h-4v-4h4zm9 0v4h-4v-4h4z"
});

function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1p);
}

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1o = /*#__PURE__*/React.createElement("path", {
  d: "M45 6a2.002 2.002 0 012 2v26a2.002 2.002 0 01-2 2H25v4h8.5v2h-19v-2H23v-4H3a2.002 2.002 0 01-2-2V8a2.002 2.002 0 012-2zm0 2H3v26h9.528a11.637 11.637 0 01-2.746-4.936l-.192-.738.661-.38A21.496 21.496 0 0121.25 25a21.496 21.496 0 0110.999 2.946l.66.38-.191.738A11.634 11.634 0 0129.973 34h6.277v-8.12l-2.597-2.92A1.998 1.998 0 1135.25 21c-.003.212-.04.422-.109.622l3.109 3.498V34h6.751L45 8zM21.25 27a19.48 19.48 0 00-9.307 2.296A10.116 10.116 0 0015.505 34h11.49a9.937 9.937 0 003.563-4.703A19.482 19.482 0 0021.25 27zm0-15.5a5.506 5.506 0 015.5 5.5 5.5 5.5 0 11-5.5-5.5zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgOnlineCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1o);
}

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1n = /*#__PURE__*/React.createElement("path", {
  d: "M39.639 2.361A4.686 4.686 0 0141 6v36a4.686 4.686 0 01-5 5H12a4.686 4.686 0 01-5-5V6a4.686 4.686 0 015-5h24a4.686 4.686 0 013.639 1.361zM36 3H12a2.706 2.706 0 00-3 3v36a2.706 2.706 0 003 3h24a2.706 2.706 0 003-3V6a2.706 2.706 0 00-3-3zm-5 23v14H17V26h14zm-2 2H19v10h10V28zM28 8v2h-9v10h10v-4h2v6H17V8h11zm4.592-.359l1.412 1.418-9.404 9.366-4.1-4.247 1.439-1.388 2.688 2.784 7.965-7.933z"
});

function SvgOptionalRates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1n);
}

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1m = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.395.164 1.666.706 3.04 1.293l.487.208 3.774 1.614a3.6 3.6 0 012.173 3.64c3.513-1.561 9.087-4.046 9.165-4.08a3.594 3.594 0 013.03 6.517c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.818 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.008 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.203 3.57 3.57 0 01-1.271-.284l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062l-3.523-1.507-.488-.209c-1.461-.624-2.858-1.22-3.275-1.393a6.04 6.04 0 00-4.624.013zM17.673 2.09a18.925 18.925 0 0112.654-.003l.677.23v1.68h1.032a3 3 0 010 6.001h-1.032v1.5h1.032a3 3 0 010 6.002h-1.032V19h1.032a3 3 0 010 6.002h-1.032v1.673l-.67.234a18.92 18.92 0 01-6.29 1.09 19.624 19.624 0 01-6.363-1.087l-.678-.23v-1.68h-1.032a3 3 0 010-6.002h1.032v-1.5h-1.032a3 3 0 010-6.002h1.032v-1.5h-1.032a3 3 0 010-6.001h1.032V2.324zM29.004 19.5h-10v5.736a16.883 16.883 0 0010 .006V19.5zM17.003 21h-1.032a1 1 0 000 2.001h1.032v-2zm15.033 0h-1.032v2.001h1.032a1 1 0 000-2zm-3.032-9.502h-10V17.5h10v-6.002zm3.032 2.001h-1.032v2h1.032a1 1 0 000-2zm-15.033 0h-1.032a1 1 0 000 2h1.032v-2zm12.001-9.736a16.883 16.883 0 00-10-.006v5.741h10zm3.032 2.234h-1.032v2h1.032a1 1 0 000-2zm-15.033 0h-1.032a1 1 0 000 2h1.032v-2z"
});

function SvgOsteopathy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1m);
}

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1l = /*#__PURE__*/React.createElement("path", {
  d: "M39 1a5.006 5.006 0 015 5v36a5.006 5.006 0 01-5 5H9a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5h30zm0 2H9a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h30a3.003 3.003 0 003-3V6a3.003 3.003 0 00-3-3zM26 7c6.184 0 9 5.184 9 10 0 4.817-2.816 10-9 10h-4v14h-2V25h6c5.167 0 7-4.31 7-8 0-3.69-1.833-8-7-8h-9v32h-2V7h11zm2.684 6.407A4.676 4.676 0 0130 17a4.74 4.74 0 01-5 5h-5V12h5.125a4.676 4.676 0 013.559 1.407zM25.125 14H22v6h3a2.751 2.751 0 003-3 2.744 2.744 0 00-2.875-3z"
});

function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1l);
}

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1k = /*#__PURE__*/React.createElement("path", {
  d: "M20.29 44.673c1.216.217 2.449.327 3.684.327l.056 2h-.056c-1.353 0-2.704-.12-4.036-.358zm10.917-.948l.683 1.879c-1.263.459-2.564.807-3.888 1.04l-.105.02-.293-1.98a21.42 21.42 0 003.603-.96zm-17.757-1.57c1.084.629 2.221 1.161 3.399 1.59l-.682 1.88a23.135 23.135 0 01-3.722-1.742zm24.062-2.08l1.29 1.53a22.884 22.884 0 01-3.369 2.354l-.994-1.736a20.856 20.856 0 003.073-2.148zm-29.637-2.62a21.157 21.157 0 002.655 2.652l-1.283 1.536a23.122 23.122 0 01-2.905-2.905zm34.316-2.97l1.733 1a23.172 23.172 0 01-2.362 3.36l-1.527-1.29a21.22 21.22 0 002.156-3.07zM4.25 31.136a21.016 21.016 0 001.583 3.4l-1.73 1.004a22.945 22.945 0 01-1.734-3.727zm40.436-3.501l1.97.345a22.837 22.837 0 01-1.073 3.968l-1.875-.693c.434-1.175.76-2.387.978-3.62zM3 23.952c0 1.241.109 2.48.324 3.702l-.977.213-.99.137A23.117 23.117 0 011 23.974zM24.026 1.001c.7 0 1.402.037 2.102.101.436.039.862.109 1.29.172.2.03.404.044.603.08a22.79 22.79 0 0117.57 14.728c.007.021.018.042.026.064a23.678 23.678 0 011.009 3.767h.003l.015.078c.097.552.162 1.106.22 1.66.01.101.031.2.04.301l.001.015c.062.689.095 1.377.095 2.06h-.003l.003.97-2 .006-.003-.98c0-.118-.013-.232-.015-.348a21.161 21.161 0 00-.069-1.52c-.009-.104-.03-.204-.04-.307A21.142 21.142 0 0026.245 3.133c-.087-.009-.172-.026-.259-.034-.646-.062-1.3-.095-1.96-.095H24L22.996 3l.007-2 .927.004V1zM25 6v17h11v2H23V6h2zM2.403 16.09l1.877.69a21.068 21.068 0 00-.971 3.623l-1.971-.343c.236-1.352.593-2.68 1.065-3.97zM6.41 9.188l1.532 1.287c-.807.96-1.527 1.989-2.152 3.076l-1.734-.998a23.31 23.31 0 012.354-3.365zm6.12-5.124l.999 1.732a21.124 21.124 0 00-3.07 2.155l-1.29-1.527a23.018 23.018 0 013.362-2.36zM20 1.356l.453 1.948-.127.025a21.058 21.058 0 00-3.568.961l-.687-1.879a23.18 23.18 0 013.928-1.055z"
});

function SvgPersiod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1k);
}

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1j = /*#__PURE__*/React.createElement("path", {
  d: "M17.995 29a33.96 33.96 0 0116.326 4.125l.674.377-.195.752A17.467 17.467 0 0117.995 47 17.467 17.467 0 011.19 34.254l-.195-.752.674-.377A33.96 33.96 0 0117.995 29zm-14.67 5.499a15.498 15.498 0 0029.34 0 32.507 32.507 0 00-29.34 0zM17.995 10a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 010-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6zm20.03-11a8.968 8.968 0 016.353 15.31C41.93 18.763 39.41 19 34.865 19c-.516 0-1.057-.003-1.63-.006-.971-.006-2.035-.012-3.206-.004l-1.007.006V17.99c0-.966-.008-1.863-.015-2.698-.005-.545-.01-1.067-.011-1.567v-.735c.011-4.314.332-6.972 2.719-9.363A8.861 8.861 0 0138.025 1zm0 2a6.872 6.872 0 00-4.894 2.04c-2.193 2.197-2.171 4.716-2.123 10.235.004.544.009 1.114.012 1.711h.158c.734 0 1.422.004 2.07.008 5.354.03 7.579.042 9.713-2.097A6.968 6.968 0 0038.024 3zm2.973 9v2h-7.002v-2h7.002zm0-5v2h-7.002V7h7.002z"
});

function SvgPersonalCounselling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1j);
}

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1i = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.5 8h-4.156a9.737 9.737 0 00-18.688 0H10.5a5.006 5.006 0 00-5 5v29a5.006 5.006 0 005 5h27a5.006 5.006 0 005-5V13a5.006 5.006 0 00-5-5zm-20.672-.161l2.676 1.53.992-1.737-2.676-1.53A7.736 7.736 0 0123 3.073V6h2V3.072a7.736 7.736 0 015.18 3.03l-2.676 1.53.992 1.736 2.676-1.53a7.79 7.79 0 01.089 5.662H25v-3h-2v3h-6.26a7.79 7.79 0 01.088-5.661zM37.5 45a3.003 3.003 0 003-3V13a3.003 3.003 0 00-3-3h-3.79c.021.256.04.512.04.773a9.705 9.705 0 01-.92 4.152l-.27.575H15.44l-.27-.576a9.71 9.71 0 01-.92-4.15c0-.262.019-.518.04-.774H10.5a3.003 3.003 0 00-3 3v29a3.003 3.003 0 003 3H23V34h2v11h12.5z",
  fill: "currentColor"
});

function SvgPersonalScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1i);
}

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1h = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.593-9.407-20.987-21-21zm4 4a2.002 2.002 0 012 2v9h9a2.002 2.002 0 012 2v8a2.002 2.002 0 01-2 2h-9v9a2.002 2.002 0 01-2 2h-8a2.002 2.002 0 01-2-2v-9H9a2.002 2.002 0 01-2-2v-8a2.002 2.002 0 012-2h9V9a2.002 2.002 0 012-2h8zm0 2h-8v11H9v8h11v11h8V28h11v-8H28V9z"
});

function SvgPharmacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1h);
}

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1g = /*#__PURE__*/React.createElement("path", {
  d: "M9.048 6.17a2.296 2.296 0 013.241 0l8.418 8.419a2.3 2.3 0 01.001 3.242l-4.167 4.166a13.088 13.088 0 008.965 8.967l4.164-4.166a2.294 2.294 0 013.24 0l8.417 8.418a2.291 2.291 0 010 3.244l-5 5.002a7.875 7.875 0 01-5.652 2.038c-4.732 0-10.376-2.657-13.015-4.443A41.782 41.782 0 016.45 29.844c-2.775-4.1-7.016-14.058-2.404-18.671zm1.827 1.414a.296.296 0 00-.413 0L5.46 12.587c-3.488 3.49.003 12.23 2.647 16.136A39.77 39.77 0 0018.782 39.4c2.434 1.648 7.611 4.1 11.893 4.1a5.922 5.922 0 004.238-1.452l5-5.004a.291.291 0 000-.414l-8.418-8.419a.263.263 0 00-.41 0L26.08 33.22l-.567-.163A15.293 15.293 0 0114.448 21.99l-.163-.566 5.008-5.006a.288.288 0 00.083-.207.285.285 0 00-.084-.209zM33.293 3l1.414 1.422-5.293 5.322H46v2.012H29.414l5.293 5.322-1.414 1.422-7-7.04a1.01 1.01 0 010-1.421l7-7.039z"
});

function SvgPhoneArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1g);
}

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1f = /*#__PURE__*/React.createElement("path", {
  d: "M8.048 7.67a2.296 2.296 0 013.241 0l8.418 8.419a2.3 2.3 0 01.001 3.242l-4.167 4.166a13.088 13.088 0 008.965 8.967l4.164-4.166a2.294 2.294 0 013.24 0l8.417 8.418a2.291 2.291 0 010 3.244l-5 5.002A7.875 7.875 0 0129.675 47c-4.732 0-10.376-2.657-13.015-4.443A41.782 41.782 0 015.45 31.344c-2.775-4.1-7.016-14.058-2.404-18.671zm1.827 1.414a.296.296 0 00-.413 0L4.46 14.087c-3.488 3.49.003 12.23 2.647 16.136A39.77 39.77 0 0017.782 40.9c2.434 1.648 7.611 4.1 11.893 4.1a5.922 5.922 0 004.238-1.452l5-5.004a.291.291 0 000-.414l-8.418-8.419a.263.263 0 00-.41 0L25.08 34.72l-.567-.163A15.293 15.293 0 0113.448 23.49l-.163-.566 5.008-5.006a.288.288 0 00.083-.207.285.285 0 00-.084-.209zM36 1c6.075 0 11 4.925 11 11s-4.925 11-11 11H25V12c0-6.075 4.925-11 11-11zm0 2a9 9 0 00-9 9v9h9a9 9 0 000-18z"
});

function SvgPhoneSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1f);
}

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1e = /*#__PURE__*/React.createElement("path", {
  d: "M10.048 5.67a2.296 2.296 0 013.241 0l8.418 8.419a2.3 2.3 0 01.001 3.242l-4.167 4.166a13.088 13.088 0 008.965 8.967l4.164-4.166a2.294 2.294 0 013.24 0l8.417 8.418a2.291 2.291 0 010 3.244l-5 5.002A7.875 7.875 0 0131.675 45c-4.732 0-10.376-2.657-13.015-4.443A41.782 41.782 0 017.45 29.344c-2.775-4.1-7.016-14.058-2.404-18.671zm1.827 1.414a.296.296 0 00-.413 0L6.46 12.087c-3.488 3.49.003 12.23 2.647 16.136A39.77 39.77 0 0019.782 38.9c2.434 1.648 7.611 4.1 11.893 4.1a5.922 5.922 0 004.238-1.452l5-5.004a.291.291 0 000-.414l-8.418-8.419a.263.263 0 00-.41 0L27.08 32.72l-.567-.163A15.293 15.293 0 0115.448 21.49l-.163-.566 5.008-5.006a.288.288 0 00.083-.207.285.285 0 00-.084-.209zM29 13.739A4.265 4.265 0 0133.26 18h-2A2.264 2.264 0 0029 15.74v-2zm0-5.87c5.592.007 10.124 4.539 10.13 10.131h-2A8.14 8.14 0 0029 9.87v-2zM29 2c8.832.01 15.99 7.168 16 16h-2c-.009-7.728-6.272-13.991-14-14V2z"
});

function SvgPhoneWlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1e);
}

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1d = /*#__PURE__*/React.createElement("path", {
  d: "M34.047 47c-5.445 0-11.942-3.06-14.98-5.118a48.187 48.187 0 01-12.936-12.94c-3.19-4.712-8.072-16.148-2.803-21.42l5.79-5.793a2.502 2.502 0 013.53-.001l9.746 9.75c.971.976.972 2.554.001 3.53L17.503 19.9a15.32 15.32 0 0010.602 10.606l4.89-4.892a2.496 2.496 0 013.528.001l9.745 9.746a2.496 2.496 0 010 3.533l-5.79 5.793A8.618 8.618 0 0134.048 47zM10.883 3a.486.486 0 00-.35.143L4.742 8.937C.639 13.042 4.7 23.26 7.787 27.82a46.194 46.194 0 0012.402 12.406C23.023 42.145 29.05 45 34.047 45a6.737 6.737 0 005.018-1.728l5.79-5.793a.467.467 0 00.145-.351.472.472 0 00-.146-.353l-9.747-9.748a.431.431 0 00-.696 0l-5.732 5.734-.566-.163a17.554 17.554 0 01-12.701-12.705l-.163-.567 5.731-5.73a.506.506 0 000-.705l-9.745-9.748A.492.492 0 0010.883 3z"
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1d);
}

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1c = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.365 34.745H43.16a4 4 0 110 8H12.01a3.993 3.993 0 01-3.835-2.926 4.94 4.94 0 01-2.335.607 4.988 4.988 0 114.952-5.471 3.945 3.945 0 011.218-.21h4.008v-16.34h.082a6.01 6.01 0 012.82-4.24 5 5 0 116.227.005 5.99 5.99 0 011.787 1.652c.882 1.204 3.852 5.18 6.273 8.418h3.64c1.873 0 3.396 1.794 3.396 4s-1.523 4-3.395 4h-5.484v2.505zm5.484-4.505c.756 0 1.395-.916 1.395-2s-.639-2-1.395-2h-9.484a2.002 2.002 0 00-2 2v6.505h4V30.24h7.484zM22.037 7.287a3 3 0 110 6 3 3 0 010-6zm-3.963 13.118h-.055v8h5.346v-.165a3.978 3.978 0 011.517-3.111 1022.65 1022.65 0 01-3.177-4.26l1.615-1.182c.487.666 2.52 3.383 3.44 4.614.2-.036.402-.056.605-.06h3.346a1483.483 1483.483 0 01-5.398-7.25 4 4 0 00-7.277 2.296c.003-.022.01.028.012.094l.026 1.024zm-.055 10h5.346v4.34h-5.346v-4.34zM2.84 35.425a3 3 0 106 0 3 3 0 00-6 0zm7.17 3.32a2.002 2.002 0 012-2h9.63v4h-9.63a2.002 2.002 0 01-2-2zm13.63 2h19.52a2 2 0 000-4H23.64v4z",
  fill: "currentColor"
});

function SvgPhysiotherapy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1c);
}

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1b = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 9.875a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm17.888 23.122c-1.012-7.766-9.048-13.835-18.783-13.835-2.63.064-5.233.54-7.715 1.41l-5.114-2.197-1.1 5.809a15.242 15.242 0 00-3.678 4.842H1v10.629h5.218a15.234 15.234 0 003.942 5.461L7.429 43.11l7.397 4.015 2.702-4.94a22.935 22.935 0 0014.019-.284l2.857 5.224 7.397-4.015-3.08-5.632a13.912 13.912 0 004.261-9.481H47v-2h-4.112zm-6.086 10.549l-.58.529 2.862 5.235-3.882 2.107-2.742-5.014-.823.329a20.22 20.22 0 01-7.532 1.418 20.4 20.4 0 01-6.728-1.117l-.8-.278-2.55 4.662-3.881-2.107 2.557-4.677-.646-.524a13.256 13.256 0 01-4.21-5.787l-.235-.666H3v-6.631h4.814l.256-.616a13.188 13.188 0 013.675-4.941l.266-.229.766-4.043 3.611 1.55.4-.177a22.354 22.354 0 017.317-1.408C33.42 14.16 41 20.214 41 27.655a12.054 12.054 0 01-4.198 8.89zM29 20.875v-2h-8v2h8zm-12.5 3.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
  fill: "currentColor"
});

function SvgPiggybank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1b);
}

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$1a = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 18.5v5.448a9.5 9.5 0 1019 0V18.5h2v5.448A11.542 11.542 0 0125 35.45V40.5h7v2H16v-2h7v-5.05a11.542 11.542 0 01-10.5-11.502V18.5h2zM24 6a7.25 7.25 0 017.25 7.25v10.5A7.258 7.258 0 0124 31a7.258 7.258 0 01-7.25-7.25v-10.5A7.25 7.25 0 0124 6zm0 2a5.25 5.25 0 00-5.25 5.25v10.5a5.25 5.25 0 0010.5 0v-10.5C29.25 10.35 26.9 8 24 8zm19.613 1.5c4.516 4.573 4.516 11.927 0 16.5l-1.428-1.418a9.721 9.721 0 000-13.664zm-39.226 0l1.428 1.418a9.721 9.721 0 000 13.664L4.387 26c-4.516-4.573-4.516-11.927 0-16.5zm36.295 2.95a7.54 7.54 0 010 10.6l-1.428-1.418a5.522 5.522 0 000-7.763zm-33.364 0l1.428 1.418a5.522 5.522 0 000 7.763L7.318 23.05a7.54 7.54 0 010-10.598z"
});

function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1a);
}

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 1h24a2.002 2.002 0 012 2v34a2.002 2.002 0 01-2 2h-4.5v6H35v2H13v-2h3.5v-6H12a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm6.5 44h11v-6h-11v6zM12 37V3h24l.002 34H12zm2.5-2.5h19v-29h-19v29zm2-27h15v25h-15v-25z",
  fill: "currentColor"
});

function SvgPosterOutdoorAdvertising(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$19);
}

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$18 = /*#__PURE__*/React.createElement("path", {
  d: "M24 1C11.297 1 1 11.297 1 24s10.297 23 23 23 23-10.297 23-23C46.986 11.303 36.697 1.014 24 1zm0 44A20.979 20.979 0 019.366 8.968a8.703 8.703 0 003.556 7.637c3.49 2.562 4.653 4.526 5.112 6.935a7.45 7.45 0 00-2.888-.55h-4.645a3.501 3.501 0 10.001 7.002h3.16a7.499 7.499 0 00-1.516 2.921 5.897 5.897 0 001.142 4.96 8.713 8.713 0 006.296 3.12c.201.008.4.012.598.012 5.774 0 10.144-3.53 13.699-11.033a8.496 8.496 0 10-5.591-15.199c-.075.06-.143.125-.216.186a3.495 3.495 0 00-6.872-.205l-1.545 7.112c-.818-2.598-2.493-4.63-5.551-6.874-3.655-2.682-2.746-6.817-2.396-7.984A20.988 20.988 0 1124 45zm4.364-19.526a6.453 6.453 0 01-1.212-5.37l.006.001.06-.26a6.487 6.487 0 017.096-4.804 6.5 6.5 0 11-5.95 10.433zm-2.272-9.668l-.821 3.58c-.09.342-.157.689-.204 1.039a8.481 8.481 0 006.668 9.37c-4.236 8.468-8.89 9.325-12.069 9.2a6.865 6.865 0 01-4.802-2.353 3.904 3.904 0 01-.76-3.327 7.108 7.108 0 011.883-2.941 1.399 1.399 0 00-.996-2.384l-4.489.002a1.501 1.501 0 01-.001-3.003h4.645a4.337 4.337 0 014.315 2.62 5.815 5.815 0 01-1.226 6.09l1.422 1.406a7.802 7.802 0 002.183-5.232c1.373.638 2.966.6 4.307-.105l-.93-1.77a2.885 2.885 0 01-4.157-3.17l2.096-9.65a1.501 1.501 0 012.936.628z"
});

function SvgPregnancy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$18);
}

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$17 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5 26a4 4 0 10-5 3.858v2.025a11 11 0 11-22 0v-6.52a13.079 13.079 0 0012-13.066V3h-7v2h5v7.297a11 11 0 11-22 0V5h5V3h-7v9.297a13.079 13.079 0 0012 13.066v6.52a13 13 0 1026 0v-2.025a3.996 3.996 0 003-3.858zm-4 2a2 2 0 110-4 2 2 0 010 4z"
});

function SvgProvision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$17);
}

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$16 = /*#__PURE__*/React.createElement("path", {
  d: "M40 7h-9V1H17v6H8a3.003 3.003 0 00-3 3v34a3.003 3.003 0 003 3h32a3.004 3.004 0 003-3V10a3.003 3.003 0 00-3-3zM19 3h10v4H19V3zM8 9h32a1 1 0 011 1v8h-6v-4h-7v4h-8v-4h-7v4H7v-8a1 1 0 011-1zm25 7v6h-3v-6h3zm-15 0v6h-3v-6h3zm22 29H8a1 1 0 01-1-1V20h6v4h7v-4h8v4h7v-4h6v24a1 1 0 01-1 1z"
});

var _ref2$2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 36a4.686 4.686 0 005 5h12a4.686 4.686 0 005-5v-7.001l-22 .024V36zm2-4.98l18-.019V36a2.706 2.706 0 01-3 3H18a2.705 2.705 0 01-3-3v-4.98z"
});

function SvgPupils(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$16, _ref2$2);
}

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$15 = /*#__PURE__*/React.createElement("path", {
  d: "M39.639 2.361A4.686 4.686 0 0141 6v36a4.686 4.686 0 01-5 5H12a4.686 4.686 0 01-5-5V6a4.686 4.686 0 015-5h24a4.686 4.686 0 013.639 1.361zM36 3H12a2.706 2.706 0 00-3 3v36a2.706 2.706 0 003 3h24a2.706 2.706 0 003-3V6a2.706 2.706 0 00-3-3zm-2 26v2H20v-2h14zm-17 0v2h-3v-2h3zm17-8v2H20v-2h14zm-17 0v2h-3v-2h3zm17-8v2H20v-2h14zm-17 0v2h-3v-2h3z"
});

function SvgRates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$15);
}

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.896 13.49l4.44 1.137-4.741-8.015a2.959 2.959 0 00-2.566-1.466h-.003A2.96 2.96 0 0021.46 6.61l-5.992 10.098-1.72-1.022L19.74 5.588a4.944 4.944 0 014.287-2.442h.004a4.943 4.943 0 014.287 2.449l4.742 8.018 1.139-4.445 1.937.496-1.986 7.75-7.75-1.987.497-1.938zM5.398 36.637a2.957 2.957 0 01.027-3.005l5.251-8.851 1.14 4.444 1.937-.496-1.987-7.75-7.75 1.986.497 1.937 4.441-1.138-5.249 8.846a4.988 4.988 0 004.286 7.536h12.035v-2H7.991a2.95 2.95 0 01-2.593-1.51zm38.901-4.02l-6.464-10.93-1.722 1.017 6.465 10.93a2.989 2.989 0 01-2.57 4.512H29.964l3.293-3.294-1.414-1.413-5.707 5.707 5.707 5.706 1.414-1.413-3.293-3.293H40.01a4.988 4.988 0 004.29-7.529z",
  fill: "currentColor"
});

function SvgRecycling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$14);
}

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$13 = /*#__PURE__*/React.createElement("path", {
  d: "M11.402 8.92C19.592.748 32.852.75 41.04 8.923c8.17 8.191 8.167 21.449-.005 29.637-4.465 4.464-9.779 6.204-18.95 6.204-.995.017-2.566.023-3.665.026h-.347l-.158.001-.738.001h-.01v-2h.753l.157-.001h.346l1.425-.006.434-.003c.65-.004 1.29-.01 1.787-.018 9.906 0 14.178-2.246 17.552-5.618a18.957 18.957 0 10-26.805-26.813C7.802 15.346 7.054 21.55 7.18 41.368l2.904-2.907 1.414 1.414-5.327 5.332-5.337-5.332 1.414-1.415 2.932 2.93a591.51 591.51 0 01-.012-2.969v-1.13c.021-17.284 1.094-23.233 6.234-28.372zm17.509 1.873c1.396 0 2.782.241 4.096.713l-.678 1.882a10.1 10.1 0 00-3.42-.595h-.01a10.081 10.081 0 00-9.225 6.006l6.495.007-.002 2-7.133-.007c-.271 1.32-.27 2.68.001 4l7.128.007-.002 2-6.48-.007a10.08 10.08 0 009.207 5.994h.012a10.1 10.1 0 003.368-.574l.664 1.887a12.098 12.098 0 01-4.032.687h-.013a12.074 12.074 0 01-11.35-7.996l-4.37-.004.002-2 3.844.004a11.087 11.087 0 010-4l-3.84-.004.003-2 4.358.004a12.074 12.074 0 0111.364-8.004z"
});

function SvgRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$13);
}

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$12 = /*#__PURE__*/React.createElement("path", {
  d: "M25.376 19.27l7.747-13.29L25.4 1.563A3.859 3.859 0 0023.378 1a3.9 3.9 0 00-1.855 7.298l5.94 3.42-3.45 5.92-8.138-4.68-.998 1.733 8.499 4.887V45h-3v2h8v-2h-3V19.27zM22.512 6.56a1.876 1.876 0 01-.976-1.619A1.909 1.909 0 0123.406 3h.022c.343.008.678.11.968.293l5.983 3.422-1.908 3.274-5.959-3.43z"
});

function SvgRehab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$12);
}

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$11 = /*#__PURE__*/React.createElement("path", {
  d: "M13.63 1a4.814 4.814 0 013.417 1.442l6.95 6.95 6.952-6.95a4.78 4.78 0 016.833 0l7.777 7.776a4.781 4.781 0 010 6.833l-6.952 6.951 6.952 6.952a4.77 4.77 0 010 6.832l-7.777 7.777a4.779 4.779 0 01-6.832 0l-6.952-6.952-6.952 6.953a4.78 4.78 0 01-6.832-.001l-7.777-7.777a4.78 4.78 0 01-.001-6.832l6.952-6.952-6.951-6.951a4.782 4.782 0 010-6.833l7.777-7.777A4.811 4.811 0 0113.629 1zm-2.827 24.417L3.85 32.368a2.771 2.771 0 000 4.004l7.778 7.777a2.769 2.769 0 004.003 0l6.953-6.952-11.781-11.78zM13.63 3a2.828 2.828 0 00-2.002.855l-7.777 7.777a2.771 2.771 0 000 4.005L32.365 44.15a2.77 2.77 0 004.003-.001l7.776-7.777a2.77 2.77 0 00.001-4.004L15.632 3.856A2.828 2.828 0 0013.63 3zm10.368 24.253a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm-5-5a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm10-.001a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zM34.367 3c-.757 0-1.48.309-2.002.856l-6.952 6.95 11.781 11.782 6.952-6.951a2.771 2.771 0 000-4.005l-7.777-7.777A2.77 2.77 0 0034.366 3zM23.998 17.252a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z"
});

function SvgRemedies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$11);
}

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.478 23v24h-2V23a1 1 0 00-2 0v2h-2v-2c0-.96.46-1.805 1.164-2.355l-9.294-8.413c-1.98 1.262-8.098 6.125-4.914 16.474q.076.248-2.262 15.179a.913.913 0 00.178.693c.164.218.415.363.69.399.666.096 1.024-.46 1.134-.954l3.34-12.285a1.001 1.001 0 011.671-.445l2.415 2.414c.567.567.878 1.32.878 2.121l-.008 8.149c0 .267.104.518.293.708a1 1 0 001.707-.707l.007-12.276c0-.227-.077-.449-.219-.627l-2.874-3.59a2.99 2.99 0 01-.493-2.85l2.155-6.263 1.612 1.463-1.876 5.45a1 1 0 00.165.95l2.874 3.591c.425.533.657 1.2.656 1.88l-.007 12.272c0 1.654-1.346 3-3 3a2.979 2.979 0 01-2.122-.88 2.977 2.977 0 01-.878-2.123l.008-8.147a.993.993 0 00-.292-.707l-1.195-1.194-2.876 10.576c-.328 1.475-1.54 2.482-2.947 2.482a3.049 3.049 0 01-2.416-1.205 2.905 2.905 0 01-.557-2.203c.58-3.702 2.035-13 2.262-14.5-2.08-6.983-.23-11.747 1.7-14.523 2.122-3.049 4.762-4.392 4.874-4.448a.998.998 0 011.118.153l10.813 9.79A2.997 2.997 0 0127.478 23zM26.66 6.5c0-3.032-2.468-5.5-5.5-5.5s-5.5 2.468-5.5 5.5 2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5zm-2 0c0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5S19.23 3 21.16 3s3.5 1.57 3.5 3.5zM41.554 16a6.708 6.708 0 01-5.682-3.108h4.409v-2h-5.243A6.327 6.327 0 0134.88 9.5c0-.537.075-1.056.201-1.555h5.2v-2h-4.307A6.716 6.716 0 0141.554 3c.782 0 1.547.13 2.274.387l.666-1.887c-.94-.332-1.93-.5-2.94-.5a8.69 8.69 0 00-7.868 4.945H30.16v2h2.872A8.325 8.325 0 0032.88 9.5c0 .475.05.938.127 1.392h-2.846v2h3.445C34.946 15.894 38.002 18 41.554 18c.996 0 1.973-.164 2.904-.488l-.659-1.889a6.81 6.81 0 01-2.245.377z"
});

function SvgRetirementProvision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$10);
}

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$$ = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.257 1.735a2.011 2.011 0 00-1.901-.531L32.294 4.128a13.245 13.245 0 00-6.239 3.497l-2.549 2.543-6.285-1.702L6.199 19.465l6.29 1.698L9.744 23.9l2.878 2.872L7.39 30.26l10.382 10.36 3.496-5.22 2.878 2.872 2.746-2.74 1.702 6.276 11.018-10.995-1.705-6.272 2.514-2.51a13.198 13.198 0 003.527-6.317l2.85-12.086a2.002 2.002 0 00-.54-1.893zm-36.195 16.7l7.752-7.736 4.06 1.099-7.751 7.734-4.061-1.097zm.47 12.134l6.932 6.918 2.361-3.527-5.758-5.747-3.535 2.356zm26.846-.351l-7.756 7.739-1.099-4.053 7.754-7.737 1.1 4.05zm1.63-9.602A11.205 11.205 0 0042 15.255l2.851-12.086L32.765 6.07a11.249 11.249 0 00-5.297 2.97L12.576 23.9l11.57 11.545 14.862-14.83zM1.78 44.806l8.598-8.58 1.413 1.415-8.598 8.58-1.413-1.416zM6.978 32.83l-5.832 5.82 1.414 1.415 5.831-5.82-1.413-1.415zm.971 12.607l5.831-5.82 1.413 1.417-5.83 5.82-1.414-1.417zm17.404-27.792a5 5 0 1010 0 5 5 0 00-10 0zm8 0a3 3 0 11-6 0 3 3 0 016 0z",
  fill: "currentColor"
});

function SvgRocketProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$$);
}

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$_ = /*#__PURE__*/React.createElement("path", {
  d: "M13 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1zM9.5 20a.501.501 0 01-.465-.686l1.878-4.694-2.767-2.767a.5.5 0 01-.094-.577L10.69 6H7.65L4.776 7.916a.5.5 0 11-.554-.832l3-2A.498.498 0 017.499 5h4a.5.5 0 01.447.723l-2.839 5.678 2.745 2.745a.501.501 0 01.111.539l-2 5a.5.5 0 01-.464.314z"
});

var _ref2$1 = /*#__PURE__*/React.createElement("path", {
  d: "M6 16H1.5a.5.5 0 010-1h4.25l1.35-1.8a.5.5 0 11.8.6l-1.5 2a.5.5 0 01-.4.2zM17.5 10h-4a.5.5 0 01-.447-.276l-1-2a.5.5 0 01.895-.447l.862 1.724h3.691a.5.5 0 010 1z"
});

function SvgRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 20 20"
  }, props), _ref$_, _ref2$1);
}

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Z = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 24C1 11.297 11.297 1 24 1c12.697.014 22.986 10.303 23 23 0 12.703-10.297 23-23 23S1 36.703 1 24zm2 0c0 11.598 9.402 21 21 21 11.593-.013 20.987-9.407 21-21 0-11.598-9.402-21-21-21S3 12.402 3 24zm12.5-3.5a2 2 0 100-4 2 2 0 000 4zm17 .028a2 2 0 100-4 2 2 0 000 4zM11.094 36.077A14.23 14.23 0 0124 28a14.23 14.23 0 0112.906 8.077l-1.812.846a12.35 12.35 0 00-22.188 0l-1.812-.846z",
  fill: "currentColor"
});

function SvgSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$Z);
}

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$Y = /*#__PURE__*/React.createElement("path", {
  d: "M23 4a2.002 2.002 0 012 2v4h5a5.006 5.006 0 015 5v7.437a7.47 7.47 0 014.605 9.446l6.419 6.419a3.338 3.338 0 01-4.722 4.72l-6.417-6.417A7.47 7.47 0 0125.437 32H6a5.006 5.006 0 01-5-5V15a5.006 5.006 0 015-5h5V6a2.002 2.002 0 012-2zm15.66 29.767a7.554 7.554 0 01-1.892 1.893l5.948 5.948a1.338 1.338 0 101.893-1.893zM36.39 25.61a5.5 5.5 0 00-9.39 3.889 5.507 5.507 0 005.5 5.5 5.5 5.5 0 003.89-9.39zM29.999 12H6a3.003 3.003 0 00-3 3v12a3.003 3.003 0 003 3h19.026c-.01-.166-.025-.331-.025-.5a7.508 7.508 0 017.5-7.5c.169 0 .334.014.5.025V15a3.003 3.003 0 00-3-3zm-11 4v4h4v2h-4v4h-2v-4h-4v-2h4v-4h2zm4-10H13v4h10V6z"
});

function SvgSearchDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$Y);
}

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$X = /*#__PURE__*/React.createElement("path", {
  d: "M34 1a5.006 5.006 0 015 5v20.989h-2V6a3.003 3.003 0 00-3-3H10a3.003 3.003 0 00-3 3v36a3.003 3.003 0 003 3h15v2H10a5.006 5.006 0 01-5-5V6a5.006 5.006 0 015-5zm-8.693 28.854a8.086 8.086 0 0112.128 10.649l5.065 5.07L41.075 47l-5.063-5.068a8.086 8.086 0 01-10.705-12.078zm5.761-.325a6.048 6.048 0 00-6.052 6.043 6.058 6.058 0 006.049 6.054 6.048 6.048 0 00.003-12.097zM15 27v2h-3v-2h3zm0-8v2h-3v-2h3zm17 0v2H18v-2h14zm-17-8v2h-3v-2h3zm17 0v2H18v-2h14z"
});

function SvgSearchServiceProvider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$X);
}

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$W = /*#__PURE__*/React.createElement("path", {
  d: "M6.37 6.17C12.75-.11 22.778-.744 29.898 4.682c7.12 5.427 9.167 15.263 4.803 23.08l11.332 11.175a4.898 4.898 0 011.47 3.511 4.974 4.974 0 01-1.498 3.564 5.104 5.104 0 01-3.592 1.468 5.024 5.024 0 01-3.54-1.44l-11.36-11.203c-7.884 4.24-17.686 2.038-23-5.167S-.009 12.45 6.371 6.17zm27.224 23.31a18.13 18.13 0 01-4.333 4.273l11.015 10.862a3.09 3.09 0 004.324-.027 2.988 2.988 0 00.902-2.139 2.911 2.911 0 00-.874-2.087zM19.003 2.982c-8.836 0-16 7.162-16 15.998.009 8.833 7.166 15.991 16 16.002 8.835 0 16-7.164 16-16s-7.164-16-16-16zm0 2.778c7.297.009 13.21 5.923 13.218 13.22a13.22 13.22 0 11-13.219-13.22zm4.292 2.854a11.22 11.22 0 10-4.293 21.586c6.193-.007 11.212-5.026 11.219-11.22a11.22 11.22 0 00-6.926-10.366z"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$W);
}

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$V = /*#__PURE__*/React.createElement("path", {
  d: "M22.086 24.856l.571.066a35.158 35.158 0 019.648 2.509l-.778 1.842a32.056 32.056 0 00-4.362-1.472v2.944a2.25 2.25 0 11-2 0v-3.407a34.038 34.038 0 00-2.17-.36l-4.254 5.684-4.846-5.672c-.581.079-1.157.177-1.73.284v1.868a3.995 3.995 0 013 3.858v2h-2v-2a2 2 0 10-4 0v2h-2v-2a3.995 3.995 0 013-3.858v-1.43a31.53 31.53 0 00-6.812 2.542 15.988 15.988 0 0015.142 10.75c6.364 0 14.464-3.865 16.343-14.756l.169-.982.983.166a34.435 34.435 0 0110.615 3.446l.685.375-.2.756a17.45 17.45 0 01-16.886 12.987h-.017l.002-2h.015a15.454 15.454 0 0014.732-10.734 32.646 32.646 0 00-8.318-2.684c-2.277 10.645-10.645 15.425-18.123 15.425A17.954 17.954 0 011.198 30.01L1 29.257l.68-.377a34.532 34.532 0 0112.505-3.944l.53-.064 3.923 4.591 3.448-4.607zm6.02-19.404a8.5 8.5 0 11.189 14.221l1.074-1.687a6.5 6.5 0 10-.144-10.875zm-9.44-1.451a8.5 8.5 0 110 17 8.51 8.51 0 01-8.5-8.5 8.5 8.5 0 018.5-8.5zm0 2a6.508 6.508 0 00-6.5 6.5 6.5 6.5 0 106.5-6.5z"
});

function SvgSecondOpinion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$V);
}

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$U = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052 1.042-.386 12.423-5.631 16.72-7.62a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.944-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM30.96 1a8.96 8.96 0 016.338 2.625c2.262 2.266 2.698 4.608 2.706 11.753l-.001.83c-.002.567-.006 1.162-.011 1.788l-.008.982-.983.009c-.913.009-1.762.014-2.553.014a52.027 52.027 0 01-6.534-.285 10.895 10.895 0 01-2.114 3.004C25.049 24.474 22.144 25 13.234 25h-.608c-.822-.002-1.693-.009-2.618-.017l-.982-.009-.008-.982c-.008-.855-.013-1.664-.015-2.43v-.9c.012-8.8.55-11.69 3.31-14.454A10.984 10.984 0 0122.884 3.37c.51.14 1.01.316 1.494.527.082-.089.157-.183.243-.27A8.96 8.96 0 0130.96 1zm-8.588 4.303a8.978 8.978 0 00-8.644 2.318c-2.156 2.16-2.704 4.35-2.722 13.086v.88c0 .452.002.92.005 1.404 10.682.072 13.063-.37 15.374-2.684a8.92 8.92 0 001.502-2.01 7.378 7.378 0 01-3.261-1.979A8.996 8.996 0 0123.16 5.57c-.26-.096-.52-.195-.79-.267zm8.59-2.303a6.908 6.908 0 00-4.775 1.904 10.77 10.77 0 014.44 11.878c2.452.2 4.913.272 7.372.213l.003-.835v-.79c-.014-6.921-.44-8.65-2.12-10.33a6.909 6.909 0 00-4.92-2.04zm-6.015 3.475a6.991 6.991 0 001.094 8.43 5.5 5.5 0 002.617 1.525 8.83 8.83 0 00-3.711-9.955z"
});

function SvgSelfHelpPromotion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$U);
}

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$T = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5 42a3.003 3.003 0 01-3 3H9a3.003 3.003 0 01-3-3V6a3.003 3.003 0 013-3h17.5a3.003 3.003 0 013 3v4h2V6a5.006 5.006 0 00-5-5H9a5.006 5.006 0 00-5 5v36a5.006 5.006 0 005 5h17.5a5.006 5.006 0 005-5v-2.5h-2V42zm9.193-29.124l3.498 5.542c3.455 5.506 1.814 12.77-3.672 16.256a11.688 11.688 0 01-8.82 1.547L19.36 33.886a2.464 2.464 0 01-1.971-1.654 2.89 2.89 0 01.806-2.79 4.568 4.568 0 014.434-1.246l3.703.83-10.846-17.217a3.138 3.138 0 011.518-4.602 3.176 3.176 0 013.82 1.323l4.135 6.558a3.163 3.163 0 011.388-1.06 3.088 3.088 0 012.654.207 3.15 3.15 0 011.622-1.425 3.089 3.089 0 012.618.188 3.13 3.13 0 015.452-.122zm-8.557 21.398a9.681 9.681 0 007.311-1.285 9.822 9.822 0 003.05-13.51l-3.496-5.542a1.189 1.189 0 00-1.395-.527 1.13 1.13 0 00-.677.708 1.15 1.15 0 00.119.974l.943 1.495-1.694 1.061-1.547-2.452a1.186 1.186 0 00-1.394-.53 1.15 1.15 0 00-.557 1.685l-.003.003 1.586 2.516-1.694 1.061-1.631-2.588.002-.002-.585-.928a1.184 1.184 0 00-1.394-.529 1.15 1.15 0 00-.557 1.685l-.002.002 2.256 3.579-1.693 1.062-2.39-3.791.002-.002-5.566-8.828a1.186 1.186 0 00-1.393-.527 1.13 1.13 0 00-.678.708c-.108.326-.064.684.12.975l12.383 19.656-.384.624a1.07 1.07 0 01-1.115.43l-5.877-1.316a3.237 3.237 0 00-.716-.084 2.468 2.468 0 00-1.81.743 1.047 1.047 0 00-.36.845c.054.176.37.265.503.296l10.332 2.332zM17.75 41.5a2 2 0 100-4 2 2 0 000 4z",
  fill: "currentColor"
});

function SvgSelfservice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$T);
}

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$S = /*#__PURE__*/React.createElement("path", {
  d: "M9.506 4.994h10v2h-10a2.706 2.706 0 00-3 3v32a2.706 2.706 0 003 3h15a2.706 2.706 0 003-3v-15h2v15a4.685 4.685 0 01-5 5h-15a4.685 4.685 0 01-5-5v-32a4.685 4.685 0 015-5zm7.5 33a2 2 0 110 4 2 2 0 010-4zM38.033 8.521a2.035 2.035 0 013.398 1.985l2.074 2.074v11.414h-21.31l-.256-.175a10.81 10.81 0 01-4.4-6.068l-.199-.747.673-.38a20.3 20.3 0 0119.985 0l.671.38-.197.746a10.355 10.355 0 01-2.32 4.244h5.353v-8.586l-1.488-1.488a2.035 2.035 0 01-1.984-3.399zm-1.73 9.461a18.313 18.313 0 00-16.593 0 8.925 8.925 0 003.114 4.012h10.363a8.75 8.75 0 003.116-4.012zM28.006.994a5.5 5.5 0 015.5 5.5 5.507 5.507 0 01-5.5 5.5 5.5 5.5 0 110-11zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgSeminarOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$S);
}

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$R = /*#__PURE__*/React.createElement("path", {
  d: "M36.786 21.202a2.517 2.517 0 014.12 2.708l4.176 4.176V42.5H10.775l-.254-.172a18.043 18.043 0 01-7.407-10.314l-.196-.75.679-.378A35.58 35.58 0 0121.082 26.5a35.575 35.575 0 0117.485 4.386l.68.377-.197.751a17.807 17.807 0 01-5.112 8.486h9.144V28.914l-3.59-3.59a2.517 2.517 0 01-2.706-4.122zM21.67 28.5l-.589.001a33.729 33.729 0 00-15.815 3.758 16.09 16.09 0 006.127 8.242H30.77a16.084 16.084 0 006.126-8.242A33.723 33.723 0 0021.082 28.5zM21.083 5.5a9 9 0 019 9 9.01 9.01 0 01-9 9 9 9 0 010-18zm0 2a7 7 0 107 7 7.008 7.008 0 00-7-7z"
});

function SvgSeminar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$R);
}

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$Q = /*#__PURE__*/React.createElement("path", {
  d: "M42 7a4.685 4.685 0 015 5v24a4.685 4.685 0 01-5 5H6a4.685 4.685 0 01-5-5V12a4.685 4.685 0 015-5zm2.225 2.775A2.706 2.706 0 0042 9H6a2.706 2.706 0 00-3 3v24a2.706 2.706 0 003 3h36a2.706 2.706 0 003-3V12a2.706 2.706 0 00-.775-2.225zM36 23v5h5v2h-5v5h-2v-5h-5v-2h5v-5h2zm-13-1v2H7v-2h16zm0-6v2H7v-2h16z"
});

function SvgSickNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$Q);
}

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$P = /*#__PURE__*/React.createElement("path", {
  d: "M22.1 29a34.557 34.557 0 0116.484 4.126l.68.377-.197.752A17.61 17.61 0 0122.1 47a17.869 17.869 0 01-13.044-5.677l1.465-1.361A15.863 15.863 0 0022.1 45c6.671.016 12.619-4.2 14.812-10.501A32.726 32.726 0 0022.1 31c-3.018 0-6.022.41-8.93 1.214l-.534-1.927A35.497 35.497 0 0122.1 29zM6.413 15.001a4.505 4.505 0 014.5 4.5v11.625a4.5 4.5 0 01-1.5 3.348V37a3 3 0 11-6 0v-2.526a4.501 4.501 0 01-1.5-3.349V19.501a4.505 4.505 0 014.5-4.5zm0 2a2.5 2.5 0 00-2.5 2.5v11.625a2.503 2.503 0 001.073 2.048l.427.298V37a1 1 0 102 0v-3.528l.427-.3a2.504 2.504 0 001.073-2.047v-1.125h-2.5v-2h2.5v-2h-2.5v-2h2.5v-2h-2.5v-2h2.5v-.5a2.5 2.5 0 00-2.5-2.5zm15.5-7a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 110-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6zm13.47-6A8.575 8.575 0 0146.087 1.51l-.68 1.88a6.577 6.577 0 00-7.75 2.611h4.256v2H36.79a6.386 6.386 0 00-.043 3h5.166v2h-4.357a6.578 6.578 0 007.824 2.786l.67 1.885A8.587 8.587 0 0135.302 13h-3.39v-2h2.803a8.121 8.121 0 01.026-3h-2.829v-2z"
});

function SvgSickPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$P);
}

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$O = /*#__PURE__*/React.createElement("path", {
  d: "M30.676 15.627l.143.004c.619.047 1.15.462 1.344 1.051.126.353.12.739-.012 1.086l-.065.146-4.317 8.427a.674.674 0 00.285.913.685.685 0 00.79-.112l.073-.082 6.323-8.174a1.392 1.392 0 011.953-.173c.5.414.637 1.117.345 1.684l-.07.119-5.964 8.477a.832.832 0 00.176 1.166.845.845 0 001.039-.033l.083-.08 5.63-5.903a1.42 1.42 0 011.995-.105 1.4 1.4 0 01.192 1.876l-.088.108-6.255 7.32a.564.564 0 00.72.852l.083-.058 5.43-4.705c.285-.25.662-.37 1.04-.33a1.38 1.38 0 011.253 1.499 1.397 1.397 0 01-.438.883 711.824 711.824 0 00-9.143 8.552 30.422 30.422 0 01-4.676 3.712 8.22 8.22 0 01-7.633.574c-2.331-1.003-5.866-3.06-6.026-7.44l-.005-.31-.4-12.803a2.15 2.15 0 014.275-.235l.017.153.143 6.06a1.397 1.397 0 001.017 1.402 1.643 1.643 0 001.846-.946c.378-.641 7.553-13.733 7.553-13.733a1.538 1.538 0 011.204-.833l.14-.009zM8.233 19.47l.138.11 3.713 3.22a.77.77 0 01.256.466l.009.11.094 4.798a.312.312 0 01-.468.294l-.06-.046-6.384-5.636a2.126 2.126 0 01-.099-3.1c.758-.759 1.95-.84 2.8-.216zM20.576 3.088c.498.186.842.637.895 1.157l.007.132-.014 10.345a.846.846 0 00.726.812.839.839 0 00.932-.598l.023-.103 1.224-7.972a1.466 1.466 0 011.464-1.263 1.406 1.406 0 011.352 1.545s-.427 7.726-.95 9.57v.004l-.083.163a315.91 315.91 0 01-1.942 3.798l-.277.529c-1.015 1.935-2.035 3.798-2.28 3.961a.511.511 0 01-.854-.223l-.018-.09-.038-1.743a3.816 3.816 0 00-3.243-3.998 5.216 5.216 0 00-2.762.409l-.257.122-.018.003a.511.511 0 01-.557-.343l-.021-.09-.02-.19L12.46 5.773a1.634 1.634 0 01.382-1.29 1.538 1.538 0 012.66.672l.024.137 1.334 9.361a.692.692 0 00.828.597.71.71 0 00.523-.567l.01-.104.487-10.212c.01-.33.131-.645.343-.897.38-.43.988-.582 1.526-.381z"
});

function SvgSignLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$O);
}

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$N = /*#__PURE__*/React.createElement("path", {
  d: "M45.273 6.395L39.39 1H20v11H8.611L3.13 17.025a2 2 0 000 2.95L8.61 25H20v22h8V14h11.389l5.883-5.394a1.499 1.499 0 00.001-2.211zM26 45h-4V25h4v20zm0-22H9.389L4.48 18.5 9.39 14H26v9zm12.611-11H22V3h16.611l4.909 4.5L38.61 12z"
});

function SvgSignpost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$N);
}

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$M = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.675 22.608a1.262 1.262 0 01-1.627.171 1.246 1.246 0 01-.432-1.557l3.391-7.321-1.936-.007c-.424 0-.82-.214-1.051-.57a1.244 1.244 0 01-.103-1.176L27.518 1.5h8.587l-3.931 5.907h4.066c.505 0 .961.3 1.16.764.196.46.099.992-.247 1.353L24.675 22.608zM28.833 3.5l-3.63 8.398 3.93.013-2.813 6.074 8.18-8.577h-6.06L32.37 3.5h-3.538zM2 44.5h44v2H2v-2zm12.25-3a1 1 0 100-2 1 1 0 000 2zm-9-1a1 1 0 11-2 0 1 1 0 012 0zm4-2a1 1 0 100-2 1 1 0 000 2zm35.5 2a1 1 0 11-2 0 1 1 0 012 0zm-11 1a1 1 0 100-2 1 1 0 000 2zm6-4a1 1 0 11-2 0 1 1 0 012 0zm-1.087-5c1.142 0 2.236-.46 3.035-1.274A6.182 6.182 0 0146 29.5v2a4.205 4.205 0 00-3.036 1.274 6.223 6.223 0 01-8.602 0 4.203 4.203 0 00-3.035-1.274 3.781 3.781 0 00-1.663.344l.485 2.475c.05.613.01 1.23-.116 1.83a6.176 6.176 0 01-4.736 4.716 6.46 6.46 0 01-1.312.135 6.18 6.18 0 01-6.182-6.68l.016-.112.472-2.395a3.835 3.835 0 00-1.599-.313 4.212 4.212 0 00-3.039 1.274 6.238 6.238 0 01-8.615 0A4.214 4.214 0 002 31.5v-2a6.19 6.19 0 014.308 1.727 4.26 4.26 0 006.076 0 6.191 6.191 0 014.308-1.727 5.966 5.966 0 011.99.325l.5-2.535a.691.691 0 00-.173-.534.725.725 0 00-.558-.256H2v-2h16.45a2.725 2.725 0 012.7 3.136l-1.358 6.901a4.147 4.147 0 001.529 3.523 4.25 4.25 0 003.57.846 4.149 4.149 0 003.268-4.37l-1.35-6.859a2.725 2.725 0 012.692-3.177H46v2H29.501a.728.728 0 00-.723.832l.494 2.518a5.922 5.922 0 012.055-.35 6.18 6.18 0 014.301 1.726 4.251 4.251 0 003.035 1.274z",
  fill: "currentColor"
});

function SvgSkinIrritations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$M);
}

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$L = /*#__PURE__*/React.createElement("path", {
  d: "M32 3a5.006 5.006 0 015 5v32a5.006 5.006 0 01-5 5H17a5.006 5.006 0 01-5-5V8a5.006 5.006 0 015-5h15zm0 2H17a3.003 3.003 0 00-3 3v32a3.003 3.003 0 003 3h15a3.003 3.003 0 003-3V8a3.003 3.003 0 00-3-3zm-7.5 31a2 2 0 110 4 2 2 0 010-4z"
});

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$L);
}

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$K = /*#__PURE__*/React.createElement("path", {
  d: "M35.493 4.03A6.797 6.797 0 0030.628 2a6.79 6.79 0 00-4.863 2.03l-1.768 1.79-1.763-1.786A6.794 6.794 0 0017.366 2a6.79 6.79 0 00-4.864 2.03A6.942 6.942 0 0010.5 8.944c0 1.861.711 3.607 2.002 4.914L23.997 25.5l11.496-11.64c2.676-2.709 2.676-7.12 0-9.83zM16.128 14.68h4.834l1.13-1.688 2.678 5.336 2.443-3.648h4.656l-7.872 7.97-7.869-7.97zm17.946-2.232l-.222.225h-7.705l-1.129 1.688-2.679-5.336-2.442 3.648h-5.75l-.226-.228A4.947 4.947 0 0112.5 8.944c0-1.33.505-2.572 1.422-3.5a4.81 4.81 0 013.445-1.437c1.306 0 2.53.511 3.449 1.44l3.182 3.222 3.187-3.226a4.81 4.81 0 013.444-1.436c1.306 0 2.53.51 3.446 1.436 1.906 1.932 1.907 5.074 0 7.005zM21.472 45.27c.103-.365 2.502-9.005.058-13-1.276-2.085-3.634-3.594-5.195-4.593-.425-.271-.953-.61-1.065-.724-.308-.358-.596-.764-1.033-1.38-.365-.513-.828-1.166-1.486-2.052-1.074-1.443-2.376-1.922-3.524-1.8a355.301 355.301 0 00-1.342-5.832c-.583-2.38-2.645-3.202-4.38-2.787-2.868.686-2.55 3.928-2.43 5.147.109 1.12 1.108 11.011 2.367 13.588.99 2.024 2.578 3.564 3.979 4.923.855.83 1.663 1.612 2.204 2.383 1.228 1.745 1.292 3.439 1.366 5.399l.06 1.457h10.216l.205-.729zm-10.21-7.278c-.65-.924-1.524-1.771-2.448-2.668-1.347-1.306-2.739-2.655-3.575-4.366-.835-1.707-1.757-8.652-2.174-12.904-.268-2.726.496-2.91.907-3.007.753-.186 1.665.072 1.97 1.317a358.025 358.025 0 011.422 6.196c-1.152 1.06-1.647 3.009-.37 4.862 1.392 2.024 3.686 5.426 3.687 5.427l1.658-1.119s-2.3-3.412-3.7-5.443c-.668-.971-.406-1.919.2-2.351.545-.392 1.438-.39 2.307.779.647.87 1.102 1.51 1.46 2.016.468.66.778 1.096 1.146 1.525.26.303.672.573 1.505 1.106 1.406.9 3.531 2.26 4.567 3.952 1.498 2.449.573 7.991-.086 10.685h-6.766c-.082-1.942-.26-3.944-1.71-6.007zm25.747 6.55c.074-1.96.138-3.654 1.366-5.4.541-.77 1.349-1.553 2.204-2.382 1.401-1.359 2.99-2.899 3.979-4.923 1.26-2.577 2.258-12.468 2.368-13.588.12-1.22.437-4.46-2.43-5.147-1.742-.415-3.799.407-4.38 2.787a355.823 355.823 0 00-1.343 5.832c-1.148-.12-2.45.357-3.524 1.8-.658.886-1.121 1.539-1.486 2.052-.437.616-.725 1.022-1.025 1.372-.12.122-.648.46-1.073.732-1.56 1-3.919 2.508-5.196 4.594-2.443 3.994-.044 12.634.06 13l.204.728h10.215l.06-1.457zm-8.834-11.227c1.037-1.693 3.162-3.054 4.568-3.953.833-.533 1.244-.803 1.505-1.106.368-.429.678-.865 1.146-1.525.358-.505.813-1.146 1.46-2.016.871-1.17 1.763-1.171 2.307-.78.606.433.868 1.38.2 2.352-1.4 2.03-3.7 5.443-3.7 5.443l1.658 1.12c.001-.002 2.295-3.404 3.688-5.428 1.276-1.853.781-3.802-.371-4.862.284-1.28.966-4.333 1.422-6.196.305-1.247 1.217-1.501 1.971-1.317.41.098 1.174.281.906 3.007-.416 4.252-1.34 11.197-2.174 12.904-.836 1.71-2.228 3.06-3.575 4.366-.924.897-1.797 1.744-2.448 2.668-1.45 2.063-1.628 4.065-1.71 6.007h-6.766c-.66-2.694-1.584-8.236-.087-10.684z"
});

function SvgSocialHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$K);
}

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$J = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 4.022A6.816 6.816 0 0030.632 2a6.809 6.809 0 00-4.867 2.023l-1.769 1.783-1.764-1.779A6.813 6.813 0 0017.36 2a6.809 6.809 0 00-4.867 2.023A6.904 6.904 0 0010.49 8.92c0 1.855.712 3.594 2.004 4.897L23.996 25.42 35.5 13.82c2.678-2.7 2.678-7.096 0-9.798zM16.122 14.636h4.837l1.13-1.682 2.68 5.318 2.445-3.636h4.66l-7.878 7.944-7.874-7.944zm17.958-2.224l-.223.224h-7.71l-1.13 1.683-2.68-5.318-2.444 3.635h-5.754l-.226-.227a4.92 4.92 0 01-1.424-3.49c0-1.324.506-2.562 1.424-3.488A4.822 4.822 0 0117.36 4c1.307 0 2.533.51 3.452 1.435l3.184 3.211 3.189-3.215A4.823 4.823 0 0130.632 4c1.307 0 2.531.508 3.448 1.431 1.907 1.925 1.908 5.057 0 6.98zm-9.023 33.073c1.329-.492 16.232-7.387 16.87-7.682a3.572 3.572 0 001.856-2.03 3.572 3.572 0 00-.123-2.748 3.57 3.57 0 00-2.03-1.856 3.562 3.562 0 00-2.733.116c-.079.035-5.654 2.52-9.166 4.081a3.599 3.599 0 00-2.171-3.64s-6.326-2.709-7.302-3.116c-1.982-.824-4.302-.814-6.205.033-1.191.53-2.37 1.096-2.894 1.348L4 30.004v13.995h7.122c.864.193 6.285 1.402 7.404 1.624.935.186 2.117.377 3.365.377 1.043 0 2.134-.133 3.166-.515zM6 32.003h5.583l.443-.21c.515-.247 1.671-.803 2.84-1.324 1.389-.617 3.16-.622 4.624-.013.972.405 7.283 3.107 7.285 3.109a1.596 1.596 0 01.844 2.09 1.6 1.6 0 01-1.443.972 4.153 4.153 0 01-.69-.144l-6.467-2.774-.789 1.837 6.515 2.794c.416.176.847.269 1.274.284.548.056 1.185.038 1.749-.204.872-.373 11.493-5.108 11.96-5.317.386-.181.82-.2 1.22-.055.4.146.72.438.9.824.18.386.2.819.054 1.22-.144.4-.437.72-.82.898-4.297 1.99-15.677 7.235-16.718 7.62-2 .74-4.595.222-5.448.052-1.168-.232-7.402-1.624-7.466-1.638L6 42v-9.997z"
});

function SvgSocialWorkHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$J);
}

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$I = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 1C36.607 1.11 46.891 11.394 47 24.112a22.72 22.72 0 01-22.763 22.89h-.126l-22.99-.122-.12-22.99A22.72 22.72 0 0123.889 1zm-.011 2h-.115A20.72 20.72 0 003.001 23.88l.11 21.01 21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12zM15.8 23.496a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4z"
});

function SvgSpeechBubbleDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$I);
}

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$H = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 1C36.607 1.11 46.891 11.394 47 24.112a22.72 22.72 0 01-22.763 22.89h-.126l-22.99-.122-.12-22.99A22.72 22.72 0 0123.889 1zm-.011 2h-.115A20.72 20.72 0 003.001 23.88l.11 21.01 21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12zM22.75 31.496a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm1-17.5v15h-2v-15h2z"
});

function SvgSpeechBubbleExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$H);
}

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 1C36.607 1.11 46.891 11.394 47 24.112a22.72 22.72 0 01-22.763 22.89h-.126l-22.99-.122-.12-22.99A22.72 22.72 0 0123.889 1zm-.011 2h-.115A20.72 20.72 0 003.001 23.88l.11 21.01 21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12zm-.88 28.495a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm.001-18.5a6 6 0 016 6 6.303 6.303 0 01-5 6.262v4.238h-2v-6.052l.94-.057A4.276 4.276 0 0027 18.995a4 4 0 10-8 0h-2a6 6 0 016-6z"
});

function SvgSpeechBubbleQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$G);
}

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F = /*#__PURE__*/React.createElement("path", {
  d: "M23.89 1C36.607 1.11 46.891 11.394 47 24.112a22.72 22.72 0 01-22.763 22.89h-.126l-22.99-.122-.12-22.99A22.72 22.72 0 0123.889 1zm-.011 2h-.115A20.72 20.72 0 003.001 23.88l.11 21.01 21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12zM28 30.5v2H14v-2h14zm6-6.5v2H14v-2h20zm0-6.5v2H14v-2h20z"
});

function SvgSpeechBubbleText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$F);
}

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E = /*#__PURE__*/React.createElement("path", {
  d: "M24.237 47h-.126l-22.99-.121-.12-22.99A22.72 22.72 0 0123.889 1C36.608 1.109 46.892 11.393 47 24.11a22.72 22.72 0 01-22.762 22.89zM3.11 44.89l21.01.111h.115A20.721 20.721 0 0045 24.121c-.1-11.623-9.498-21.022-21.121-21.12h-.115A20.72 20.72 0 003.001 23.879l.11 21.01z"
});

function SvgSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$E);
}

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D = /*#__PURE__*/React.createElement("path", {
  d: "M43.095 9.79A12.812 12.812 0 0033.96 6h-.001a12.81 12.81 0 00-9.137 3.792c-.198.199-.37.423-.556.635A16.372 16.372 0 0017.584 9h-.003A16.301 16.301 0 005.97 13.81C1.339 18.445.872 23.41 1.023 40.982l.009.983.982.009C3.806 41.99 5.468 42 7.01 42c13.627 0 18.058-.79 22.184-4.923a16.357 16.357 0 003.615-5.475 84.27 84.27 0 009.71.397c1.092 0 2.25-.006 3.471-.017l.983-.01.008-.982c.117-13.683-.25-17.552-3.887-21.2zM27.78 35.662c-3.758 3.764-7.529 4.451-24.765 4.32-.121-17.185.576-20.963 4.369-24.76a14.313 14.313 0 0110.197-4.224h.003a14.317 14.317 0 0110.199 4.227c5.624 5.652 5.623 14.787-.003 20.437zm17.21-5.674c-3.854.1-7.71-.008-11.553-.326a16.336 16.336 0 00-7.356-18.28c.055-.057.101-.123.157-.179A10.823 10.823 0 0133.958 8h.002a10.826 10.826 0 017.719 3.201c2.858 2.866 3.397 5.751 3.31 18.788z"
});

function SvgSpeechBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$D);
}

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 32.458c.013-11.592 9.408-20.987 21-21 11.593.013 20.987 9.408 21 21v1h-6v-2h3.974a18.915 18.915 0 00-4.866-11.696l-2.797 2.798-1.414-1.414 2.793-2.794A18.9 18.9 0 0025 13.507v3.951h-2v-3.95a18.9 18.9 0 00-11.69 4.844l2.793 2.794-1.414 1.414-2.797-2.798a18.915 18.915 0 00-4.866 11.696H9v2H3v-1zm25.312-12.5l-3.744 8.558a3.94 3.94 0 00-.568-.058 4.041 4.041 0 102.404.824l3.73-8.527-1.822-.797zM24 34.458a2 2 0 110-4 2 2 0 010 4z",
  fill: "currentColor"
});

function SvgSpeedometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$C);
}

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B = /*#__PURE__*/React.createElement("path", {
  d: "M22.354 8.5l.124.857c.978 6.8 6.642 7.189 8.36 7.143l.693-.017.26.643c.158.376 1.552 2.899 2.99 5.453l.346.613c1.323 2.342 2.603 4.568 2.913 5.032.492.737 1.39 1.324 4.167 1.786a4.71 4.71 0 013.352 2.058c1.266 1.96.914 4.718.396 6.687l-.196.745H27.074l-21-21 10-10h6.28zM35.43 27.749l-13.608 3.67 6.08 6.081h16.294c.274-1.331.443-3.17-.317-4.345a2.76 2.76 0 00-2-1.173c-2.521-.42-4.421-1.03-5.503-2.647a45.4 45.4 0 01-.946-1.586zM16.574 33.5v2h-15v-2h15zm16.05-10.677L17.31 26.908l2.88 2.88 14.209-3.833c-.563-.985-1.18-2.074-1.775-3.132zM10.574 27.5v2h-9v-2h9zm10.075-17h-3.747l-8 8 6.775 6.775 15.942-4.253c-.577-1.04-1.07-1.942-1.374-2.523a9.587 9.587 0 01-9.596-7.999z"
});

function SvgSport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$B);
}

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 46.5h-2v-8.56a3.443 3.443 0 013.44-3.44h7.56v-7.56a3.443 3.443 0 013.44-3.44h7.56v-7.56a3.443 3.443 0 013.44-3.44h7.56V4.94a3.443 3.443 0 013.44-3.44h8.56v2h-8.56a1.44 1.44 0 00-1.44 1.44v9.56h-9.56a1.44 1.44 0 00-1.44 1.44v9.56h-9.56a1.44 1.44 0 00-1.44 1.44v9.56H4.94a1.44 1.44 0 00-1.44 1.44v8.56z"
});

function SvgStaircase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$A);
}

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z = /*#__PURE__*/React.createElement("path", {
  d: "M11.314 46.25a2.477 2.477 0 01-2.434-2.891l2.205-13.03-9.351-9.221a2.506 2.506 0 01-.614-2.538 2.459 2.459 0 011.978-1.688l12.93-1.909 5.776-11.839a2.447 2.447 0 014.408.002l5.775 11.836 12.907 1.9c.93.139 1.699.794 1.983 1.689a2.5 2.5 0 01-.606 2.537l-9.359 9.222 2.204 13.026a2.47 2.47 0 01-3.57 2.614L24 39.817l-11.545 6.142c-.35.192-.742.292-1.14.291zM24.008 3.753a.46.46 0 00-.403.252L17.362 16.8 3.394 18.863a.47.47 0 00-.372.326.492.492 0 00.116.492l10.093 9.953-2.378 14.055a.468.468 0 00.176.457.438.438 0 00.472.052l12.498-6.65L36.48 44.19c.145.09.332.076.462-.035a.495.495 0 00.2-.48l-2.377-14.05L44.86 19.68a.507.507 0 00.115-.501.472.472 0 00-.376-.326l-13.946-2.052-6.238-12.787a.457.457 0 00-.407-.26z"
});

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$z);
}

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y = /*#__PURE__*/React.createElement("path", {
  d: "M42.016 17.5H38.66a12.722 12.722 0 01-.903-4.5c.033-1.745.42-3.466 1.138-5.057l.711-1.443H5.984C3.534 6.5 1 8.932 1 13s2.534 6.5 4.984 6.5H9.34a12.65 12.65 0 01.9 4.5 12.724 12.724 0 01-.902 4.5H3.387l.717 1.445A12.75 12.75 0 015.241 35a12.872 12.872 0 01-1.137 5.057L3.393 41.5h33.623C39.466 41.5 42 39.068 42 35a7.442 7.442 0 00-1.363-4.5h1.379C44.466 30.5 47 28.068 47 24s-2.534-6.5-4.984-6.5zm-36.032 0C4.549 17.5 3 15.78 3 13c0-2.78 1.549-4.5 2.984-4.5h30.545a14.448 14.448 0 00-.77 4.5c.016 1.531.276 3.05.77 4.5H5.984zM40 35c0 2.78-1.55 4.5-2.984 4.5H6.47c.493-1.45.753-2.969.77-4.5a14.463 14.463 0 00-.77-4.5h30.545C38.45 30.5 40 32.22 40 35zm2.016-6.5H11.47c.493-1.45.753-2.969.77-4.5a14.463 14.463 0 00-.77-4.5h30.545C43.45 19.5 45 21.22 45 24c0 2.78-1.55 4.5-2.984 4.5z"
});

function SvgStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$y);
}

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 1h2v8h-2V1zM12 24c0-6.627 5.373-12 12-12 6.624.007 11.993 5.376 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12zm2 0c0 5.523 4.477 10 10 10 5.52-.007 9.993-4.48 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10zm11 23v-8h-2v8h2zM1 23h8v2H1v-2zm46 0h-8v2h8v-2zM7.03 8.443L8.442 7.03l5.658 5.658-1.415 1.414L7.03 8.443zM35.312 33.9L33.9 35.313l5.658 5.658 1.414-1.414-5.657-5.658zM7.03 39.557l5.658-5.658 1.414 1.414-5.658 5.658-1.414-1.414zM39.557 7.029l-5.658 5.658 1.414 1.414 5.658-5.658-1.414-1.414z",
  fill: "currentColor"
});

function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$x);
}

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w = /*#__PURE__*/React.createElement("path", {
  d: "M20.999.838l.643.535a35.912 35.912 0 009.499 5.203A8.986 8.986 0 0145 14.14a9.007 9.007 0 01-6 8.475v5.525c0 6.443-11.353 17.637-17.796 18.979l-.204.043-.204-.043C14.353 45.777 3 34.583 3 28.14V8.585l.84-.135a37.607 37.607 0 0016.518-7.076L21 .838zm.002 2.57A39.683 39.683 0 015 10.278V28.14c0 5.422 10.37 15.61 16 16.975 5.63-1.365 16-11.553 16-16.975v-5.059A8.98 8.98 0 0129.403 8.04a38.885 38.885 0 01-8.402-4.631zM36 7.14a7 7 0 100 14 7.008 7.008 0 007-7 7 7 0 00-7-7zm1 2v4h4v2h-4v4h-2v-4h-4v-2h4v-4h2z"
});

function SvgSupplementaryInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$w);
}

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v = /*#__PURE__*/React.createElement("path", {
  d: "M14.054 30.142a8 8 0 016.205-.031c.976.405 7.302 3.114 7.302 3.114a3.599 3.599 0 012.171 3.64l2.904-1.291.509-.227.254-.113.506-.225 4.994-2.225a3.595 3.595 0 013.03 6.518c-.304.141-3.853 1.783-7.627 3.516l-.733.336c-3.912 1.795-7.857 3.589-8.51 3.83a9.134 9.134 0 01-3.168.516 17.336 17.336 0 01-3.364-.377c-1.12-.222-6.54-1.431-7.405-1.623H4V31.503l7.16-.013c.523-.252 1.702-.82 2.894-1.348zm5.437 1.814a6.04 6.04 0 00-4.625.013c-1.17.52-2.326 1.076-2.84 1.323l-.443.211H6V43.5l5.45.025c.032.006 1.607.358 3.32.737l.516.114c1.554.343 3.105.682 3.631.787 1.792.442 3.665.424 5.448-.053.638-.236 5.16-2.298 9.555-4.317l.693-.318c2.53-1.163 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.356-2.888c-.242.108-3.214 1.434-6.141 2.737l-.626.279c-2.492 1.109-4.805 2.136-5.193 2.302-.548.21-1.14.28-1.722.206a3.57 3.57 0 01-1.3-.287l-6.516-2.793.789-1.837 6.468 2.773c.226.068.458.117.693.145a1.596 1.596 0 00.595-3.064c-.002 0-6.313-2.702-7.285-3.107zM24 1l6.361 6.315a8.9 8.9 0 010 12.65A8.98 8.98 0 0125 22.515V27h-2v-4.485a8.98 8.98 0 01-5.361-2.55 8.9 8.9 0 010-12.65L24 1zm1 3.81v9.418l3.024-1.734.995 1.734L25 16.534v3.965a6.982 6.982 0 003.953-1.954A6.865 6.865 0 0031 13.639a6.865 6.865 0 00-2.047-4.904L25 4.81zm-2 0l-3.953 3.925a6.901 6.901 0 000 9.81A6.976 6.976 0 0023 20.499v-3.96l-4.026-2.31.996-1.735L23 14.232V4.811z"
});

function SvgSustainability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$v);
}

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.745 15.582a2.205 2.205 0 01.578-2.114L45.75 7.04l-1.411-1.412-6.428 6.428a4.208 4.208 0 00-1.096 4.036l1.121 4.233a1.542 1.542 0 01-.856 1.842c-.51.193-1.086.07-1.472-.315a1.343 1.343 0 01-.354-.617l-.698-2.639a7.262 7.262 0 00-5.152-5.152l-2.64-.699a1.353 1.353 0 01-.868-.7 1.397 1.397 0 01-.053-1.15 1.526 1.526 0 011.825-.835l4.24 1.124a4.202 4.202 0 004.036-1.097L42.37 3.66l-1.411-1.411-6.427 6.427a2.197 2.197 0 01-2.114.578l-4.24-1.123a3.544 3.544 0 00-4.197 2.045c-.35.903-.3 1.913.137 2.777a3.368 3.368 0 002.136 1.722l2.64.699a5.262 5.262 0 013.732 3.733l.698 2.638a3.36 3.36 0 003.269 2.504c.4 0 .797-.07 1.173-.208a3.53 3.53 0 002.1-4.227l-1.12-4.233zm-15.822 4.36a1.5 1.5 0 10-.816-2.885 1.5 1.5 0 00.816 2.886zm5.996 1.01a1.5 1.5 0 10-2.122-2.12 1.5 1.5 0 002.122 2.12zm-5.98 3.858a1.5 1.5 0 102.121-2.121 1.5 1.5 0 00-2.121 2.121zm-3.858 3.859a1.5 1.5 0 112.122-2.121 1.5 1.5 0 01-2.122 2.12zm4.915.156a1.5 1.5 0 112.978.35 1.5 1.5 0 01-2.979-.35zm5.662-5.033a1.5 1.5 0 10-.816 2.886 1.5 1.5 0 00.816-2.886zm-9.731-.598a1.5 1.5 0 11-2.354-1.858 1.5 1.5 0 012.354 1.859zm-.82 9.431l2.639.699a3.367 3.367 0 012.136 1.722c.438.864.487 1.874.137 2.777a3.536 3.536 0 01-4.197 2.045l-4.24-1.123a2.203 2.203 0 00-2.115.578L7.041 45.75 5.63 44.339l6.426-6.427a4.213 4.213 0 014.036-1.097l4.24 1.123a1.522 1.522 0 001.824-.833c.15-.373.13-.793-.052-1.151a1.352 1.352 0 00-.869-.7l-2.639-.699a7.264 7.264 0 01-5.152-5.152l-.698-2.64a1.344 1.344 0 00-.354-.617 1.386 1.386 0 00-1.472-.314 1.542 1.542 0 00-.857 1.842l1.121 4.233a4.207 4.207 0 01-1.096 4.036L3.66 42.371l-1.41-1.412 6.426-6.427a2.205 2.205 0 00.578-2.114l-1.12-4.233a3.532 3.532 0 012.1-4.227 3.406 3.406 0 013.57.778c.42.42.72.944.871 1.518l.699 2.638a5.262 5.262 0 003.733 3.733z",
  fill: "currentColor"
});

function SvgSynapses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$u);
}

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.6 12.361c0 .048-.002.095-.003.142a9.302 9.302 0 01-3.978 17.747l-27.512-.053A8.39 8.39 0 014.05 27.73 10.519 10.519 0 011 20.235a9.894 9.894 0 012.98-7.082 10.072 10.072 0 016.96-2.93 11.626 11.626 0 0119.764-5.338 7.836 7.836 0 012.831-.532A8.046 8.046 0 0141.6 12.36zM10.11 28.197l27.51.053a7.303 7.303 0 002.88-14.046l-1.027-.43.108-1.107c.011-.101.017-.204.017-.306a6.043 6.043 0 00-6.063-6.008 5.895 5.895 0 00-2.359.499l-1.007.438-.728-.823a9.624 9.624 0 00-16.62 4.53l-.24 1.257-1.51-.031a8.064 8.064 0 00-5.686 2.354A7.908 7.908 0 003 20.235a8.509 8.509 0 002.451 6.066 6.452 6.452 0 004.66 1.896zm19.14 8.553a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm2 0a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm-6 3a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
  fill: "currentColor"
});

function SvgThoughts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$t);
}

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s = /*#__PURE__*/React.createElement("path", {
  d: "M25 41.378V47h-2v-5.622h2zm11.995-5.797l3.976 3.976-1.414 1.414-3.976-3.976 1.414-1.414zm-25.99 0l1.414 1.414-3.975 3.975-1.414-1.414 3.975-3.975zM29.525 11A6.493 6.493 0 0136 17.497a8.701 8.701 0 01-1.25 3.645 7.728 7.728 0 00-.71 1.627l-.027.204c-1.028 7.65-1.659 12.49-1.733 13.282a2.942 2.942 0 01-2.612 2.731c-.089.01-.18.014-.27.014a3.275 3.275 0 01-3.087-2.552c-.271-.906-1.082-3.342-2.302-6.918l-.001.001-.085.249c-.675 1.968-1.784 5.21-2.185 6.51l-.049.158a3.248 3.248 0 01-3.357 2.538 2.94 2.94 0 01-2.61-2.731c-.01-.107-.03-.288-.06-.539l-.03-.232c-.217-1.788-.797-6.202-1.648-12.538l-.023-.175a7.716 7.716 0 00-.711-1.627A8.714 8.714 0 0112 17.497 6.494 6.494 0 0118.476 11a6.316 6.316 0 013.282.926c.233.119.46.251.679.395.919.718 2.208.718 3.127 0 .244-.158.495-.304.753-.436A6.207 6.207 0 0129.525 11zm0 2a4.32 4.32 0 00-2.243.635c-.223.115-.44.24-.651.378a4.511 4.511 0 01-5.26 0 6.195 6.195 0 00-.578-.337A4.437 4.437 0 0018.476 13 4.492 4.492 0 0014 17.497a7.715 7.715 0 001.03 2.733c.422.706.73 1.474.913 2.276l.024.174.502 3.755.09.678.137 1.023.09.68c.449 3.393.861 6.563.926 7.251a.93.93 0 00.816.93c.442.045.978-.231 1.245-1.123.398-1.324 1.782-5.354 2.446-7.29.209-.605.35-1.017.374-1.09.205-.602.772-1.003 1.407-.995a1.487 1.487 0 011.42.978l.063.183c.302.883.686 2.006 1.072 3.147l.232.686c.616 1.825 1.202 3.587 1.44 4.381.268.892.82 1.17 1.245 1.122a.93.93 0 00.817-.929c.105-1.117 1.136-8.85 1.741-13.36l.028-.204a7.843 7.843 0 01.913-2.274A7.696 7.696 0 0034 17.497 4.49 4.49 0 0029.525 13zM6.622 23v2H1v-2h5.622zM47 23v2h-5.622v-2H47zM39.557 7.03l1.414 1.414-3.976 3.975-1.414-1.414 3.976-3.975zm-31.113 0l3.975 3.975-1.414 1.414L7.03 8.444 8.444 7.03zM25 1v5.622h-2V1h2z"
});

function SvgToothCleaning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$s);
}

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r = /*#__PURE__*/React.createElement("path", {
  d: "M32.5 19.91H31v-3.887A3.025 3.025 0 0027.981 13H8.02A3.025 3.025 0 005 16.023v3.888H3.5A2.504 2.504 0 001 22.414v3.755h2v-3.755c0-.276.225-.5.5-.5H5v17.604c0 1.66 1.345 3.01 3 3.02v2.209a2.504 2.504 0 002.5 2.503h2.25c1.379 0 2.5-1.123 2.5-2.503V42.54h5.5v2.207a2.504 2.504 0 002.5 2.503h2.25c1.379 0 2.5-1.123 2.5-2.503v-2.208c1.655-.01 3-1.361 3-3.021V21.914h1.5c.275 0 .5.224.5.5v3.755h2v-3.755a2.504 2.504 0 00-2.5-2.503zM8.019 15.004H27.98A1.02 1.02 0 0129 16.023v.982H7v-.982c0-.563.457-1.02 1.019-1.02zM7 28.02v-9.013h10v9.013H7zm12-9.013h10v9.013H19v-9.013zm-5.75 25.739c0 .275-.225.5-.5.5H10.5a.501.501 0 01-.5-.5V42.54h3.25v2.207zm12.25.5h-2.25a.501.501 0 01-.5-.5V42.54H26v2.207c0 .275-.225.5-.5.5zm2.481-4.71H8.02A1.02 1.02 0 017 39.518v-9.494h22v9.495a1.02 1.02 0 01-1.019 1.02zM12 32.028a3.005 3.005 0 000 6.007 3.005 3.005 0 000-6.008zm0 4.005a1.001 1.001 0 010-2.003 1.001 1.001 0 010 2.003zm12.536-4.006a3.005 3.005 0 000 6.008 3.005 3.005 0 000-6.008zm0 4.006a1.001 1.001 0 010-2.003 1.001 1.001 0 010 2.003zm20.77-20.409l.658 1.889A8.802 8.802 0 0143.06 18c-3.553 0-6.61-2.106-7.95-5.108h-3.444v-2h2.846a8.32 8.32 0 01-.126-1.392c0-.532.056-1.05.152-1.555h-2.872v-2h3.525A8.69 8.69 0 0143.061 1c1.01 0 1.999.168 2.939.5l-.666 1.887A6.801 6.801 0 0043.061 3a6.716 6.716 0 00-5.58 2.945h4.306v2h-5.2a6.31 6.31 0 00-.2 1.555c0 .478.057.943.158 1.392h5.242v2h-4.409A6.708 6.708 0 0043.061 16a6.81 6.81 0 002.245-.377z"
});

function SvgTransportSubsidy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$r);
}

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q = /*#__PURE__*/React.createElement("path", {
  d: "M27.363 22.5l6.12 5.1 11.381 3.395a3.003 3.003 0 012.051 3.58L45.418 40.5h-6.842a4.99 4.99 0 01-9.152 0H17.576a4.994 4.994 0 01-9.177-.046l-.085-.004-5.189-1.702A3.008 3.008 0 011 35.878v-2.385l3.627-6.481 1.746.976L3 34.015v1.864c.003.443.294.833.719.96l4.307 1.412A4.99 4.99 0 0118 38.5h11a5 5 0 1110 0h4.862l1.112-4.405a.999.999 0 00-.686-1.185l-11.77-3.51-5.88-4.9H24v-2h3.363zM13 35.5a3 3 0 100 6 3 3 0 000-6zm21 0a3 3 0 100 6 3 3 0 000-6zm-21.5-31C18.851 4.5 24 9.649 24 16s-5.149 11.5-11.5 11.5C6.152 27.493 1.008 22.348 1 16 1 9.649 6.15 4.5 12.5 4.5zm0 2A9.51 9.51 0 003 16a9.5 9.5 0 109.5-9.5zM7.476 13a6.495 6.495 0 017.969-3.114l-.68 1.88A4.465 4.465 0 009.907 13h2.649v2H8.858a4.19 4.19 0 000 2h3.698v2h-2.65a4.47 4.47 0 004.84 1.241l.67 1.885A6.498 6.498 0 017.476 19H5v-2h1.822a5.911 5.911 0 010-2H5v-2z"
});

function SvgTravelExpenses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$q);
}

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p = /*#__PURE__*/React.createElement("path", {
  d: "M42 12.497h-7v-2a4.784 4.784 0 00-5-5H18a4.784 4.784 0 00-5 5v2H6a4.685 4.685 0 00-5 5v20a4.685 4.685 0 005 5h36a4.685 4.685 0 005-5v-20a4.685 4.685 0 00-5-5zm-27-2a2.811 2.811 0 013-3h12a2.811 2.811 0 013 3v2H15v-2zm18 4v26H15v-26h18zm-30 23v-20a2.706 2.706 0 013-3h7v26H6a2.706 2.706 0 01-3-3zm42 0a2.706 2.706 0 01-3 3h-7v-26h7a2.706 2.706 0 013 3v20z"
});

function SvgTravel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$p);
}

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.407c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V30.8l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003v9.997l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zm9.134-8.898l.698 1.427 1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.427zm5.238-1.428l.698 1.427 1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.427zm-10.443 0l.699 1.427 1.56.23-1.13 1.11.268 1.568-1.397-.74-1.396.74.266-1.568-1.13-1.11 1.562-.23.698-1.427zm14.374-3.868l.699 1.427 1.56.23-1.13 1.11.268 1.568-1.397-.74-1.396.74.266-1.568-1.13-1.11 1.562-.23.698-1.427zm-18.254 0l.699 1.427 1.56.23-1.13 1.11.268 1.568-1.397-.74-1.396.74.266-1.568-1.13-1.11 1.562-.23.698-1.427zm19.575-5.289l.698 1.427 1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.569-1.13-1.11 1.562-.229.698-1.427zm-20.98 0l.698 1.427 1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.569-1.13-1.11 1.562-.229.698-1.427zm19.575-5.287l.698 1.427 1.562.228-1.13 1.111.266 1.57-1.396-.742-1.397.741.267-1.569-1.13-1.11 1.56-.229.7-1.427zm-18.17 0l.699 1.427 1.56.228-1.13 1.111.268 1.57-1.397-.742-1.396.741.266-1.569-1.13-1.11 1.562-.229.698-1.427zm3.847-3.865l.699 1.427 1.56.23-1.13 1.11.268 1.568-1.397-.74-1.397.74.267-1.569-1.13-1.11 1.562-.229.698-1.427zm10.476 0l.698 1.427 1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.569-1.13-1.11 1.562-.229.698-1.427zm-5.238-1.428L24.7 2.63l1.562.23-1.13 1.11.267 1.568-1.397-.74-1.397.74.267-1.568-1.13-1.11 1.562-.23.698-1.427z"
});

function SvgTreatmentEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$o);
}

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM25.003 1c6.9.008 12.492 5.6 12.5 12.5 0 6.904-5.597 12.5-12.5 12.5-6.904 0-12.5-5.596-12.5-12.5 0-6.903 5.596-12.5 12.5-12.5zm3.167 17.036h-6.334c.675 3.736 2.098 5.964 3.167 5.964s2.491-2.228 3.167-5.964zm-8.357 0h-4.266a10.54 10.54 0 005.98 5.36 16.881 16.881 0 01-1.714-5.36zm14.645 0h-4.265a16.875 16.875 0 01-1.714 5.36 10.539 10.539 0 005.98-5.36zm.77-6.885H30.46c.065.78.098 1.568.098 2.35 0 .844-.041 1.694-.116 2.535h4.738c.211-.83.32-1.68.323-2.536a10.473 10.473 0 00-.275-2.35zm-6.769 0h-6.912a27.483 27.483 0 00.019 4.885h6.874a27.318 27.318 0 00.019-4.885zm-8.914 0h-4.768c-.18.77-.272 1.558-.274 2.35.003.855.111 1.706.322 2.535h4.739a28.72 28.72 0 01-.117-2.536c0-.781.034-1.57.098-2.35zm8.934-7.547A17.113 17.113 0 0130.22 9.15h4.328a10.541 10.541 0 00-6.069-5.547zM25.003 3C23.916 3 22.46 5.3 21.8 9.15h6.406C27.546 5.3 26.09 3 25.003 3zm-3.477.604a10.54 10.54 0 00-6.068 5.547h4.327c.26-1.935.849-3.81 1.741-5.547z"
});

function SvgTreatmentForeignCountries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$n);
}

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m = /*#__PURE__*/React.createElement("path", {
  d: "M20.262 29.61c.975.406 7.301 3.115 7.301 3.115a3.6 3.6 0 012.173 3.64c3.294-1.464 8.398-3.739 9.088-4.046l.065-.03.012-.005a3.594 3.594 0 013.03 6.518c-.638.295-15.541 7.191-16.87 7.683a9.132 9.132 0 01-3.166.514 17.351 17.351 0 01-3.366-.376c-.67-.133-2.89-.622-4.746-1.033l-.602-.134c-.973-.215-1.767-.393-2.056-.457H4.003V31.003l7.16-.013c.523-.252 1.702-.819 2.894-1.348a7.997 7.997 0 016.205-.032zm-5.393 1.858c-1.169.52-2.326 1.077-2.84 1.324l-.444.211H6.003V43l5.45.024c.035.007 1.937.432 3.836.851l.516.114c1.37.302 2.648.58 3.115.673 1.79.442 3.665.424 5.447-.052.639-.236 5.161-2.298 9.556-4.317l.692-.318c2.53-1.164 4.947-2.28 6.472-2.985a1.595 1.595 0 00-1.355-2.888c-.468.21-11.088 4.945-11.96 5.318a3.556 3.556 0 01-1.752.202 3.57 3.57 0 01-1.271-.283l-6.515-2.793.788-1.837 6.47 2.773c.224.067.454.116.687.144a1.594 1.594 0 00.6-3.062c-.003-.001-6.313-2.704-7.286-3.109a6.04 6.04 0 00-4.624.013zM27.003 1a2.002 2.002 0 012 2v6h6a2.002 2.002 0 012 2v4a2.002 2.002 0 01-2 2h-6v6a2.002 2.002 0 01-2 2h-4a2.002 2.002 0 01-2-2v-6h-6a2.002 2.002 0 01-2-2v-4a2.002 2.002 0 012-2h6V3a2.002 2.002 0 012-2h4zm0 2h-4v8h-8v4h8v8h4v-8h8v-4h-8V3z"
});

function SvgTreatment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$m);
}

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l = /*#__PURE__*/React.createElement("path", {
  d: "M36.007 6.125V1H12.002v5.125H5v9.05a7.334 7.334 0 007.327 7.325h1.233c1.903 4.046 5.378 7.438 9.444 7.926V39h-6.001a5.006 5.006 0 00-5.001 5v3h24.005v-3a5.006 5.006 0 00-5.001-5h-6.001v-8.574c4.066-.488 7.541-3.88 9.444-7.926h1.225A7.334 7.334 0 0043 15.175v-9.05h-6.993zm-2 37.875v1H14.002v-1a3.004 3.004 0 013-3h14.004a3.004 3.004 0 013 3zm-21.68-23.5A5.332 5.332 0 017 15.175v-7.05h5.002V16c.02 1.531.279 3.05.769 4.5h-.444zm11.677 8c-5.387 0-10.002-6.873-10.002-12.5V3h20.005v13c0 5.627-4.616 12.5-10.003 12.5zM41 15.175a5.331 5.331 0 01-5.326 5.325h-.436c.49-1.45.75-2.969.77-4.5V8.125h4.991v7.05z"
});

function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$l);
}

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.988 3.04c10.608.418 19.542 7.386 20.988 16.563l.274 2.186-1.798-1.187a9.544 9.544 0 00-9.704.008l-.654.403-.559-.53a5.544 5.544 0 00-4.053-1.384 7.34 7.34 0 00-4.494 1.745l-.001 21.267a5 5 0 01-9.999-.11h2a3 3 0 006 0V21.03c-2.22-2.044-5.37-1.954-8.705.298l-.627.423-.578-.487c-4.263-3.599-9.378-.762-9.594-.639L1.75 21.652l.25-2.05c1.446-9.174 10.38-16.143 20.988-16.56V1h2v2.04zm4.419 14.06a7.582 7.582 0 014.924 1.442 11.208 11.208 0 019.235-.548C41.33 10.465 33.284 5 23.988 5c-9.33 0-17.401 5.505-19.602 13.078a11.979 11.979 0 013.752-.633 9.394 9.394 0 015.643 1.83c3.7-2.253 7.376-2.293 10.107-.132a9.401 9.401 0 015.519-2.042z",
  fill: "currentColor"
});

function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$k);
}

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.16 8.36a37.623 37.623 0 01-16.518-7.075L23.999.75l-.64.535A37.623 37.623 0 016.84 8.36L6 8.496v19.735c0 6.442 11.352 17.634 17.796 18.977l.204.042.204-.042C30.648 45.865 42 34.672 42 28.23V8.496l-.84-.136zM40 28.23c0 5.422-10.37 15.609-16 16.974C18.37 43.839 8 33.652 8 28.23V10.189A39.698 39.698 0 0024 3.32a39.698 39.698 0 0016 6.87v18.04zM19 12.75v3h-4a2.002 2.002 0 00-2 2v11a2.002 2.002 0 002 2h.086l-1.793 1.793 1.414 1.414 3.207-3.207H33a2.002 2.002 0 002-2v-11a2.002 2.002 0 00-2-2h-.086l1.793-1.793-1.414-1.414-3.207 3.207H29v-3a2.002 2.002 0 00-2-2h-6a2.002 2.002 0 00-2 2zm-1.914 16H15v-6h8.086l-6 6zm2.828 0h13.087v-6h-7.087l-6 6zm11-11H33v3h-5.086l3-3zm-5.828 3l3-3H15v3h10.086zm1.914-5h-6v-3h6v3z",
  fill: "currentColor"
});

function SvgUnemploymentInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$j);
}

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i = /*#__PURE__*/React.createElement("path", {
  d: "M14.66 6c.184 0 .365.051.522.147l8.493 5.196H41.81A5.195 5.195 0 0147 16.53v19.783a5.195 5.195 0 01-5.19 5.187H6.19A5.195 5.195 0 011 36.313V11.188A5.195 5.195 0 016.19 6h8.47zm-.282 2H6.19A3.192 3.192 0 003 11.188v25.125A3.192 3.192 0 006.19 39.5h35.62A3.192 3.192 0 0045 36.313V16.53a3.192 3.192 0 00-3.19-3.187H23.393a.996.996 0 01-.522-.148L14.378 8zm10.316 9.78l7.5 7.222-1.388 1.441L25 20.851V34.5h-2V20.852l-5.806 5.591-1.388-1.441 7.5-7.223a1 1 0 011.388 0z"
});

function SvgUploadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$i);
}

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h = /*#__PURE__*/React.createElement("path", {
  d: "M4 30v10a3.003 3.003 0 003 3h34a3.003 3.003 0 003-3V30h2v10a5.006 5.006 0 01-5 5H7a5.006 5.006 0 01-5-5V30h2zM24.694 3.28l13.5 13-1.388 1.441L25 6.352V37h-2V6.352l-11.806 11.37-1.388-1.442 13.5-13a1 1 0 011.388 0z"
});

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$h);
}

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g = /*#__PURE__*/React.createElement("path", {
  d: "M24 25a43.246 43.246 0 0120.567 5.125l.683.377-.199.752C42.646 40.378 33.792 47 24 47c-9.791 0-18.645-6.622-21.051-15.746l-.199-.752.683-.377A43.251 43.251 0 0124 25zm0 2a41.413 41.413 0 00-18.893 4.499 19.97 19.97 0 0037.786 0A41.407 41.407 0 0024 27zm0-26c5.523 0 10 4.477 10 10-.006 5.52-4.48 9.994-10 10-5.523 0-10-4.477-10-10S18.477 1 24 1zm0 2a8 8 0 108 8 8.01 8.01 0 00-8-8z"
});

function SvgUserAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$g);
}

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f = /*#__PURE__*/React.createElement("path", {
  d: "M46.75 45.333L34.546 33.131l2.507-2.507a1.84 1.84 0 000-2.692L15.222 6.1a1.84 1.84 0 00-2.692 0l-2.507 2.507-3.018-3.019 2.922-2.921L8.51 1.25 1.25 8.51l1.417 1.417 2.921-2.922 3.019 3.018L6.1 12.53a1.84 1.84 0 000 2.692l21.832 21.831a1.84 1.84 0 002.692 0l2.506-2.506L45.333 46.75l1.417-1.417zm-17.473-9.77L7.589 13.875l6.288-6.285 3.403 3.403-2.508 2.509 1.416 1.416 2.509-2.508 3.114 3.115-2.507 2.508 1.416 1.416 2.508-2.507 3.114 3.115-2.507 2.507 1.416 1.416 2.508-2.506 3.114 3.115-2.507 2.507 1.416 1.416 2.508-2.507 3.274 3.275-6.287 6.285z"
});

function SvgVaccination(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$f);
}

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.703 0 23 10.297 23 23-.014 12.697-10.303 22.986-23 23C11.297 47 1 36.703 1 24S11.297 1 24 1zm0 2C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c-.013-11.593-9.407-20.987-21-21zm-5.521 10.387l15.976 8.82a2.048 2.048 0 010 3.586l-15.94 8.8a2.152 2.152 0 01-.963.235c-.377 0-.746-.106-1.066-.306a2.035 2.035 0 01-.97-1.74V15.218a2.047 2.047 0 012.963-1.832zm-.93 1.77l-.033 17.624a.04.04 0 00.022.04l15.95-8.78-15.94-8.884z"
});

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$e);
}

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d = /*#__PURE__*/React.createElement("path", {
  d: "M35.757 9.875l1.41 1.406L10.25 38.125l-1.41-1.406 3.966-3.955a37.737 37.737 0 01-9.503-7.622l-.552-.645.552-.645c.377-.44 9.355-10.789 20.698-10.789a21.08 21.08 0 017.216 1.34l4.541-4.528zm-.665 6.308a37.843 37.843 0 019.606 7.67l.552.644-.552.645C44.32 25.582 35.343 35.93 24 35.93a21.096 21.096 0 01-7.323-1.384l1.575-1.57a18.52 18.52 0 005.748.965c8.851 0 16.452-7.218 18.585-9.445a36.795 36.795 0 00-8.977-6.833zm-4.978 4.965a6.96 6.96 0 01-9.473 9.446l1.502-1.497c.589.243 1.22.369 1.857.371a4.984 4.984 0 004.985-4.97 4.889 4.889 0 00-.372-1.853zM24 15.052c-8.851 0-16.452 7.218-18.585 9.445a36.955 36.955 0 008.883 6.778l3.536-3.526a6.958 6.958 0 019.426-9.4l2.367-2.36A18.438 18.438 0 0024 15.052zm1.747 4.806a4.95 4.95 0 00-6.732 4.64c.004.595.117 1.185.333 1.741z"
});

function SvgVisualImpairment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$d);
}

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.29 8.326a3.368 3.368 0 013.433-.2 3.47 3.47 0 011.902 3.096v25.616a3.395 3.395 0 01-1.86 3.036 3.442 3.442 0 01-1.56.377c-.707 0-1.398-.22-1.974-.63L13.42 31.64H3.626V16.35h9.796L25.29 8.325zm2.566 29.767c.472-.24.77-.725.769-1.255V11.222a1.476 1.476 0 00-.814-1.315 1.351 1.351 0 00-1.384.064l-12.393 8.377H5.625V29.64h8.41l12.332 8.338a1.42 1.42 0 001.488.116zm7.176-21.842l-1.407 1.444a8.655 8.655 0 010 12.611l1.407 1.445a10.654 10.654 0 000-15.5zm2.843-2.538l1.397-1.462a16.37 16.37 0 010 23.75l-1.397-1.463a14.336 14.336 0 000-20.825z",
  fill: "currentColor"
});

function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$c);
}

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 39v2h-6v4h15v-4h-6v-2h14v2h-6v4h6v2h-31v-2h6v-4h-6v-2h14zm-1.462-16.538a5.01 5.01 0 011.462 3.775V36h-14v-9.763A5.01 5.01 0 0113.737 21h3.526a5.01 5.01 0 013.775 1.462zm17 0a5.01 5.01 0 011.462 3.775V36h-14v-9.763A5.01 5.01 0 0130.737 21h3.526a5.01 5.01 0 013.775 1.462zM17.263 23h-3.526a3.033 3.033 0 00-3.237 3.237V34h10v-7.763A3.033 3.033 0 0017.263 23zm17 0h-3.526a3.033 3.033 0 00-3.237 3.237V34h10v-7.763A3.033 3.033 0 0034.263 23zM24 1a8.5 8.5 0 018.5 8.5A8.51 8.51 0 0124 18a8.5 8.5 0 110-17zm0 2a6.5 6.5 0 106.5 6.5A6.508 6.508 0 0024 3zm1 2v4.478l1.85 1.286-1.143 1.642L23 10.522V5h2z"
});

function SvgWaitingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$b);
}

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a = /*#__PURE__*/React.createElement("path", {
  d: "M40.947 21.361l4.803-6.145L31.253 4.178l-1.559 2.07L23.503 3 16.13 17.59H4.997A1.998 1.998 0 003 19.583v22.924A1.998 1.998 0 004.997 44.5H38.95a1.998 1.998 0 001.997-1.993v-5.46h1.997v-7.475h-1.997v-8.21zM31.64 6.981l11.293 8.597-5.079 6.497H20.278L31.641 6.98zm-3.161.88l-4.108-2.153-8.27 16.367h1.679l10.7-14.213zm10.47 34.646H4.996V19.583h10.127l-1.26 2.492H9.99v1.993h28.96v5.504h-2.247a3.738 3.738 0 100 7.475h2.246v5.46zm-2.247-7.453h4.244v-3.488h-4.244a1.744 1.744 0 100 3.488z"
});

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$a);
}

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.008 15.535l.385.226.09.436c.133.64.266 1.284.398 1.929l.316 1.547.47 2.31.153.762c1.71 8.485 3.149 15.973 3.167 16.067L35.214 40h-7.71v7h-2v-9h7.29c-.516-2.666-1.837-9.451-3.292-16.625l-.194-.958-.196-.961-.493-2.401a11.05 11.05 0 00-9.225-.002L15.224 38h7.28v9h-2v-7h-7.718l4.826-24.237.388-.228a12.508 12.508 0 0112.008 0zM24.005 1a5.5 5.5 0 015.5 5.5 5.507 5.507 0 01-5.5 5.5 5.5 5.5 0 010-11zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgWcLadies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$9);
}

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.984 15.774l.516.287V33h-4v14h-2V31h4V17.256a13.02 13.02 0 00-11 0V31h4v16h-2V33h-4V16.06l.516-.286a14.633 14.633 0 0113.968 0zM24 1a5.5 5.5 0 015.5 5.5A5.507 5.507 0 0124 12a5.5 5.5 0 010-11zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgWcMen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$8);
}

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.13 15.774l.515.287V33h-4v14h-2V31h4V17.256a13.02 13.02 0 00-11 0V31h4v16h-2V33h-4V16.06l.516-.286a14.633 14.633 0 0113.969 0zm19.019-.239l.384.226.091.436.398 1.929.316 1.547.469 2.31.153.762c1.711 8.485 3.15 15.973 3.167 16.067L43.355 40h-7.71v7h-2v-9h7.289c-.62-3.2-2.397-12.33-4.175-20.945a11.05 11.05 0 00-9.225-.002L23.364 38h7.28v9h-2v-7h-7.718l4.826-24.237.389-.228a12.508 12.508 0 0112.008 0zM12.145 1a5.5 5.5 0 015.5 5.5 5.507 5.507 0 01-5.5 5.5 5.5 5.5 0 010-11zm20 0a5.5 5.5 0 015.5 5.5 5.507 5.507 0 01-5.5 5.5 5.5 5.5 0 010-11zm-20 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm20 0a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgWc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$7);
}

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.913 24.98l11.09.023-.005 2L8.91 26.98a7.284 7.284 0 01-5.265-2.149A9.116 9.116 0 011 18.338a8.583 8.583 0 012.585-6.142 8.72 8.72 0 015.917-2.538 10.055 10.055 0 0117.002-4.58 6.814 6.814 0 012.373-.43 7.007 7.007 0 017.02 6.977v.028a8.06 8.06 0 014.603 7.281h-2a6.072 6.072 0 00-3.744-5.603l-.976-.41.104-1.05c.008-.082.014-.163.014-.246a5.004 5.004 0 00-5.02-4.976 4.888 4.888 0 00-1.953.414l-.955.413-.69-.777a8.053 8.053 0 00-13.911 3.79l-.227 1.194-1.413-.03a6.724 6.724 0 00-4.74 1.965A6.6 6.6 0 003 18.338a7.108 7.108 0 002.045 5.067 5.355 5.355 0 003.868 1.575zM14 29.253h13.89a2.118 2.118 0 10-2.118-2.125h-1.994a4.125 4.125 0 114.112 4.125H14v-2zm22.379 8.5H10v2h26.38a2.125 2.125 0 11-2.122 2.125h-2a4.122 4.122 0 104.122-4.125zm-2.04-8.75a6.424 6.424 0 016.331-6.5 6.502 6.502 0 010 13H18v-2h22.67a4.334 4.334 0 10-4.33-4.5h-2z",
  fill: "currentColor"
});

function SvgWeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$6);
}

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.25 29a34.864 34.864 0 0116.566 4.125l.684.377-.198.752A17.686 17.686 0 0118.25 47 17.686 17.686 0 011.198 34.254L1 33.502l.684-.377A34.864 34.864 0 0118.25 29zm0 2a33.03 33.03 0 00-14.886 3.499 15.802 15.802 0 0029.772 0 33.03 33.03 0 00-14.886-3.5zm0-21a8 8 0 018 8 8.01 8.01 0 01-8 8 8 8 0 110-16zm0 2a6 6 0 106 6 6.007 6.007 0 00-6-6zm-2 6a2 2 0 104 0h2a4.005 4.005 0 01-4 4 4.005 4.005 0 01-4-4h2zM39 15.5V19h-2v-3.5h2zm-5.596-2.318l1.414 1.414-2.475 2.475-1.414-1.414 2.475-2.475zm9.192 0l2.475 2.475-1.414 1.414-2.475-2.475 1.414-1.414zM38 6a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4zm9 1v2h-3.5V9H47zM32.5 9v2H29V9h3.5zm11.157-6.07l1.414 1.413-2.475 2.475-1.414-1.414 2.475-2.475zm-11.314 0l2.475 2.474-1.414 1.414-2.475-2.475 1.414-1.414zM39 1v3.5h-2V1h2z"
});

function SvgWellBeing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$5);
}

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.072 22v2.057a10.627 10.627 0 00-7.954 10.31 10.513 10.513 0 1021.024 0v-.332h1.988v.331c.029 6.937-5.563 12.59-12.5 12.634a12.647 12.647 0 01-2.558-25zm8.73-6.47L28.706 24h6.424v2h-7.576L22.07 16.53a.997.997 0 00-1.164-.49c-.47.112-.794.54-.776 1.023l.002 9.701a2.227 2.227 0 002.21 2.237h12.74l7.789 13.5-1.732 1-7.211-12.5H22.343a4.228 4.228 0 01-4.211-4.237l-.002-9.701a3.038 3.038 0 015.672-1.533zM21.63 1a5.5 5.5 0 015.5 5.5 5.507 5.507 0 01-5.5 5.5 5.5 5.5 0 010-11zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgWheelchairUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$4);
}

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.47 17.942a7.644 7.644 0 017.515-7.75 7.644 7.644 0 017.515 7.75 7.644 7.644 0 01-7.515 7.75H11.5v-2h27.485a5.642 5.642 0 005.515-5.75 5.52 5.52 0 10-11.03 0h-2zm-4.97-1.336a4.663 4.663 0 10-9.328 0h2a2.663 2.663 0 112.664 2.663H5.5v2h16.336a4.669 4.669 0 004.664-4.663zm7.191 11.586H1.5v1.997h32.19a2.815 2.815 0 11-2.81 2.815h-1.998a4.808 4.808 0 104.808-4.812z",
  fill: "currentColor"
});

function SvgWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3);
}

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/React.createElement("path", {
  d: "M46 11V9h-3.634a5.428 5.428 0 00-.856-2.096l2.56-2.56-1.413-1.415-2.562 2.562A5.467 5.467 0 0038 4.594V1h-2v3.594a5.469 5.469 0 00-2.095.897l-2.562-2.562-1.414 1.414 2.561 2.561A5.479 5.479 0 0031.635 9H28v2h3.594a5.471 5.471 0 00.897 2.095l-2.562 2.562 1.414 1.414 2.552-2.552a5.51 5.51 0 002.105.882V19h2v-3.6a5.509 5.509 0 002.105-.88l2.552 2.55 1.414-1.413-2.562-2.562A5.467 5.467 0 0042.406 11zm-9-4.5a3.502 3.502 0 013.474 3.287v.002A2.034 2.034 0 0040.5 10a3.498 3.498 0 01-6.995-.02c.009-.063.017-.126.02-.193A3.503 3.503 0 0137 6.5zM18.165 22a4.005 4.005 0 004-4h-2a2 2 0 01-4 0h-2a4.005 4.005 0 004 4z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.165 26a8 8 0 10-8-8 8.01 8.01 0 008 8zm0-14a6 6 0 11-6 6 6.007 6.007 0 016-6zM18.165 29A34.555 34.555 0 001.68 33.125l-.68.377.197.752a17.666 17.666 0 0033.935 0l.197-.752-.68-.377A34.555 34.555 0 0018.165 29zm0 16A15.643 15.643 0 013.352 34.499a33.107 33.107 0 0129.625 0A15.643 15.643 0 0118.165 45z"
});

function SvgWorkLiveBalance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2, _ref2);
}

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  d: "M24 1C11.297 1 1 11.297 1 24s10.297 23 23 23 23-10.297 23-23C46.986 11.303 36.697 1.014 24 1zm-6.434 3.008a21.251 21.251 0 00-4.717 8.471 22.275 22.275 0 01-4.646-2.301 21.066 21.066 0 019.363-6.17zm-10.612 7.74a24.23 24.23 0 005.35 2.657A39.278 39.278 0 0011.19 23H3.023a20.87 20.87 0 013.931-11.252zm.001 24.506A20.877 20.877 0 013.023 25h8.166a39.297 39.297 0 001.117 8.598 24.25 24.25 0 00-5.35 2.656zm1.25 1.57a22.241 22.241 0 014.645-2.3 21.256 21.256 0 004.716 8.468 21.059 21.059 0 01-9.36-6.168zM23 44.906c-3.422-.641-6.44-4.53-8.198-10.012A33.623 33.623 0 0123 33.683v11.223zm0-13.224c-2.957.066-5.895.5-8.745 1.292A36.718 36.718 0 0113.19 25H23v6.682zM23 23h-9.81a36.7 36.7 0 011.064-7.97A35.616 35.616 0 0023 16.321V23zm0-8.679a33.577 33.577 0 01-8.2-1.212c1.76-5.483 4.777-9.374 8.2-10.015V14.32zm18.046-2.573A20.87 20.87 0 0144.976 23h-8.165a39.278 39.278 0 00-1.116-8.595 24.23 24.23 0 005.35-2.657zm-1.25-1.57a22.275 22.275 0 01-4.645 2.301 21.251 21.251 0 00-4.717-8.471 21.066 21.066 0 019.363 6.17zM25 3.094c3.423.641 6.44 4.532 8.2 10.015a33.577 33.577 0 01-8.2 1.212V3.094zm0 13.228c2.958-.066 5.896-.5 8.746-1.293A36.7 36.7 0 0134.81 23H25v-6.678zM25 25h9.81a36.718 36.718 0 01-1.065 7.974A35.661 35.661 0 0025 31.682V25zm0 19.906V33.683c2.772.064 5.526.47 8.198 1.21-1.759 5.483-4.776 9.372-8.198 10.013zm5.434-.914a21.256 21.256 0 004.716-8.469 22.24 22.24 0 014.645 2.301 21.059 21.059 0 01-9.361 6.168zm10.61-7.738a24.25 24.25 0 00-5.35-2.656A39.297 39.297 0 0036.811 25h8.166a20.877 20.877 0 01-3.932 11.254z"
});

function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1);
}

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.993 13.5a6.25 6.25 0 10-6.25-6.25 6.257 6.257 0 006.25 6.25zm0-10.5a4.25 4.25 0 110 8.5 4.25 4.25 0 010-8.5zm15.37 36.413l-5.638-4.422a3.278 3.278 0 01-1.273-2.54l.001-.025c.223.05.451.077.68.078a3.018 3.018 0 002.624-1.484 3.137 3.137 0 00.358-2.545l-2.494-8.326a6.425 6.425 0 00-6.15-4.649h-6.97a6.42 6.42 0 00-6.145 4.636L11.84 28.54a3.19 3.19 0 00.393 2.505 3.112 3.112 0 003.293 1.376 3.296 3.296 0 01-1.266 2.57l-5.638 4.421a4.24 4.24 0 002.616 7.576h7.374c.018 0 .036.003.054.005.02.003.04.006.061.006v-.011h18.02a4.24 4.24 0 002.615-7.576zM13.931 29.99a1.124 1.124 0 01-.156-.94l2.5-8.351a4.416 4.416 0 014.227-3.198h6.97a4.42 4.42 0 014.23 3.21l2.492 8.32c.099.337.038.7-.166.985-.297.455-.885.62-1.375.386l-8.666-3.797-8.665 3.797a1.111 1.111 0 01-1.391-.413zm22.816 15a2.19 2.19 0 002.116-1.508 2.189 2.189 0 00-.734-2.494l-5.639-4.421a5.29 5.29 0 01-2.036-4.186l.052-.736-6.519-2.857-6.507 2.852.048.67a5.315 5.315 0 01-2.033 4.257l-5.638 4.421a2.24 2.24 0 001.382 4.002h4.2a3.722 3.722 0 013.29-5.489h10.764v2H18.729a1.746 1.746 0 00-.115 3.489h18.133zm-7.78-19.528l.555-1.92a11.408 11.408 0 01-4.777-3.2.998.998 0 00-.752-.34h-.005a1 1 0 00-.754.349 11.117 11.117 0 01-4.763 3.188l.545 1.924a12.918 12.918 0 004.983-3.01 13.174 13.174 0 004.967 3.01z"
});

function SvgYoga(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

var Accessibility = function Accessibility(props) {
  return /*#__PURE__*/React__default.createElement(SvgAccessibility, _extends$3T({
    "data-icon": "accessibility"
  }, props));
};
var AccidentInsurance = function AccidentInsurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgAccidentInsurance, _extends$3T({
    "data-icon": "accident-insurance"
  }, props));
};
var AddressBook = function AddressBook(props) {
  return /*#__PURE__*/React__default.createElement(SvgAddressBook, _extends$3T({
    "data-icon": "address-book"
  }, props));
};
var AdministrationHealthcare = function AdministrationHealthcare(props) {
  return /*#__PURE__*/React__default.createElement(SvgAdministrationHealthcare, _extends$3T({
    "data-icon": "administration-healthcare"
  }, props));
};
var AllergyBedding = function AllergyBedding(props) {
  return /*#__PURE__*/React__default.createElement(SvgAllergyBedding, _extends$3T({
    "data-icon": "allergy-bedding"
  }, props));
};
var Ambulance = function Ambulance(props) {
  return /*#__PURE__*/React__default.createElement(SvgAmbulance, _extends$3T({
    "data-icon": "ambulance"
  }, props));
};
var AokBonusProgram = function AokBonusProgram(props) {
  return /*#__PURE__*/React__default.createElement(SvgAokBonusProgram, _extends$3T({
    "data-icon": "aok-bonus-program"
  }, props));
};
var AokHealthAccount = function AokHealthAccount(props) {
  return /*#__PURE__*/React__default.createElement(SvgAokHealthAccount, _extends$3T({
    "data-icon": "aok-health-account"
  }, props));
};
var AokPremiumProgram = function AokPremiumProgram(props) {
  return /*#__PURE__*/React__default.createElement(SvgAokPremiumProgram, _extends$3T({
    "data-icon": "aok-premium-program"
  }, props));
};
var AokRecommendation = function AokRecommendation(props) {
  return /*#__PURE__*/React__default.createElement(SvgAokRecommendation, _extends$3T({
    "data-icon": "aok-recommendation"
  }, props));
};
var Aok = function Aok(props) {
  return /*#__PURE__*/React__default.createElement(SvgAok, _extends$3T({
    "data-icon": "aok"
  }, props));
};
var Apprenticeships = function Apprenticeships(props) {
  return /*#__PURE__*/React__default.createElement(SvgApprenticeships, _extends$3T({
    "data-icon": "apprenticeships"
  }, props));
};
var ApprovalWait = function ApprovalWait(props) {
  return /*#__PURE__*/React__default.createElement(SvgApprovalWait, _extends$3T({
    "data-icon": "approval-wait"
  }, props));
};
var ArrowDownLeft = function ArrowDownLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowDownLeft, _extends$3T({
    "data-icon": "arrow-down-left"
  }, props));
};
var ArrowDownRight = function ArrowDownRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowDownRight, _extends$3T({
    "data-icon": "arrow-down-right"
  }, props));
};
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowDown, _extends$3T({
    "data-icon": "arrow-down"
  }, props));
};
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowLeft, _extends$3T({
    "data-icon": "arrow-left"
  }, props));
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRight, _extends$3T({
    "data-icon": "arrow-right"
  }, props));
};
var ArrowUpLeft = function ArrowUpLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowUpLeft, _extends$3T({
    "data-icon": "arrow-up-left"
  }, props));
};
var ArrowUpRight = function ArrowUpRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowUpRight, _extends$3T({
    "data-icon": "arrow-up-right"
  }, props));
};
var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowUp, _extends$3T({
    "data-icon": "arrow-up"
  }, props));
};
var AssistanceDog = function AssistanceDog(props) {
  return /*#__PURE__*/React__default.createElement(SvgAssistanceDog, _extends$3T({
    "data-icon": "assistance-dog"
  }, props));
};
var BabyBonus = function BabyBonus(props) {
  return /*#__PURE__*/React__default.createElement(SvgBabyBonus, _extends$3T({
    "data-icon": "baby-bonus"
  }, props));
};
var Baby = function Baby(props) {
  return /*#__PURE__*/React__default.createElement(SvgBaby, _extends$3T({
    "data-icon": "baby"
  }, props));
};
var Balloon = function Balloon(props) {
  return /*#__PURE__*/React__default.createElement(SvgBalloon, _extends$3T({
    "data-icon": "balloon"
  }, props));
};
var Bandage = function Bandage(props) {
  return /*#__PURE__*/React__default.createElement(SvgBandage, _extends$3T({
    "data-icon": "bandage"
  }, props));
};
var Bank = function Bank(props) {
  return /*#__PURE__*/React__default.createElement(SvgBank, _extends$3T({
    "data-icon": "bank"
  }, props));
};
var BatteryCharging = function BatteryCharging(props) {
  return /*#__PURE__*/React__default.createElement(SvgBatteryCharging, _extends$3T({
    "data-icon": "battery-charging"
  }, props));
};
var BeautyLipstick = function BeautyLipstick(props) {
  return /*#__PURE__*/React__default.createElement(SvgBeautyLipstick, _extends$3T({
    "data-icon": "beauty-lipstick"
  }, props));
};
var BecomeAMember = function BecomeAMember(props) {
  return /*#__PURE__*/React__default.createElement(SvgBecomeAMember, _extends$3T({
    "data-icon": "become-a-member"
  }, props));
};
var Bike = function Bike(props) {
  return /*#__PURE__*/React__default.createElement(SvgBike, _extends$3T({
    "data-icon": "bike"
  }, props));
};
var BirthPreparationCourse = function BirthPreparationCourse(props) {
  return /*#__PURE__*/React__default.createElement(SvgBirthPreparationCourse, _extends$3T({
    "data-icon": "birth-preparation-course"
  }, props));
};
var Bone = function Bone(props) {
  return /*#__PURE__*/React__default.createElement(SvgBone, _extends$3T({
    "data-icon": "bone"
  }, props));
};
var Bonus = function Bonus(props) {
  return /*#__PURE__*/React__default.createElement(SvgBonus, _extends$3T({
    "data-icon": "bonus"
  }, props));
};
var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/React__default.createElement(SvgBookmark, _extends$3T({
    "data-icon": "bookmark"
  }, props));
};
var Bread = function Bread(props) {
  return /*#__PURE__*/React__default.createElement(SvgBread, _extends$3T({
    "data-icon": "bread"
  }, props));
};
var BubbleQuestion = function BubbleQuestion(props) {
  return /*#__PURE__*/React__default.createElement(SvgBubbleQuestion, _extends$3T({
    "data-icon": "bubble-question"
  }, props));
};
var Cafeteria = function Cafeteria(props) {
  return /*#__PURE__*/React__default.createElement(SvgCafeteria, _extends$3T({
    "data-icon": "cafeteria"
  }, props));
};
var CalenderArrow = function CalenderArrow(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalenderArrow, _extends$3T({
    "data-icon": "calender-arrow"
  }, props));
};
var CalenderCheck = function CalenderCheck(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalenderCheck, _extends$3T({
    "data-icon": "calender-check"
  }, props));
};
var CalenderDate = function CalenderDate(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalenderDate, _extends$3T({
    "data-icon": "calender-date"
  }, props));
};
var Calender = function Calender(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalender, _extends$3T({
    "data-icon": "calender"
  }, props));
};
var CancellationForm = function CancellationForm(props) {
  return /*#__PURE__*/React__default.createElement(SvgCancellationForm, _extends$3T({
    "data-icon": "cancellation-form"
  }, props));
};
var Car = function Car(props) {
  return /*#__PURE__*/React__default.createElement(SvgCar, _extends$3T({
    "data-icon": "car"
  }, props));
};
var CareInsurance = function CareInsurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgCareInsurance, _extends$3T({
    "data-icon": "care-insurance"
  }, props));
};
var Care = function Care(props) {
  return /*#__PURE__*/React__default.createElement(SvgCare, _extends$3T({
    "data-icon": "care"
  }, props));
};
var ChaningRoom = function ChaningRoom(props) {
  return /*#__PURE__*/React__default.createElement(SvgChaningRoom, _extends$3T({
    "data-icon": "chaning-room"
  }, props));
};
var Charity = function Charity(props) {
  return /*#__PURE__*/React__default.createElement(SvgCharity, _extends$3T({
    "data-icon": "charity"
  }, props));
};
var ChatOnline = function ChatOnline(props) {
  return /*#__PURE__*/React__default.createElement(SvgChatOnline, _extends$3T({
    "data-icon": "chat-online"
  }, props));
};
var Chatbot = function Chatbot(props) {
  return /*#__PURE__*/React__default.createElement(SvgChatbot, _extends$3T({
    "data-icon": "chatbot"
  }, props));
};
var Check = function Check(props) {
  return /*#__PURE__*/React__default.createElement(SvgCheck, _extends$3T({
    "data-icon": "check"
  }, props));
};
var ChefHat = function ChefHat(props) {
  return /*#__PURE__*/React__default.createElement(SvgChefHat, _extends$3T({
    "data-icon": "chef-hat"
  }, props));
};
var ChildSicknessBenefit = function ChildSicknessBenefit(props) {
  return /*#__PURE__*/React__default.createElement(SvgChildSicknessBenefit, _extends$3T({
    "data-icon": "child-sickness-benefit"
  }, props));
};
var Child = function Child(props) {
  return /*#__PURE__*/React__default.createElement(SvgChild, _extends$3T({
    "data-icon": "child"
  }, props));
};
var ClinicalThermometer = function ClinicalThermometer(props) {
  return /*#__PURE__*/React__default.createElement(SvgClinicalThermometer, _extends$3T({
    "data-icon": "clinical-thermometer"
  }, props));
};
var Cloakroom = function Cloakroom(props) {
  return /*#__PURE__*/React__default.createElement(SvgCloakroom, _extends$3T({
    "data-icon": "cloakroom"
  }, props));
};
var Clock = function Clock(props) {
  return /*#__PURE__*/React__default.createElement(SvgClock, _extends$3T({
    "data-icon": "clock"
  }, props));
};
var Cloud = function Cloud(props) {
  return /*#__PURE__*/React__default.createElement(SvgCloud, _extends$3T({
    "data-icon": "cloud"
  }, props));
};
var CoBrowsing = function CoBrowsing(props) {
  return /*#__PURE__*/React__default.createElement(SvgCoBrowsing, _extends$3T({
    "data-icon": "co-browsing"
  }, props));
};
var CoPayments = function CoPayments(props) {
  return /*#__PURE__*/React__default.createElement(SvgCoPayments, _extends$3T({
    "data-icon": "co-payments"
  }, props));
};
var Compass = function Compass(props) {
  return /*#__PURE__*/React__default.createElement(SvgCompass, _extends$3T({
    "data-icon": "compass"
  }, props));
};
var Contributions = function Contributions(props) {
  return /*#__PURE__*/React__default.createElement(SvgContributions, _extends$3T({
    "data-icon": "contributions"
  }, props));
};
var Cookies = function Cookies(props) {
  return /*#__PURE__*/React__default.createElement(SvgCookies, _extends$3T({
    "data-icon": "cookies"
  }, props));
};
var CorporateClients = function CorporateClients(props) {
  return /*#__PURE__*/React__default.createElement(SvgCorporateClients, _extends$3T({
    "data-icon": "corporate-clients"
  }, props));
};
var Cure = function Cure(props) {
  return /*#__PURE__*/React__default.createElement(SvgCure, _extends$3T({
    "data-icon": "cure"
  }, props));
};
var CustomerSatisfaction = function CustomerSatisfaction(props) {
  return /*#__PURE__*/React__default.createElement(SvgCustomerSatisfaction, _extends$3T({
    "data-icon": "customer-satisfaction"
  }, props));
};
var Cutlery = function Cutlery(props) {
  return /*#__PURE__*/React__default.createElement(SvgCutlery, _extends$3T({
    "data-icon": "cutlery"
  }, props));
};
var DataExchange = function DataExchange(props) {
  return /*#__PURE__*/React__default.createElement(SvgDataExchange, _extends$3T({
    "data-icon": "data-exchange"
  }, props));
};
var Dementia = function Dementia(props) {
  return /*#__PURE__*/React__default.createElement(SvgDementia, _extends$3T({
    "data-icon": "dementia"
  }, props));
};
var Dentistry = function Dentistry(props) {
  return /*#__PURE__*/React__default.createElement(SvgDentistry, _extends$3T({
    "data-icon": "dentistry"
  }, props));
};
var Devices = function Devices(props) {
  return /*#__PURE__*/React__default.createElement(SvgDevices, _extends$3T({
    "data-icon": "devices"
  }, props));
};
var Diagram = function Diagram(props) {
  return /*#__PURE__*/React__default.createElement(SvgDiagram, _extends$3T({
    "data-icon": "diagram"
  }, props));
};
var Diamont = function Diamont(props) {
  return /*#__PURE__*/React__default.createElement(SvgDiamont, _extends$3T({
    "data-icon": "diamont"
  }, props));
};
var Digestion = function Digestion(props) {
  return /*#__PURE__*/React__default.createElement(SvgDigestion, _extends$3T({
    "data-icon": "digestion"
  }, props));
};
var DigitalHealthApplications = function DigitalHealthApplications(props) {
  return /*#__PURE__*/React__default.createElement(SvgDigitalHealthApplications, _extends$3T({
    "data-icon": "digital-health-applications"
  }, props));
};
var DigitalHealthCard = function DigitalHealthCard(props) {
  return /*#__PURE__*/React__default.createElement(SvgDigitalHealthCard, _extends$3T({
    "data-icon": "digital-health-card"
  }, props));
};
var DigitalPatientReceipt = function DigitalPatientReceipt(props) {
  return /*#__PURE__*/React__default.createElement(SvgDigitalPatientReceipt, _extends$3T({
    "data-icon": "digital-patient-receipt"
  }, props));
};
var Doctor = function Doctor(props) {
  return /*#__PURE__*/React__default.createElement(SvgDoctor, _extends$3T({
    "data-icon": "doctor"
  }, props));
};
var Dokument = function Dokument(props) {
  return /*#__PURE__*/React__default.createElement(SvgDokument, _extends$3T({
    "data-icon": "dokument"
  }, props));
};
var DownloadFolder = function DownloadFolder(props) {
  return /*#__PURE__*/React__default.createElement(SvgDownloadFolder, _extends$3T({
    "data-icon": "download-folder"
  }, props));
};
var Download = function Download(props) {
  return /*#__PURE__*/React__default.createElement(SvgDownload, _extends$3T({
    "data-icon": "download"
  }, props));
};
var Drop = function Drop(props) {
  return /*#__PURE__*/React__default.createElement(SvgDrop, _extends$3T({
    "data-icon": "drop"
  }, props));
};
var DualStudy = function DualStudy(props) {
  return /*#__PURE__*/React__default.createElement(SvgDualStudy, _extends$3T({
    "data-icon": "dual-study"
  }, props));
};
var EarlyDetection = function EarlyDetection(props) {
  return /*#__PURE__*/React__default.createElement(SvgEarlyDetection, _extends$3T({
    "data-icon": "early-detection"
  }, props));
};
var EasyLanguage = function EasyLanguage(props) {
  return /*#__PURE__*/React__default.createElement(SvgEasyLanguage, _extends$3T({
    "data-icon": "easy-language"
  }, props));
};
var EmergencyRescueRing = function EmergencyRescueRing(props) {
  return /*#__PURE__*/React__default.createElement(SvgEmergencyRescueRing, _extends$3T({
    "data-icon": "emergency-rescue-ring"
  }, props));
};
var Employed = function Employed(props) {
  return /*#__PURE__*/React__default.createElement(SvgEmployed, _extends$3T({
    "data-icon": "employed"
  }, props));
};
var Envelope = function Envelope(props) {
  return /*#__PURE__*/React__default.createElement(SvgEnvelope, _extends$3T({
    "data-icon": "envelope"
  }, props));
};
var Family = function Family(props) {
  return /*#__PURE__*/React__default.createElement(SvgFamily, _extends$3T({
    "data-icon": "family"
  }, props));
};
var File = function File(props) {
  return /*#__PURE__*/React__default.createElement(SvgFile, _extends$3T({
    "data-icon": "file"
  }, props));
};
var Files = function Files(props) {
  return /*#__PURE__*/React__default.createElement(SvgFiles, _extends$3T({
    "data-icon": "files"
  }, props));
};
var Fire = function Fire(props) {
  return /*#__PURE__*/React__default.createElement(SvgFire, _extends$3T({
    "data-icon": "fire"
  }, props));
};
var Flag = function Flag(props) {
  return /*#__PURE__*/React__default.createElement(SvgFlag, _extends$3T({
    "data-icon": "flag"
  }, props));
};
var Folder = function Folder(props) {
  return /*#__PURE__*/React__default.createElement(SvgFolder, _extends$3T({
    "data-icon": "folder"
  }, props));
};
var Form = function Form(props) {
  return /*#__PURE__*/React__default.createElement(SvgForm, _extends$3T({
    "data-icon": "form"
  }, props));
};
var GeneralPractitioner = function GeneralPractitioner(props) {
  return /*#__PURE__*/React__default.createElement(SvgGeneralPractitioner, _extends$3T({
    "data-icon": "general-practitioner"
  }, props));
};
var Gift = function Gift(props) {
  return /*#__PURE__*/React__default.createElement(SvgGift, _extends$3T({
    "data-icon": "gift"
  }, props));
};
var Glasses = function Glasses(props) {
  return /*#__PURE__*/React__default.createElement(SvgGlasses, _extends$3T({
    "data-icon": "glasses"
  }, props));
};
var Goal = function Goal(props) {
  return /*#__PURE__*/React__default.createElement(SvgGoal, _extends$3T({
    "data-icon": "goal"
  }, props));
};
var Grapes = function Grapes(props) {
  return /*#__PURE__*/React__default.createElement(SvgGrapes, _extends$3T({
    "data-icon": "grapes"
  }, props));
};
var HandShow = function HandShow(props) {
  return /*#__PURE__*/React__default.createElement(SvgHandShow, _extends$3T({
    "data-icon": "hand-show"
  }, props));
};
var HandStop = function HandStop(props) {
  return /*#__PURE__*/React__default.createElement(SvgHandStop, _extends$3T({
    "data-icon": "hand-stop"
  }, props));
};
var HandThumbUp = function HandThumbUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgHandThumbUp, _extends$3T({
    "data-icon": "hand-thumb-up"
  }, props));
};
var HandshakeCare = function HandshakeCare(props) {
  return /*#__PURE__*/React__default.createElement(SvgHandshakeCare, _extends$3T({
    "data-icon": "handshake-care"
  }, props));
};
var Happy = function Happy(props) {
  return /*#__PURE__*/React__default.createElement(SvgHappy, _extends$3T({
    "data-icon": "happy"
  }, props));
};
var HeadphonesOne = function HeadphonesOne(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeadphones1, _extends$3T({
    "data-icon": "headphones-1"
  }, props));
};
var HeadphonesTwo = function HeadphonesTwo(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeadphones2, _extends$3T({
    "data-icon": "headphones-2"
  }, props));
};
var HealthCheck = function HealthCheck(props) {
  return /*#__PURE__*/React__default.createElement(SvgHealthCheck, _extends$3T({
    "data-icon": "health-check"
  }, props));
};
var HealthCourse = function HealthCourse(props) {
  return /*#__PURE__*/React__default.createElement(SvgHealthCourse, _extends$3T({
    "data-icon": "health-course"
  }, props));
};
var HealthInsurance = function HealthInsurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgHealthInsurance, _extends$3T({
    "data-icon": "health-insurance"
  }, props));
};
var HealthPartner = function HealthPartner(props) {
  return /*#__PURE__*/React__default.createElement(SvgHealthPartner, _extends$3T({
    "data-icon": "health-partner"
  }, props));
};
var HealthResources = function HealthResources(props) {
  return /*#__PURE__*/React__default.createElement(SvgHealthResources, _extends$3T({
    "data-icon": "health-resources"
  }, props));
};
var HearingImpairment = function HearingImpairment(props) {
  return /*#__PURE__*/React__default.createElement(SvgHearingImpairment, _extends$3T({
    "data-icon": "hearing-impairment"
  }, props));
};
var HeartBeat = function HeartBeat(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeartBeat, _extends$3T({
    "data-icon": "heart-beat"
  }, props));
};
var Heart = function Heart(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeart, _extends$3T({
    "data-icon": "heart"
  }, props));
};
var HomeNursing = function HomeNursing(props) {
  return /*#__PURE__*/React__default.createElement(SvgHomeNursing, _extends$3T({
    "data-icon": "home-nursing"
  }, props));
};
var HospitalTreatment = function HospitalTreatment(props) {
  return /*#__PURE__*/React__default.createElement(SvgHospitalTreatment, _extends$3T({
    "data-icon": "hospital-treatment"
  }, props));
};
var Hospital = function Hospital(props) {
  return /*#__PURE__*/React__default.createElement(SvgHospital, _extends$3T({
    "data-icon": "hospital"
  }, props));
};
var Housekeeping = function Housekeeping(props) {
  return /*#__PURE__*/React__default.createElement(SvgHousekeeping, _extends$3T({
    "data-icon": "housekeeping"
  }, props));
};
var HygieneArmBend = function HygieneArmBend(props) {
  return /*#__PURE__*/React__default.createElement(SvgHygieneArmBend, _extends$3T({
    "data-icon": "hygiene-arm-bend"
  }, props));
};
var HygieneDisinfection = function HygieneDisinfection(props) {
  return /*#__PURE__*/React__default.createElement(SvgHygieneDisinfection, _extends$3T({
    "data-icon": "hygiene-disinfection"
  }, props));
};
var HygieneMask = function HygieneMask(props) {
  return /*#__PURE__*/React__default.createElement(SvgHygieneMask, _extends$3T({
    "data-icon": "hygiene-mask"
  }, props));
};
var InsuranceEu = function InsuranceEu(props) {
  return /*#__PURE__*/React__default.createElement(SvgInsuranceEu, _extends$3T({
    "data-icon": "insurance-eu"
  }, props));
};
var Insurance = function Insurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgInsurance, _extends$3T({
    "data-icon": "insurance"
  }, props));
};
var IntegratedCare = function IntegratedCare(props) {
  return /*#__PURE__*/React__default.createElement(SvgIntegratedCare, _extends$3T({
    "data-icon": "integrated-care"
  }, props));
};
var JobOffer = function JobOffer(props) {
  return /*#__PURE__*/React__default.createElement(SvgJobOffer, _extends$3T({
    "data-icon": "job-offer"
  }, props));
};
var Jolinchen = function Jolinchen(props) {
  return /*#__PURE__*/React__default.createElement(SvgJolinchen, _extends$3T({
    "data-icon": "jolinchen"
  }, props));
};
var Law = function Law(props) {
  return /*#__PURE__*/React__default.createElement(SvgLaw, _extends$3T({
    "data-icon": "law"
  }, props));
};
var Lebensbaum = function Lebensbaum(props) {
  return /*#__PURE__*/React__default.createElement(SvgLebensbaum, _extends$3T({
    "data-icon": "lebensbaum"
  }, props));
};
var LegalDatabase = function LegalDatabase(props) {
  return /*#__PURE__*/React__default.createElement(SvgLegalDatabase, _extends$3T({
    "data-icon": "legal-database"
  }, props));
};
var Lift = function Lift(props) {
  return /*#__PURE__*/React__default.createElement(SvgLift, _extends$3T({
    "data-icon": "lift"
  }, props));
};
var LightBulb = function LightBulb(props) {
  return /*#__PURE__*/React__default.createElement(SvgLightBulb, _extends$3T({
    "data-icon": "light-bulb"
  }, props));
};
var LivingRoom = function LivingRoom(props) {
  return /*#__PURE__*/React__default.createElement(SvgLivingRoom, _extends$3T({
    "data-icon": "living-room"
  }, props));
};
var Location = function Location(props) {
  return /*#__PURE__*/React__default.createElement(SvgLocation, _extends$3T({
    "data-icon": "location"
  }, props));
};
var LungsBreathSystem = function LungsBreathSystem(props) {
  return /*#__PURE__*/React__default.createElement(SvgLungsBreathSystem, _extends$3T({
    "data-icon": "lungs-breath-system"
  }, props));
};
var Magazin = function Magazin(props) {
  return /*#__PURE__*/React__default.createElement(SvgMagazin, _extends$3T({
    "data-icon": "magazin"
  }, props));
};
var Management = function Management(props) {
  return /*#__PURE__*/React__default.createElement(SvgManagement, _extends$3T({
    "data-icon": "management"
  }, props));
};
var Map = function Map(props) {
  return /*#__PURE__*/React__default.createElement(SvgMap, _extends$3T({
    "data-icon": "map"
  }, props));
};
var MaternityBenefit = function MaternityBenefit(props) {
  return /*#__PURE__*/React__default.createElement(SvgMaternityBenefit, _extends$3T({
    "data-icon": "maternity-benefit"
  }, props));
};
var MedialOffers = function MedialOffers(props) {
  return /*#__PURE__*/React__default.createElement(SvgMedialOffers, _extends$3T({
    "data-icon": "medial-offers"
  }, props));
};
var MedicineCare = function MedicineCare(props) {
  return /*#__PURE__*/React__default.createElement(SvgMedicineCare, _extends$3T({
    "data-icon": "medicine-care"
  }, props));
};
var Medicines = function Medicines(props) {
  return /*#__PURE__*/React__default.createElement(SvgMedicines, _extends$3T({
    "data-icon": "medicines"
  }, props));
};
var MeetingRoom = function MeetingRoom(props) {
  return /*#__PURE__*/React__default.createElement(SvgMeetingRoom, _extends$3T({
    "data-icon": "meeting-room"
  }, props));
};
var Megaphone = function Megaphone(props) {
  return /*#__PURE__*/React__default.createElement(SvgMegaphone, _extends$3T({
    "data-icon": "megaphone"
  }, props));
};
var Metabolism = function Metabolism(props) {
  return /*#__PURE__*/React__default.createElement(SvgMetabolism, _extends$3T({
    "data-icon": "metabolism"
  }, props));
};
var Microphone = function Microphone(props) {
  return /*#__PURE__*/React__default.createElement(SvgMicrophone, _extends$3T({
    "data-icon": "microphone"
  }, props));
};
var Midwife = function Midwife(props) {
  return /*#__PURE__*/React__default.createElement(SvgMidwife, _extends$3T({
    "data-icon": "midwife"
  }, props));
};
var Mind = function Mind(props) {
  return /*#__PURE__*/React__default.createElement(SvgMind, _extends$3T({
    "data-icon": "mind"
  }, props));
};
var Monitor = function Monitor(props) {
  return /*#__PURE__*/React__default.createElement(SvgMonitor, _extends$3T({
    "data-icon": "monitor"
  }, props));
};
var Moon = function Moon(props) {
  return /*#__PURE__*/React__default.createElement(SvgMoon, _extends$3T({
    "data-icon": "moon"
  }, props));
};
var NetworkConnections = function NetworkConnections(props) {
  return /*#__PURE__*/React__default.createElement(SvgNetworkConnections, _extends$3T({
    "data-icon": "network-connections"
  }, props));
};
var Newsletter = function Newsletter(props) {
  return /*#__PURE__*/React__default.createElement(SvgNewsletter, _extends$3T({
    "data-icon": "newsletter"
  }, props));
};
var Newspaper = function Newspaper(props) {
  return /*#__PURE__*/React__default.createElement(SvgNewspaper, _extends$3T({
    "data-icon": "newspaper"
  }, props));
};
var NumberThree = function NumberThree(props) {
  return /*#__PURE__*/React__default.createElement(SvgNumber3, _extends$3T({
    "data-icon": "number-3"
  }, props));
};
var Nurse = function Nurse(props) {
  return /*#__PURE__*/React__default.createElement(SvgNurse, _extends$3T({
    "data-icon": "nurse"
  }, props));
};
var Nutrition = function Nutrition(props) {
  return /*#__PURE__*/React__default.createElement(SvgNutrition, _extends$3T({
    "data-icon": "nutrition"
  }, props));
};
var OfficeOnline = function OfficeOnline(props) {
  return /*#__PURE__*/React__default.createElement(SvgOfficeOnline, _extends$3T({
    "data-icon": "office-online"
  }, props));
};
var Office = function Office(props) {
  return /*#__PURE__*/React__default.createElement(SvgOffice, _extends$3T({
    "data-icon": "office"
  }, props));
};
var OnlineCourse = function OnlineCourse(props) {
  return /*#__PURE__*/React__default.createElement(SvgOnlineCourse, _extends$3T({
    "data-icon": "online-course"
  }, props));
};
var OptionalRates = function OptionalRates(props) {
  return /*#__PURE__*/React__default.createElement(SvgOptionalRates, _extends$3T({
    "data-icon": "optional-rates"
  }, props));
};
var Osteopathy = function Osteopathy(props) {
  return /*#__PURE__*/React__default.createElement(SvgOsteopathy, _extends$3T({
    "data-icon": "osteopathy"
  }, props));
};
var Parking = function Parking(props) {
  return /*#__PURE__*/React__default.createElement(SvgParking, _extends$3T({
    "data-icon": "parking"
  }, props));
};
var Persiod = function Persiod(props) {
  return /*#__PURE__*/React__default.createElement(SvgPersiod, _extends$3T({
    "data-icon": "persiod"
  }, props));
};
var PersonalCounselling = function PersonalCounselling(props) {
  return /*#__PURE__*/React__default.createElement(SvgPersonalCounselling, _extends$3T({
    "data-icon": "personal-counselling"
  }, props));
};
var PersonalScale = function PersonalScale(props) {
  return /*#__PURE__*/React__default.createElement(SvgPersonalScale, _extends$3T({
    "data-icon": "personal-scale"
  }, props));
};
var Pharmacy = function Pharmacy(props) {
  return /*#__PURE__*/React__default.createElement(SvgPharmacy, _extends$3T({
    "data-icon": "pharmacy"
  }, props));
};
var PhoneArrow = function PhoneArrow(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhoneArrow, _extends$3T({
    "data-icon": "phone-arrow"
  }, props));
};
var PhoneSpeechBubble = function PhoneSpeechBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhoneSpeechBubble, _extends$3T({
    "data-icon": "phone-speech-bubble"
  }, props));
};
var PhoneWlan = function PhoneWlan(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhoneWlan, _extends$3T({
    "data-icon": "phone-wlan"
  }, props));
};
var Phone = function Phone(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhone, _extends$3T({
    "data-icon": "phone"
  }, props));
};
var Physiotherapy = function Physiotherapy(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhysiotherapy, _extends$3T({
    "data-icon": "physiotherapy"
  }, props));
};
var Piggybank = function Piggybank(props) {
  return /*#__PURE__*/React__default.createElement(SvgPiggybank, _extends$3T({
    "data-icon": "piggybank"
  }, props));
};
var Podcast = function Podcast(props) {
  return /*#__PURE__*/React__default.createElement(SvgPodcast, _extends$3T({
    "data-icon": "podcast"
  }, props));
};
var PosterOutdoorAdvertising = function PosterOutdoorAdvertising(props) {
  return /*#__PURE__*/React__default.createElement(SvgPosterOutdoorAdvertising, _extends$3T({
    "data-icon": "poster-outdoor-advertising"
  }, props));
};
var Pregnancy = function Pregnancy(props) {
  return /*#__PURE__*/React__default.createElement(SvgPregnancy, _extends$3T({
    "data-icon": "pregnancy"
  }, props));
};
var Provision = function Provision(props) {
  return /*#__PURE__*/React__default.createElement(SvgProvision, _extends$3T({
    "data-icon": "provision"
  }, props));
};
var Pupils = function Pupils(props) {
  return /*#__PURE__*/React__default.createElement(SvgPupils, _extends$3T({
    "data-icon": "pupils"
  }, props));
};
var Rates = function Rates(props) {
  return /*#__PURE__*/React__default.createElement(SvgRates, _extends$3T({
    "data-icon": "rates"
  }, props));
};
var Recycling = function Recycling(props) {
  return /*#__PURE__*/React__default.createElement(SvgRecycling, _extends$3T({
    "data-icon": "recycling"
  }, props));
};
var Refund = function Refund(props) {
  return /*#__PURE__*/React__default.createElement(SvgRefund, _extends$3T({
    "data-icon": "refund"
  }, props));
};
var Rehab = function Rehab(props) {
  return /*#__PURE__*/React__default.createElement(SvgRehab, _extends$3T({
    "data-icon": "rehab"
  }, props));
};
var Remedies = function Remedies(props) {
  return /*#__PURE__*/React__default.createElement(SvgRemedies, _extends$3T({
    "data-icon": "remedies"
  }, props));
};
var RetirementProvision = function RetirementProvision(props) {
  return /*#__PURE__*/React__default.createElement(SvgRetirementProvision, _extends$3T({
    "data-icon": "retirement-provision"
  }, props));
};
var RocketProgress = function RocketProgress(props) {
  return /*#__PURE__*/React__default.createElement(SvgRocketProgress, _extends$3T({
    "data-icon": "rocket-progress"
  }, props));
};
var Run = function Run(props) {
  return /*#__PURE__*/React__default.createElement(SvgRun, _extends$3T({
    "data-icon": "run"
  }, props));
};
var Sad = function Sad(props) {
  return /*#__PURE__*/React__default.createElement(SvgSad, _extends$3T({
    "data-icon": "sad"
  }, props));
};
var SearchDoctor = function SearchDoctor(props) {
  return /*#__PURE__*/React__default.createElement(SvgSearchDoctor, _extends$3T({
    "data-icon": "search-doctor"
  }, props));
};
var SearchServiceProvider = function SearchServiceProvider(props) {
  return /*#__PURE__*/React__default.createElement(SvgSearchServiceProvider, _extends$3T({
    "data-icon": "search-service-provider"
  }, props));
};
var Search = function Search(props) {
  return /*#__PURE__*/React__default.createElement(SvgSearch, _extends$3T({
    "data-icon": "search"
  }, props));
};
var SecondOpinion = function SecondOpinion(props) {
  return /*#__PURE__*/React__default.createElement(SvgSecondOpinion, _extends$3T({
    "data-icon": "second-opinion"
  }, props));
};
var SelfHelpPromotion = function SelfHelpPromotion(props) {
  return /*#__PURE__*/React__default.createElement(SvgSelfHelpPromotion, _extends$3T({
    "data-icon": "self-help-promotion"
  }, props));
};
var Selfservice = function Selfservice(props) {
  return /*#__PURE__*/React__default.createElement(SvgSelfservice, _extends$3T({
    "data-icon": "selfservice"
  }, props));
};
var SeminarOnline = function SeminarOnline(props) {
  return /*#__PURE__*/React__default.createElement(SvgSeminarOnline, _extends$3T({
    "data-icon": "seminar-online"
  }, props));
};
var Seminar = function Seminar(props) {
  return /*#__PURE__*/React__default.createElement(SvgSeminar, _extends$3T({
    "data-icon": "seminar"
  }, props));
};
var SickNote = function SickNote(props) {
  return /*#__PURE__*/React__default.createElement(SvgSickNote, _extends$3T({
    "data-icon": "sick-note"
  }, props));
};
var SickPay = function SickPay(props) {
  return /*#__PURE__*/React__default.createElement(SvgSickPay, _extends$3T({
    "data-icon": "sick-pay"
  }, props));
};
var SignLanguage = function SignLanguage(props) {
  return /*#__PURE__*/React__default.createElement(SvgSignLanguage, _extends$3T({
    "data-icon": "sign-language"
  }, props));
};
var Signpost = function Signpost(props) {
  return /*#__PURE__*/React__default.createElement(SvgSignpost, _extends$3T({
    "data-icon": "signpost"
  }, props));
};
var SkinIrritations = function SkinIrritations(props) {
  return /*#__PURE__*/React__default.createElement(SvgSkinIrritations, _extends$3T({
    "data-icon": "skin-irritations"
  }, props));
};
var Smartphone = function Smartphone(props) {
  return /*#__PURE__*/React__default.createElement(SvgSmartphone, _extends$3T({
    "data-icon": "smartphone"
  }, props));
};
var SocialHealth = function SocialHealth(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialHealth, _extends$3T({
    "data-icon": "social-health"
  }, props));
};
var SocialWorkHealth = function SocialWorkHealth(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialWorkHealth, _extends$3T({
    "data-icon": "social-work-health"
  }, props));
};
var SpeechBubbleDots = function SpeechBubbleDots(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubbleDots, _extends$3T({
    "data-icon": "speech-bubble-dots"
  }, props));
};
var SpeechBubbleExclamation = function SpeechBubbleExclamation(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubbleExclamation, _extends$3T({
    "data-icon": "speech-bubble-exclamation"
  }, props));
};
var SpeechBubbleQuestion = function SpeechBubbleQuestion(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubbleQuestion, _extends$3T({
    "data-icon": "speech-bubble-question"
  }, props));
};
var SpeechBubbleText = function SpeechBubbleText(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubbleText, _extends$3T({
    "data-icon": "speech-bubble-text"
  }, props));
};
var SpeechBubble = function SpeechBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubble, _extends$3T({
    "data-icon": "speech-bubble"
  }, props));
};
var SpeechBubbles = function SpeechBubbles(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubbles, _extends$3T({
    "data-icon": "speech-bubbles"
  }, props));
};
var Speedometer = function Speedometer(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeedometer, _extends$3T({
    "data-icon": "speedometer"
  }, props));
};
var Sport = function Sport(props) {
  return /*#__PURE__*/React__default.createElement(SvgSport, _extends$3T({
    "data-icon": "sport"
  }, props));
};
var Staircase = function Staircase(props) {
  return /*#__PURE__*/React__default.createElement(SvgStaircase, _extends$3T({
    "data-icon": "staircase"
  }, props));
};
var Star = function Star(props) {
  return /*#__PURE__*/React__default.createElement(SvgStar, _extends$3T({
    "data-icon": "star"
  }, props));
};
var Student = function Student(props) {
  return /*#__PURE__*/React__default.createElement(SvgStudent, _extends$3T({
    "data-icon": "student"
  }, props));
};
var Sun = function Sun(props) {
  return /*#__PURE__*/React__default.createElement(SvgSun, _extends$3T({
    "data-icon": "sun"
  }, props));
};
var SupplementaryInsurance = function SupplementaryInsurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgSupplementaryInsurance, _extends$3T({
    "data-icon": "supplementary-insurance"
  }, props));
};
var Sustainability = function Sustainability(props) {
  return /*#__PURE__*/React__default.createElement(SvgSustainability, _extends$3T({
    "data-icon": "sustainability"
  }, props));
};
var Synapses = function Synapses(props) {
  return /*#__PURE__*/React__default.createElement(SvgSynapses, _extends$3T({
    "data-icon": "synapses"
  }, props));
};
var Thoughts = function Thoughts(props) {
  return /*#__PURE__*/React__default.createElement(SvgThoughts, _extends$3T({
    "data-icon": "thoughts"
  }, props));
};
var ToothCleaning = function ToothCleaning(props) {
  return /*#__PURE__*/React__default.createElement(SvgToothCleaning, _extends$3T({
    "data-icon": "tooth-cleaning"
  }, props));
};
var TransportSubsidy = function TransportSubsidy(props) {
  return /*#__PURE__*/React__default.createElement(SvgTransportSubsidy, _extends$3T({
    "data-icon": "transport-subsidy"
  }, props));
};
var TravelExpenses = function TravelExpenses(props) {
  return /*#__PURE__*/React__default.createElement(SvgTravelExpenses, _extends$3T({
    "data-icon": "travel-expenses"
  }, props));
};
var Travel = function Travel(props) {
  return /*#__PURE__*/React__default.createElement(SvgTravel, _extends$3T({
    "data-icon": "travel"
  }, props));
};
var TreatmentEu = function TreatmentEu(props) {
  return /*#__PURE__*/React__default.createElement(SvgTreatmentEu, _extends$3T({
    "data-icon": "treatment-eu"
  }, props));
};
var TreatmentForeignCountries = function TreatmentForeignCountries(props) {
  return /*#__PURE__*/React__default.createElement(SvgTreatmentForeignCountries, _extends$3T({
    "data-icon": "treatment-foreign-countries"
  }, props));
};
var Treatment = function Treatment(props) {
  return /*#__PURE__*/React__default.createElement(SvgTreatment, _extends$3T({
    "data-icon": "treatment"
  }, props));
};
var Trophy = function Trophy(props) {
  return /*#__PURE__*/React__default.createElement(SvgTrophy, _extends$3T({
    "data-icon": "trophy"
  }, props));
};
var Umbrella = function Umbrella(props) {
  return /*#__PURE__*/React__default.createElement(SvgUmbrella, _extends$3T({
    "data-icon": "umbrella"
  }, props));
};
var UnemploymentInsurance = function UnemploymentInsurance(props) {
  return /*#__PURE__*/React__default.createElement(SvgUnemploymentInsurance, _extends$3T({
    "data-icon": "unemployment-insurance"
  }, props));
};
var UploadFolder = function UploadFolder(props) {
  return /*#__PURE__*/React__default.createElement(SvgUploadFolder, _extends$3T({
    "data-icon": "upload-folder"
  }, props));
};
var Upload = function Upload(props) {
  return /*#__PURE__*/React__default.createElement(SvgUpload, _extends$3T({
    "data-icon": "upload"
  }, props));
};
var UserAccount = function UserAccount(props) {
  return /*#__PURE__*/React__default.createElement(SvgUserAccount, _extends$3T({
    "data-icon": "user-account"
  }, props));
};
var Vaccination = function Vaccination(props) {
  return /*#__PURE__*/React__default.createElement(SvgVaccination, _extends$3T({
    "data-icon": "vaccination"
  }, props));
};
var Video = function Video(props) {
  return /*#__PURE__*/React__default.createElement(SvgVideo, _extends$3T({
    "data-icon": "video"
  }, props));
};
var VisualImpairment = function VisualImpairment(props) {
  return /*#__PURE__*/React__default.createElement(SvgVisualImpairment, _extends$3T({
    "data-icon": "visual-impairment"
  }, props));
};
var Volume = function Volume(props) {
  return /*#__PURE__*/React__default.createElement(SvgVolume, _extends$3T({
    "data-icon": "volume"
  }, props));
};
var WaitingRoom = function WaitingRoom(props) {
  return /*#__PURE__*/React__default.createElement(SvgWaitingRoom, _extends$3T({
    "data-icon": "waiting-room"
  }, props));
};
var Wallet = function Wallet(props) {
  return /*#__PURE__*/React__default.createElement(SvgWallet, _extends$3T({
    "data-icon": "wallet"
  }, props));
};
var WcLadies = function WcLadies(props) {
  return /*#__PURE__*/React__default.createElement(SvgWcLadies, _extends$3T({
    "data-icon": "wc-ladies"
  }, props));
};
var WcMen = function WcMen(props) {
  return /*#__PURE__*/React__default.createElement(SvgWcMen, _extends$3T({
    "data-icon": "wc-men"
  }, props));
};
var Wc = function Wc(props) {
  return /*#__PURE__*/React__default.createElement(SvgWc, _extends$3T({
    "data-icon": "wc"
  }, props));
};
var Weather = function Weather(props) {
  return /*#__PURE__*/React__default.createElement(SvgWeather, _extends$3T({
    "data-icon": "weather"
  }, props));
};
var WellBeing = function WellBeing(props) {
  return /*#__PURE__*/React__default.createElement(SvgWellBeing, _extends$3T({
    "data-icon": "well-being"
  }, props));
};
var WheelchairUser = function WheelchairUser(props) {
  return /*#__PURE__*/React__default.createElement(SvgWheelchairUser, _extends$3T({
    "data-icon": "wheelchair-user"
  }, props));
};
var Wind = function Wind(props) {
  return /*#__PURE__*/React__default.createElement(SvgWind, _extends$3T({
    "data-icon": "wind"
  }, props));
};
var WorkLiveBalance = function WorkLiveBalance(props) {
  return /*#__PURE__*/React__default.createElement(SvgWorkLiveBalance, _extends$3T({
    "data-icon": "work-live-balance"
  }, props));
};
var World = function World(props) {
  return /*#__PURE__*/React__default.createElement(SvgWorld, _extends$3T({
    "data-icon": "world"
  }, props));
};
var Yoga = function Yoga(props) {
  return /*#__PURE__*/React__default.createElement(SvgYoga, _extends$3T({
    "data-icon": "yoga"
  }, props));
};

var _excluded = ["name", "className"];

var Icon = function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  switch (name) {
    case 'accessibility':
      return /*#__PURE__*/React__default.createElement(Accessibility, _extends$3T({
        className: className
      }, rest));

    case 'accident-insurance':
      return /*#__PURE__*/React__default.createElement(AccidentInsurance, _extends$3T({
        className: className
      }, rest));

    case 'address-book':
      return /*#__PURE__*/React__default.createElement(AddressBook, _extends$3T({
        className: className
      }, rest));

    case 'administration-healthcare':
      return /*#__PURE__*/React__default.createElement(AdministrationHealthcare, _extends$3T({
        className: className
      }, rest));

    case 'allergy-bedding':
      return /*#__PURE__*/React__default.createElement(AllergyBedding, _extends$3T({
        className: className
      }, rest));

    case 'ambulance':
      return /*#__PURE__*/React__default.createElement(Ambulance, _extends$3T({
        className: className
      }, rest));

    case 'aok-bonus-program':
      return /*#__PURE__*/React__default.createElement(AokBonusProgram, _extends$3T({
        className: className
      }, rest));

    case 'aok-health-account':
      return /*#__PURE__*/React__default.createElement(AokHealthAccount, _extends$3T({
        className: className
      }, rest));

    case 'aok-premium-program':
      return /*#__PURE__*/React__default.createElement(AokPremiumProgram, _extends$3T({
        className: className
      }, rest));

    case 'aok-recommendation':
      return /*#__PURE__*/React__default.createElement(AokRecommendation, _extends$3T({
        className: className
      }, rest));

    case 'aok':
      return /*#__PURE__*/React__default.createElement(Aok, _extends$3T({
        className: className
      }, rest));

    case 'apprenticeships':
      return /*#__PURE__*/React__default.createElement(Apprenticeships, _extends$3T({
        className: className
      }, rest));

    case 'approval-wait':
      return /*#__PURE__*/React__default.createElement(ApprovalWait, _extends$3T({
        className: className
      }, rest));

    case 'arrow-down-left':
      return /*#__PURE__*/React__default.createElement(ArrowDownLeft, _extends$3T({
        className: className
      }, rest));

    case 'arrow-down-right':
      return /*#__PURE__*/React__default.createElement(ArrowDownRight, _extends$3T({
        className: className
      }, rest));

    case 'arrow-down':
      return /*#__PURE__*/React__default.createElement(ArrowDown, _extends$3T({
        className: className
      }, rest));

    case 'arrow-left':
      return /*#__PURE__*/React__default.createElement(ArrowLeft, _extends$3T({
        className: className
      }, rest));

    case 'arrow-right':
      return /*#__PURE__*/React__default.createElement(ArrowRight, _extends$3T({
        className: className
      }, rest));

    case 'arrow-up-left':
      return /*#__PURE__*/React__default.createElement(ArrowUpLeft, _extends$3T({
        className: className
      }, rest));

    case 'arrow-up-right':
      return /*#__PURE__*/React__default.createElement(ArrowUpRight, _extends$3T({
        className: className
      }, rest));

    case 'arrow-up':
      return /*#__PURE__*/React__default.createElement(ArrowUp, _extends$3T({
        className: className
      }, rest));

    case 'assistance-dog':
      return /*#__PURE__*/React__default.createElement(AssistanceDog, _extends$3T({
        className: className
      }, rest));

    case 'baby-bonus':
      return /*#__PURE__*/React__default.createElement(BabyBonus, _extends$3T({
        className: className
      }, rest));

    case 'baby':
      return /*#__PURE__*/React__default.createElement(Baby, _extends$3T({
        className: className
      }, rest));

    case 'balloon':
      return /*#__PURE__*/React__default.createElement(Balloon, _extends$3T({
        className: className
      }, rest));

    case 'bandage':
      return /*#__PURE__*/React__default.createElement(Bandage, _extends$3T({
        className: className
      }, rest));

    case 'bank':
      return /*#__PURE__*/React__default.createElement(Bank, _extends$3T({
        className: className
      }, rest));

    case 'battery-charging':
      return /*#__PURE__*/React__default.createElement(BatteryCharging, _extends$3T({
        className: className
      }, rest));

    case 'beauty-lipstick':
      return /*#__PURE__*/React__default.createElement(BeautyLipstick, _extends$3T({
        className: className
      }, rest));

    case 'become-a-member':
      return /*#__PURE__*/React__default.createElement(BecomeAMember, _extends$3T({
        className: className
      }, rest));

    case 'bike':
      return /*#__PURE__*/React__default.createElement(Bike, _extends$3T({
        className: className
      }, rest));

    case 'birth-preparation-course':
      return /*#__PURE__*/React__default.createElement(BirthPreparationCourse, _extends$3T({
        className: className
      }, rest));

    case 'bone':
      return /*#__PURE__*/React__default.createElement(Bone, _extends$3T({
        className: className
      }, rest));

    case 'bonus':
      return /*#__PURE__*/React__default.createElement(Bonus, _extends$3T({
        className: className
      }, rest));

    case 'bookmark':
      return /*#__PURE__*/React__default.createElement(Bookmark, _extends$3T({
        className: className
      }, rest));

    case 'bread':
      return /*#__PURE__*/React__default.createElement(Bread, _extends$3T({
        className: className
      }, rest));

    case 'bubble-question':
      return /*#__PURE__*/React__default.createElement(BubbleQuestion, _extends$3T({
        className: className
      }, rest));

    case 'cafeteria':
      return /*#__PURE__*/React__default.createElement(Cafeteria, _extends$3T({
        className: className
      }, rest));

    case 'calender-arrow':
      return /*#__PURE__*/React__default.createElement(CalenderArrow, _extends$3T({
        className: className
      }, rest));

    case 'calender-check':
      return /*#__PURE__*/React__default.createElement(CalenderCheck, _extends$3T({
        className: className
      }, rest));

    case 'calender-date':
      return /*#__PURE__*/React__default.createElement(CalenderDate, _extends$3T({
        className: className
      }, rest));

    case 'calender':
      return /*#__PURE__*/React__default.createElement(Calender, _extends$3T({
        className: className
      }, rest));

    case 'cancellation-form':
      return /*#__PURE__*/React__default.createElement(CancellationForm, _extends$3T({
        className: className
      }, rest));

    case 'car':
      return /*#__PURE__*/React__default.createElement(Car, _extends$3T({
        className: className
      }, rest));

    case 'care-insurance':
      return /*#__PURE__*/React__default.createElement(CareInsurance, _extends$3T({
        className: className
      }, rest));

    case 'care':
      return /*#__PURE__*/React__default.createElement(Care, _extends$3T({
        className: className
      }, rest));

    case 'chaning-room':
      return /*#__PURE__*/React__default.createElement(ChaningRoom, _extends$3T({
        className: className
      }, rest));

    case 'charity':
      return /*#__PURE__*/React__default.createElement(Charity, _extends$3T({
        className: className
      }, rest));

    case 'chat-online':
      return /*#__PURE__*/React__default.createElement(ChatOnline, _extends$3T({
        className: className
      }, rest));

    case 'chatbot':
      return /*#__PURE__*/React__default.createElement(Chatbot, _extends$3T({
        className: className
      }, rest));

    case 'check':
      return /*#__PURE__*/React__default.createElement(Check, _extends$3T({
        className: className
      }, rest));

    case 'chef-hat':
      return /*#__PURE__*/React__default.createElement(ChefHat, _extends$3T({
        className: className
      }, rest));

    case 'child-sickness-benefit':
      return /*#__PURE__*/React__default.createElement(ChildSicknessBenefit, _extends$3T({
        className: className
      }, rest));

    case 'child':
      return /*#__PURE__*/React__default.createElement(Child, _extends$3T({
        className: className
      }, rest));

    case 'clinical-thermometer':
      return /*#__PURE__*/React__default.createElement(ClinicalThermometer, _extends$3T({
        className: className
      }, rest));

    case 'cloakroom':
      return /*#__PURE__*/React__default.createElement(Cloakroom, _extends$3T({
        className: className
      }, rest));

    case 'clock':
      return /*#__PURE__*/React__default.createElement(Clock, _extends$3T({
        className: className
      }, rest));

    case 'cloud':
      return /*#__PURE__*/React__default.createElement(Cloud, _extends$3T({
        className: className
      }, rest));

    case 'co-browsing':
      return /*#__PURE__*/React__default.createElement(CoBrowsing, _extends$3T({
        className: className
      }, rest));

    case 'co-payments':
      return /*#__PURE__*/React__default.createElement(CoPayments, _extends$3T({
        className: className
      }, rest));

    case 'compass':
      return /*#__PURE__*/React__default.createElement(Compass, _extends$3T({
        className: className
      }, rest));

    case 'contributions':
      return /*#__PURE__*/React__default.createElement(Contributions, _extends$3T({
        className: className
      }, rest));

    case 'cookies':
      return /*#__PURE__*/React__default.createElement(Cookies, _extends$3T({
        className: className
      }, rest));

    case 'corporate-clients':
      return /*#__PURE__*/React__default.createElement(CorporateClients, _extends$3T({
        className: className
      }, rest));

    case 'cure':
      return /*#__PURE__*/React__default.createElement(Cure, _extends$3T({
        className: className
      }, rest));

    case 'customer-satisfaction':
      return /*#__PURE__*/React__default.createElement(CustomerSatisfaction, _extends$3T({
        className: className
      }, rest));

    case 'cutlery':
      return /*#__PURE__*/React__default.createElement(Cutlery, _extends$3T({
        className: className
      }, rest));

    case 'data-exchange':
      return /*#__PURE__*/React__default.createElement(DataExchange, _extends$3T({
        className: className
      }, rest));

    case 'dementia':
      return /*#__PURE__*/React__default.createElement(Dementia, _extends$3T({
        className: className
      }, rest));

    case 'dentistry':
      return /*#__PURE__*/React__default.createElement(Dentistry, _extends$3T({
        className: className
      }, rest));

    case 'devices':
      return /*#__PURE__*/React__default.createElement(Devices, _extends$3T({
        className: className
      }, rest));

    case 'diagram':
      return /*#__PURE__*/React__default.createElement(Diagram, _extends$3T({
        className: className
      }, rest));

    case 'diamont':
      return /*#__PURE__*/React__default.createElement(Diamont, _extends$3T({
        className: className
      }, rest));

    case 'digestion':
      return /*#__PURE__*/React__default.createElement(Digestion, _extends$3T({
        className: className
      }, rest));

    case 'digital-health-applications':
      return /*#__PURE__*/React__default.createElement(DigitalHealthApplications, _extends$3T({
        className: className
      }, rest));

    case 'digital-health-card':
      return /*#__PURE__*/React__default.createElement(DigitalHealthCard, _extends$3T({
        className: className
      }, rest));

    case 'digital-patient-receipt':
      return /*#__PURE__*/React__default.createElement(DigitalPatientReceipt, _extends$3T({
        className: className
      }, rest));

    case 'doctor':
      return /*#__PURE__*/React__default.createElement(Doctor, _extends$3T({
        className: className
      }, rest));

    case 'dokument':
      return /*#__PURE__*/React__default.createElement(Dokument, _extends$3T({
        className: className
      }, rest));

    case 'download-folder':
      return /*#__PURE__*/React__default.createElement(DownloadFolder, _extends$3T({
        className: className
      }, rest));

    case 'download':
      return /*#__PURE__*/React__default.createElement(Download, _extends$3T({
        className: className
      }, rest));

    case 'drop':
      return /*#__PURE__*/React__default.createElement(Drop, _extends$3T({
        className: className
      }, rest));

    case 'dual-study':
      return /*#__PURE__*/React__default.createElement(DualStudy, _extends$3T({
        className: className
      }, rest));

    case 'early-detection':
      return /*#__PURE__*/React__default.createElement(EarlyDetection, _extends$3T({
        className: className
      }, rest));

    case 'easy-language':
      return /*#__PURE__*/React__default.createElement(EasyLanguage, _extends$3T({
        className: className
      }, rest));

    case 'emergency-rescue-ring':
      return /*#__PURE__*/React__default.createElement(EmergencyRescueRing, _extends$3T({
        className: className
      }, rest));

    case 'employed':
      return /*#__PURE__*/React__default.createElement(Employed, _extends$3T({
        className: className
      }, rest));

    case 'envelope':
      return /*#__PURE__*/React__default.createElement(Envelope, _extends$3T({
        className: className
      }, rest));

    case 'family':
      return /*#__PURE__*/React__default.createElement(Family, _extends$3T({
        className: className
      }, rest));

    case 'file':
      return /*#__PURE__*/React__default.createElement(File, _extends$3T({
        className: className
      }, rest));

    case 'files':
      return /*#__PURE__*/React__default.createElement(Files, _extends$3T({
        className: className
      }, rest));

    case 'fire':
      return /*#__PURE__*/React__default.createElement(Fire, _extends$3T({
        className: className
      }, rest));

    case 'flag':
      return /*#__PURE__*/React__default.createElement(Flag, _extends$3T({
        className: className
      }, rest));

    case 'folder':
      return /*#__PURE__*/React__default.createElement(Folder, _extends$3T({
        className: className
      }, rest));

    case 'form':
      return /*#__PURE__*/React__default.createElement(Form, _extends$3T({
        className: className
      }, rest));

    case 'general-practitioner':
      return /*#__PURE__*/React__default.createElement(GeneralPractitioner, _extends$3T({
        className: className
      }, rest));

    case 'gift':
      return /*#__PURE__*/React__default.createElement(Gift, _extends$3T({
        className: className
      }, rest));

    case 'glasses':
      return /*#__PURE__*/React__default.createElement(Glasses, _extends$3T({
        className: className
      }, rest));

    case 'goal':
      return /*#__PURE__*/React__default.createElement(Goal, _extends$3T({
        className: className
      }, rest));

    case 'grapes':
      return /*#__PURE__*/React__default.createElement(Grapes, _extends$3T({
        className: className
      }, rest));

    case 'hand-show':
      return /*#__PURE__*/React__default.createElement(HandShow, _extends$3T({
        className: className
      }, rest));

    case 'hand-stop':
      return /*#__PURE__*/React__default.createElement(HandStop, _extends$3T({
        className: className
      }, rest));

    case 'hand-thumb-up':
      return /*#__PURE__*/React__default.createElement(HandThumbUp, _extends$3T({
        className: className
      }, rest));

    case 'handshake-care':
      return /*#__PURE__*/React__default.createElement(HandshakeCare, _extends$3T({
        className: className
      }, rest));

    case 'happy':
      return /*#__PURE__*/React__default.createElement(Happy, _extends$3T({
        className: className
      }, rest));

    case 'headphones-1':
      return /*#__PURE__*/React__default.createElement(HeadphonesOne, _extends$3T({
        className: className
      }, rest));

    case 'headphones-2':
      return /*#__PURE__*/React__default.createElement(HeadphonesTwo, _extends$3T({
        className: className
      }, rest));

    case 'health-check':
      return /*#__PURE__*/React__default.createElement(HealthCheck, _extends$3T({
        className: className
      }, rest));

    case 'health-course':
      return /*#__PURE__*/React__default.createElement(HealthCourse, _extends$3T({
        className: className
      }, rest));

    case 'health-insurance':
      return /*#__PURE__*/React__default.createElement(HealthInsurance, _extends$3T({
        className: className
      }, rest));

    case 'health-partner':
      return /*#__PURE__*/React__default.createElement(HealthPartner, _extends$3T({
        className: className
      }, rest));

    case 'health-resources':
      return /*#__PURE__*/React__default.createElement(HealthResources, _extends$3T({
        className: className
      }, rest));

    case 'hearing-impairment':
      return /*#__PURE__*/React__default.createElement(HearingImpairment, _extends$3T({
        className: className
      }, rest));

    case 'heart-beat':
      return /*#__PURE__*/React__default.createElement(HeartBeat, _extends$3T({
        className: className
      }, rest));

    case 'heart':
      return /*#__PURE__*/React__default.createElement(Heart, _extends$3T({
        className: className
      }, rest));

    case 'home-nursing':
      return /*#__PURE__*/React__default.createElement(HomeNursing, _extends$3T({
        className: className
      }, rest));

    case 'hospital-treatment':
      return /*#__PURE__*/React__default.createElement(HospitalTreatment, _extends$3T({
        className: className
      }, rest));

    case 'hospital':
      return /*#__PURE__*/React__default.createElement(Hospital, _extends$3T({
        className: className
      }, rest));

    case 'housekeeping':
      return /*#__PURE__*/React__default.createElement(Housekeeping, _extends$3T({
        className: className
      }, rest));

    case 'hygiene-arm-bend':
      return /*#__PURE__*/React__default.createElement(HygieneArmBend, _extends$3T({
        className: className
      }, rest));

    case 'hygiene-disinfection':
      return /*#__PURE__*/React__default.createElement(HygieneDisinfection, _extends$3T({
        className: className
      }, rest));

    case 'hygiene-mask':
      return /*#__PURE__*/React__default.createElement(HygieneMask, _extends$3T({
        className: className
      }, rest));

    case 'insurance-eu':
      return /*#__PURE__*/React__default.createElement(InsuranceEu, _extends$3T({
        className: className
      }, rest));

    case 'insurance':
      return /*#__PURE__*/React__default.createElement(Insurance, _extends$3T({
        className: className
      }, rest));

    case 'integrated-care':
      return /*#__PURE__*/React__default.createElement(IntegratedCare, _extends$3T({
        className: className
      }, rest));

    case 'job-offer':
      return /*#__PURE__*/React__default.createElement(JobOffer, _extends$3T({
        className: className
      }, rest));

    case 'jolinchen':
      return /*#__PURE__*/React__default.createElement(Jolinchen, _extends$3T({
        className: className
      }, rest));

    case 'law':
      return /*#__PURE__*/React__default.createElement(Law, _extends$3T({
        className: className
      }, rest));

    case 'lebensbaum':
      return /*#__PURE__*/React__default.createElement(Lebensbaum, _extends$3T({
        className: className
      }, rest));

    case 'legal-database':
      return /*#__PURE__*/React__default.createElement(LegalDatabase, _extends$3T({
        className: className
      }, rest));

    case 'lift':
      return /*#__PURE__*/React__default.createElement(Lift, _extends$3T({
        className: className
      }, rest));

    case 'light-bulb':
      return /*#__PURE__*/React__default.createElement(LightBulb, _extends$3T({
        className: className
      }, rest));

    case 'living-room':
      return /*#__PURE__*/React__default.createElement(LivingRoom, _extends$3T({
        className: className
      }, rest));

    case 'location':
      return /*#__PURE__*/React__default.createElement(Location, _extends$3T({
        className: className
      }, rest));

    case 'lungs-breath-system':
      return /*#__PURE__*/React__default.createElement(LungsBreathSystem, _extends$3T({
        className: className
      }, rest));

    case 'magazin':
      return /*#__PURE__*/React__default.createElement(Magazin, _extends$3T({
        className: className
      }, rest));

    case 'management':
      return /*#__PURE__*/React__default.createElement(Management, _extends$3T({
        className: className
      }, rest));

    case 'map':
      return /*#__PURE__*/React__default.createElement(Map, _extends$3T({
        className: className
      }, rest));

    case 'maternity-benefit':
      return /*#__PURE__*/React__default.createElement(MaternityBenefit, _extends$3T({
        className: className
      }, rest));

    case 'medial-offers':
      return /*#__PURE__*/React__default.createElement(MedialOffers, _extends$3T({
        className: className
      }, rest));

    case 'medicine-care':
      return /*#__PURE__*/React__default.createElement(MedicineCare, _extends$3T({
        className: className
      }, rest));

    case 'medicines':
      return /*#__PURE__*/React__default.createElement(Medicines, _extends$3T({
        className: className
      }, rest));

    case 'meeting-room':
      return /*#__PURE__*/React__default.createElement(MeetingRoom, _extends$3T({
        className: className
      }, rest));

    case 'megaphone':
      return /*#__PURE__*/React__default.createElement(Megaphone, _extends$3T({
        className: className
      }, rest));

    case 'metabolism':
      return /*#__PURE__*/React__default.createElement(Metabolism, _extends$3T({
        className: className
      }, rest));

    case 'microphone':
      return /*#__PURE__*/React__default.createElement(Microphone, _extends$3T({
        className: className
      }, rest));

    case 'midwife':
      return /*#__PURE__*/React__default.createElement(Midwife, _extends$3T({
        className: className
      }, rest));

    case 'mind':
      return /*#__PURE__*/React__default.createElement(Mind, _extends$3T({
        className: className
      }, rest));

    case 'monitor':
      return /*#__PURE__*/React__default.createElement(Monitor, _extends$3T({
        className: className
      }, rest));

    case 'moon':
      return /*#__PURE__*/React__default.createElement(Moon, _extends$3T({
        className: className
      }, rest));

    case 'network-connections':
      return /*#__PURE__*/React__default.createElement(NetworkConnections, _extends$3T({
        className: className
      }, rest));

    case 'newsletter':
      return /*#__PURE__*/React__default.createElement(Newsletter, _extends$3T({
        className: className
      }, rest));

    case 'newspaper':
      return /*#__PURE__*/React__default.createElement(Newspaper, _extends$3T({
        className: className
      }, rest));

    case 'number-3':
      return /*#__PURE__*/React__default.createElement(NumberThree, _extends$3T({
        className: className
      }, rest));

    case 'nurse':
      return /*#__PURE__*/React__default.createElement(Nurse, _extends$3T({
        className: className
      }, rest));

    case 'nutrition':
      return /*#__PURE__*/React__default.createElement(Nutrition, _extends$3T({
        className: className
      }, rest));

    case 'office-online':
      return /*#__PURE__*/React__default.createElement(OfficeOnline, _extends$3T({
        className: className
      }, rest));

    case 'office':
      return /*#__PURE__*/React__default.createElement(Office, _extends$3T({
        className: className
      }, rest));

    case 'online-course':
      return /*#__PURE__*/React__default.createElement(OnlineCourse, _extends$3T({
        className: className
      }, rest));

    case 'optional-rates':
      return /*#__PURE__*/React__default.createElement(OptionalRates, _extends$3T({
        className: className
      }, rest));

    case 'osteopathy':
      return /*#__PURE__*/React__default.createElement(Osteopathy, _extends$3T({
        className: className
      }, rest));

    case 'parking':
      return /*#__PURE__*/React__default.createElement(Parking, _extends$3T({
        className: className
      }, rest));

    case 'persiod':
      return /*#__PURE__*/React__default.createElement(Persiod, _extends$3T({
        className: className
      }, rest));

    case 'personal-counselling':
      return /*#__PURE__*/React__default.createElement(PersonalCounselling, _extends$3T({
        className: className
      }, rest));

    case 'personal-scale':
      return /*#__PURE__*/React__default.createElement(PersonalScale, _extends$3T({
        className: className
      }, rest));

    case 'pharmacy':
      return /*#__PURE__*/React__default.createElement(Pharmacy, _extends$3T({
        className: className
      }, rest));

    case 'phone-arrow':
      return /*#__PURE__*/React__default.createElement(PhoneArrow, _extends$3T({
        className: className
      }, rest));

    case 'phone-speech-bubble':
      return /*#__PURE__*/React__default.createElement(PhoneSpeechBubble, _extends$3T({
        className: className
      }, rest));

    case 'phone-wlan':
      return /*#__PURE__*/React__default.createElement(PhoneWlan, _extends$3T({
        className: className
      }, rest));

    case 'phone':
      return /*#__PURE__*/React__default.createElement(Phone, _extends$3T({
        className: className
      }, rest));

    case 'physiotherapy':
      return /*#__PURE__*/React__default.createElement(Physiotherapy, _extends$3T({
        className: className
      }, rest));

    case 'piggybank':
      return /*#__PURE__*/React__default.createElement(Piggybank, _extends$3T({
        className: className
      }, rest));

    case 'podcast':
      return /*#__PURE__*/React__default.createElement(Podcast, _extends$3T({
        className: className
      }, rest));

    case 'poster-outdoor-advertising':
      return /*#__PURE__*/React__default.createElement(PosterOutdoorAdvertising, _extends$3T({
        className: className
      }, rest));

    case 'pregnancy':
      return /*#__PURE__*/React__default.createElement(Pregnancy, _extends$3T({
        className: className
      }, rest));

    case 'provision':
      return /*#__PURE__*/React__default.createElement(Provision, _extends$3T({
        className: className
      }, rest));

    case 'pupils':
      return /*#__PURE__*/React__default.createElement(Pupils, _extends$3T({
        className: className
      }, rest));

    case 'rates':
      return /*#__PURE__*/React__default.createElement(Rates, _extends$3T({
        className: className
      }, rest));

    case 'recycling':
      return /*#__PURE__*/React__default.createElement(Recycling, _extends$3T({
        className: className
      }, rest));

    case 'refund':
      return /*#__PURE__*/React__default.createElement(Refund, _extends$3T({
        className: className
      }, rest));

    case 'rehab':
      return /*#__PURE__*/React__default.createElement(Rehab, _extends$3T({
        className: className
      }, rest));

    case 'remedies':
      return /*#__PURE__*/React__default.createElement(Remedies, _extends$3T({
        className: className
      }, rest));

    case 'retirement-provision':
      return /*#__PURE__*/React__default.createElement(RetirementProvision, _extends$3T({
        className: className
      }, rest));

    case 'rocket-progress':
      return /*#__PURE__*/React__default.createElement(RocketProgress, _extends$3T({
        className: className
      }, rest));

    case 'run':
      return /*#__PURE__*/React__default.createElement(Run, _extends$3T({
        className: className
      }, rest));

    case 'sad':
      return /*#__PURE__*/React__default.createElement(Sad, _extends$3T({
        className: className
      }, rest));

    case 'search-doctor':
      return /*#__PURE__*/React__default.createElement(SearchDoctor, _extends$3T({
        className: className
      }, rest));

    case 'search-service-provider':
      return /*#__PURE__*/React__default.createElement(SearchServiceProvider, _extends$3T({
        className: className
      }, rest));

    case 'search':
      return /*#__PURE__*/React__default.createElement(Search, _extends$3T({
        className: className
      }, rest));

    case 'second-opinion':
      return /*#__PURE__*/React__default.createElement(SecondOpinion, _extends$3T({
        className: className
      }, rest));

    case 'self-help-promotion':
      return /*#__PURE__*/React__default.createElement(SelfHelpPromotion, _extends$3T({
        className: className
      }, rest));

    case 'selfservice':
      return /*#__PURE__*/React__default.createElement(Selfservice, _extends$3T({
        className: className
      }, rest));

    case 'seminar-online':
      return /*#__PURE__*/React__default.createElement(SeminarOnline, _extends$3T({
        className: className
      }, rest));

    case 'seminar':
      return /*#__PURE__*/React__default.createElement(Seminar, _extends$3T({
        className: className
      }, rest));

    case 'sick-note':
      return /*#__PURE__*/React__default.createElement(SickNote, _extends$3T({
        className: className
      }, rest));

    case 'sick-pay':
      return /*#__PURE__*/React__default.createElement(SickPay, _extends$3T({
        className: className
      }, rest));

    case 'sign-language':
      return /*#__PURE__*/React__default.createElement(SignLanguage, _extends$3T({
        className: className
      }, rest));

    case 'signpost':
      return /*#__PURE__*/React__default.createElement(Signpost, _extends$3T({
        className: className
      }, rest));

    case 'skin-irritations':
      return /*#__PURE__*/React__default.createElement(SkinIrritations, _extends$3T({
        className: className
      }, rest));

    case 'smartphone':
      return /*#__PURE__*/React__default.createElement(Smartphone, _extends$3T({
        className: className
      }, rest));

    case 'social-health':
      return /*#__PURE__*/React__default.createElement(SocialHealth, _extends$3T({
        className: className
      }, rest));

    case 'social-work-health':
      return /*#__PURE__*/React__default.createElement(SocialWorkHealth, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubble-dots':
      return /*#__PURE__*/React__default.createElement(SpeechBubbleDots, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubble-exclamation':
      return /*#__PURE__*/React__default.createElement(SpeechBubbleExclamation, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubble-question':
      return /*#__PURE__*/React__default.createElement(SpeechBubbleQuestion, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubble-text':
      return /*#__PURE__*/React__default.createElement(SpeechBubbleText, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubble':
      return /*#__PURE__*/React__default.createElement(SpeechBubble, _extends$3T({
        className: className
      }, rest));

    case 'speech-bubbles':
      return /*#__PURE__*/React__default.createElement(SpeechBubbles, _extends$3T({
        className: className
      }, rest));

    case 'speedometer':
      return /*#__PURE__*/React__default.createElement(Speedometer, _extends$3T({
        className: className
      }, rest));

    case 'sport':
      return /*#__PURE__*/React__default.createElement(Sport, _extends$3T({
        className: className
      }, rest));

    case 'staircase':
      return /*#__PURE__*/React__default.createElement(Staircase, _extends$3T({
        className: className
      }, rest));

    case 'star':
      return /*#__PURE__*/React__default.createElement(Star, _extends$3T({
        className: className
      }, rest));

    case 'student':
      return /*#__PURE__*/React__default.createElement(Student, _extends$3T({
        className: className
      }, rest));

    case 'sun':
      return /*#__PURE__*/React__default.createElement(Sun, _extends$3T({
        className: className
      }, rest));

    case 'supplementary-insurance':
      return /*#__PURE__*/React__default.createElement(SupplementaryInsurance, _extends$3T({
        className: className
      }, rest));

    case 'sustainability':
      return /*#__PURE__*/React__default.createElement(Sustainability, _extends$3T({
        className: className
      }, rest));

    case 'synapses':
      return /*#__PURE__*/React__default.createElement(Synapses, _extends$3T({
        className: className
      }, rest));

    case 'thoughts':
      return /*#__PURE__*/React__default.createElement(Thoughts, _extends$3T({
        className: className
      }, rest));

    case 'tooth-cleaning':
      return /*#__PURE__*/React__default.createElement(ToothCleaning, _extends$3T({
        className: className
      }, rest));

    case 'transport-subsidy':
      return /*#__PURE__*/React__default.createElement(TransportSubsidy, _extends$3T({
        className: className
      }, rest));

    case 'travel-expenses':
      return /*#__PURE__*/React__default.createElement(TravelExpenses, _extends$3T({
        className: className
      }, rest));

    case 'travel':
      return /*#__PURE__*/React__default.createElement(Travel, _extends$3T({
        className: className
      }, rest));

    case 'treatment-eu':
      return /*#__PURE__*/React__default.createElement(TreatmentEu, _extends$3T({
        className: className
      }, rest));

    case 'treatment-foreign-countries':
      return /*#__PURE__*/React__default.createElement(TreatmentForeignCountries, _extends$3T({
        className: className
      }, rest));

    case 'treatment':
      return /*#__PURE__*/React__default.createElement(Treatment, _extends$3T({
        className: className
      }, rest));

    case 'trophy':
      return /*#__PURE__*/React__default.createElement(Trophy, _extends$3T({
        className: className
      }, rest));

    case 'umbrella':
      return /*#__PURE__*/React__default.createElement(Umbrella, _extends$3T({
        className: className
      }, rest));

    case 'unemployment-insurance':
      return /*#__PURE__*/React__default.createElement(UnemploymentInsurance, _extends$3T({
        className: className
      }, rest));

    case 'upload-folder':
      return /*#__PURE__*/React__default.createElement(UploadFolder, _extends$3T({
        className: className
      }, rest));

    case 'upload':
      return /*#__PURE__*/React__default.createElement(Upload, _extends$3T({
        className: className
      }, rest));

    case 'user-account':
      return /*#__PURE__*/React__default.createElement(UserAccount, _extends$3T({
        className: className
      }, rest));

    case 'vaccination':
      return /*#__PURE__*/React__default.createElement(Vaccination, _extends$3T({
        className: className
      }, rest));

    case 'video':
      return /*#__PURE__*/React__default.createElement(Video, _extends$3T({
        className: className
      }, rest));

    case 'visual-impairment':
      return /*#__PURE__*/React__default.createElement(VisualImpairment, _extends$3T({
        className: className
      }, rest));

    case 'volume':
      return /*#__PURE__*/React__default.createElement(Volume, _extends$3T({
        className: className
      }, rest));

    case 'waiting-room':
      return /*#__PURE__*/React__default.createElement(WaitingRoom, _extends$3T({
        className: className
      }, rest));

    case 'wallet':
      return /*#__PURE__*/React__default.createElement(Wallet, _extends$3T({
        className: className
      }, rest));

    case 'wc-ladies':
      return /*#__PURE__*/React__default.createElement(WcLadies, _extends$3T({
        className: className
      }, rest));

    case 'wc-men':
      return /*#__PURE__*/React__default.createElement(WcMen, _extends$3T({
        className: className
      }, rest));

    case 'wc':
      return /*#__PURE__*/React__default.createElement(Wc, _extends$3T({
        className: className
      }, rest));

    case 'weather':
      return /*#__PURE__*/React__default.createElement(Weather, _extends$3T({
        className: className
      }, rest));

    case 'well-being':
      return /*#__PURE__*/React__default.createElement(WellBeing, _extends$3T({
        className: className
      }, rest));

    case 'wheelchair-user':
      return /*#__PURE__*/React__default.createElement(WheelchairUser, _extends$3T({
        className: className
      }, rest));

    case 'wind':
      return /*#__PURE__*/React__default.createElement(Wind, _extends$3T({
        className: className
      }, rest));

    case 'work-live-balance':
      return /*#__PURE__*/React__default.createElement(WorkLiveBalance, _extends$3T({
        className: className
      }, rest));

    case 'world':
      return /*#__PURE__*/React__default.createElement(World, _extends$3T({
        className: className
      }, rest));

    case 'yoga':
      return /*#__PURE__*/React__default.createElement(Yoga, _extends$3T({
        className: className
      }, rest));

    default:
      return /*#__PURE__*/React__default.createElement(Aok, _extends$3T({
        className: className
      }, rest));
  }
};

Icon.propTypes = {
  name: PropTypes.string,
  // icon filename
  className: PropTypes.string
};
Icon.defaultProps = {
  name: '',
  className: ''
};

export { Accessibility, AccidentInsurance, AddressBook, AdministrationHealthcare, AllergyBedding, Ambulance, Aok, AokBonusProgram, AokHealthAccount, AokPremiumProgram, AokRecommendation, Apprenticeships, ApprovalWait, ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowRight, ArrowUp, ArrowUpLeft, ArrowUpRight, AssistanceDog, Baby, BabyBonus, Balloon, Bandage, Bank, BatteryCharging, BeautyLipstick, BecomeAMember, Bike, BirthPreparationCourse, Bone, Bonus, Bookmark, Bread, BubbleQuestion, Cafeteria, Calender, CalenderArrow, CalenderCheck, CalenderDate, CancellationForm, Car, Care, CareInsurance, ChaningRoom, Charity, ChatOnline, Chatbot, Check, ChefHat, Child, ChildSicknessBenefit, ClinicalThermometer, Cloakroom, Clock, Cloud, CoBrowsing, CoPayments, Compass, Contributions, Cookies, CorporateClients, Cure, CustomerSatisfaction, Cutlery, DataExchange, Dementia, Dentistry, Devices, Diagram, Diamont, Digestion, DigitalHealthApplications, DigitalHealthCard, DigitalPatientReceipt, Doctor, Dokument, Download, DownloadFolder, Drop, DualStudy, EarlyDetection, EasyLanguage, EmergencyRescueRing, Employed, Envelope, Family, File, Files, Fire, Flag, Folder, Form, GeneralPractitioner, Gift, Glasses, Goal, Grapes, HandShow, HandStop, HandThumbUp, HandshakeCare, Happy, HeadphonesOne, HeadphonesTwo, HealthCheck, HealthCourse, HealthInsurance, HealthPartner, HealthResources, HearingImpairment, Heart, HeartBeat, HomeNursing, Hospital, HospitalTreatment, Housekeeping, HygieneArmBend, HygieneDisinfection, HygieneMask, Insurance, InsuranceEu, IntegratedCare, JobOffer, Jolinchen, Law, Lebensbaum, LegalDatabase, Lift, LightBulb, LivingRoom, Location, LungsBreathSystem, Magazin, Management, Map, MaternityBenefit, MedialOffers, MedicineCare, Medicines, MeetingRoom, Megaphone, Metabolism, Microphone, Midwife, Mind, Monitor, Moon, NetworkConnections, Newsletter, Newspaper, NumberThree, Nurse, Nutrition, Office, OfficeOnline, OnlineCourse, OptionalRates, Osteopathy, Parking, Persiod, PersonalCounselling, PersonalScale, Pharmacy, Phone, PhoneArrow, PhoneSpeechBubble, PhoneWlan, Physiotherapy, Piggybank, Podcast, PosterOutdoorAdvertising, Pregnancy, Provision, Pupils, Rates, Recycling, Refund, Rehab, Remedies, RetirementProvision, RocketProgress, Run, Sad, Search, SearchDoctor, SearchServiceProvider, SecondOpinion, SelfHelpPromotion, Selfservice, Seminar, SeminarOnline, SickNote, SickPay, SignLanguage, Signpost, SkinIrritations, Smartphone, SocialHealth, SocialWorkHealth, SpeechBubble, SpeechBubbleDots, SpeechBubbleExclamation, SpeechBubbleQuestion, SpeechBubbleText, SpeechBubbles, Speedometer, Sport, Staircase, Star, Student, Sun, SupplementaryInsurance, Sustainability, Synapses, Thoughts, ToothCleaning, TransportSubsidy, Travel, TravelExpenses, Treatment, TreatmentEu, TreatmentForeignCountries, Trophy, Umbrella, UnemploymentInsurance, Upload, UploadFolder, UserAccount, Vaccination, Video, VisualImpairment, Volume, WaitingRoom, Wallet, Wc, WcLadies, WcMen, Weather, WellBeing, WheelchairUser, Wind, WorkLiveBalance, World, Yoga, Icon as default };
